(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[630],{

/***/ 4937:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Q": function() { return /* binding */ registerComponents; }
});

// NAMESPACE OBJECT: ./components/book-a-demo/roomstay-blog-book-a-demo.builder-component.ts
var roomstay_blog_book_a_demo_builder_component_namespaceObject = {};
__webpack_require__.r(roomstay_blog_book_a_demo_builder_component_namespaceObject);
__webpack_require__.d(roomstay_blog_book_a_demo_builder_component_namespaceObject, {
  "RoomstayBlogBookADemoConfig": function() { return RoomstayBlogBookADemoConfig; },
  "default": function() { return roomstay_blog_book_a_demo_builder_component; }
});

// NAMESPACE OBJECT: ./components/ButtonBookADemo/roomstay-blog-button-custom.builder-component.ts
var roomstay_blog_button_custom_builder_component_namespaceObject = {};
__webpack_require__.r(roomstay_blog_button_custom_builder_component_namespaceObject);
__webpack_require__.d(roomstay_blog_button_custom_builder_component_namespaceObject, {
  "RoomstayBlogButtonCustomConfig": function() { return RoomstayBlogButtonCustomConfig; },
  "default": function() { return roomstay_blog_button_custom_builder_component; }
});

// NAMESPACE OBJECT: ./components/roomstay-blog-about-hero/roomstay-blog-about-hero.builder-component.ts
var roomstay_blog_about_hero_builder_component_namespaceObject = {};
__webpack_require__.r(roomstay_blog_about_hero_builder_component_namespaceObject);
__webpack_require__.d(roomstay_blog_about_hero_builder_component_namespaceObject, {
  "RoomstayBlogAboutHeroBuilderConfig": function() { return RoomstayBlogAboutHeroBuilderConfig; },
  "default": function() { return roomstay_blog_about_hero_builder_component; }
});

// NAMESPACE OBJECT: ./components/roomstay-blog-article-card/roomstay-blog-article-card.builder-component.ts
var roomstay_blog_article_card_builder_component_namespaceObject = {};
__webpack_require__.r(roomstay_blog_article_card_builder_component_namespaceObject);
__webpack_require__.d(roomstay_blog_article_card_builder_component_namespaceObject, {
  "RoomstayBlogArticleCardBuilderConfig": function() { return RoomstayBlogArticleCardBuilderConfig; },
  "default": function() { return roomstay_blog_article_card_builder_component; }
});

// NAMESPACE OBJECT: ./components/roomstay-blog-article-text-list/roomstay-blog-article-text-list.builder-component.ts
var roomstay_blog_article_text_list_builder_component_namespaceObject = {};
__webpack_require__.r(roomstay_blog_article_text_list_builder_component_namespaceObject);
__webpack_require__.d(roomstay_blog_article_text_list_builder_component_namespaceObject, {
  "RoomstayBlogArticleTextListBuilderConfig": function() { return RoomstayBlogArticleTextListBuilderConfig; },
  "default": function() { return roomstay_blog_article_text_list_builder_component; }
});

// NAMESPACE OBJECT: ./components/roomstay-blog-book-demo-form/roomstay-blog-book-demo-form.builder-component.ts
var roomstay_blog_book_demo_form_builder_component_namespaceObject = {};
__webpack_require__.r(roomstay_blog_book_demo_form_builder_component_namespaceObject);
__webpack_require__.d(roomstay_blog_book_demo_form_builder_component_namespaceObject, {
  "config": function() { return config; },
  "default": function() { return roomstay_blog_book_demo_form_builder_component; }
});

// NAMESPACE OBJECT: ./components/roomstay-blog-button/roomstay-blog-button.builder-component.ts
var roomstay_blog_button_builder_component_namespaceObject = {};
__webpack_require__.r(roomstay_blog_button_builder_component_namespaceObject);
__webpack_require__.d(roomstay_blog_button_builder_component_namespaceObject, {
  "RoomstayBlogButtonBuilderConfig": function() { return RoomstayBlogButtonBuilderConfig; },
  "default": function() { return roomstay_blog_button_builder_component; }
});

// NAMESPACE OBJECT: ./components/roomstay-blog-card-pricing/roomstay-blog-card-pricing.builder-component.ts
var roomstay_blog_card_pricing_builder_component_namespaceObject = {};
__webpack_require__.r(roomstay_blog_card_pricing_builder_component_namespaceObject);
__webpack_require__.d(roomstay_blog_card_pricing_builder_component_namespaceObject, {
  "RoomStayBlogCardPricingBuilderConfig": function() { return RoomStayBlogCardPricingBuilderConfig; },
  "default": function() { return roomstay_blog_card_pricing_builder_component; }
});

// NAMESPACE OBJECT: ./components/roomstay-blog-clipped-section/roomstay-blog-clipped-section.builder-component.ts
var roomstay_blog_clipped_section_builder_component_namespaceObject = {};
__webpack_require__.r(roomstay_blog_clipped_section_builder_component_namespaceObject);
__webpack_require__.d(roomstay_blog_clipped_section_builder_component_namespaceObject, {
  "RoomstayBlogClippedSectionBuilderConfig": function() { return RoomstayBlogClippedSectionBuilderConfig; },
  "default": function() { return roomstay_blog_clipped_section_builder_component; }
});

// NAMESPACE OBJECT: ./components/roomstay-blog-customer-case-accordion-2/roomstay-blog-customer-case-accordion-2.builder-component.ts
var roomstay_blog_customer_case_accordion_2_builder_component_namespaceObject = {};
__webpack_require__.r(roomstay_blog_customer_case_accordion_2_builder_component_namespaceObject);
__webpack_require__.d(roomstay_blog_customer_case_accordion_2_builder_component_namespaceObject, {
  "RoomStayBlogCustomerAccordion2BuilderConfig": function() { return RoomStayBlogCustomerAccordion2BuilderConfig; },
  "default": function() { return roomstay_blog_customer_case_accordion_2_builder_component; }
});

// NAMESPACE OBJECT: ./components/roomstay-blog-customer-case-accordion/roomstay-blog-customer-case-accordion.builder-component.ts
var roomstay_blog_customer_case_accordion_builder_component_namespaceObject = {};
__webpack_require__.r(roomstay_blog_customer_case_accordion_builder_component_namespaceObject);
__webpack_require__.d(roomstay_blog_customer_case_accordion_builder_component_namespaceObject, {
  "RoomStayBlogCustomerAccordionBuilderConfig": function() { return RoomStayBlogCustomerAccordionBuilderConfig; },
  "default": function() { return roomstay_blog_customer_case_accordion_builder_component; }
});

// NAMESPACE OBJECT: ./components/roomstay-blog-customer-case-block/roomstay-blog-customer-case-block.builder-component.ts
var roomstay_blog_customer_case_block_builder_component_namespaceObject = {};
__webpack_require__.r(roomstay_blog_customer_case_block_builder_component_namespaceObject);
__webpack_require__.d(roomstay_blog_customer_case_block_builder_component_namespaceObject, {
  "RoomStayBlogCustomerCaseBlockBuilderConfig": function() { return RoomStayBlogCustomerCaseBlockBuilderConfig; },
  "default": function() { return roomstay_blog_customer_case_block_builder_component; }
});

// NAMESPACE OBJECT: ./components/roomstay-blog-customer-case-hero/roomstay-blog-customer-case-hero.builder-component.ts
var roomstay_blog_customer_case_hero_builder_component_namespaceObject = {};
__webpack_require__.r(roomstay_blog_customer_case_hero_builder_component_namespaceObject);
__webpack_require__.d(roomstay_blog_customer_case_hero_builder_component_namespaceObject, {
  "RoomStayBlogCustomerCaseBuilderConfig": function() { return RoomStayBlogCustomerCaseBuilderConfig; },
  "default": function() { return roomstay_blog_customer_case_hero_builder_component; }
});

// NAMESPACE OBJECT: ./components/roomstay-blog-customer-case-image/roomstay-blog-customer-case-image.builder-component.ts
var roomstay_blog_customer_case_image_builder_component_namespaceObject = {};
__webpack_require__.r(roomstay_blog_customer_case_image_builder_component_namespaceObject);
__webpack_require__.d(roomstay_blog_customer_case_image_builder_component_namespaceObject, {
  "RoomStayBlogCustomerCaseImageBuilderConfig": function() { return RoomStayBlogCustomerCaseImageBuilderConfig; },
  "default": function() { return roomstay_blog_customer_case_image_builder_component; }
});

// NAMESPACE OBJECT: ./components/roomstay-blog-customer-case-list-card-2/roomstay-blog-customer-case-list-card-2.builder-component.ts
var roomstay_blog_customer_case_list_card_2_builder_component_namespaceObject = {};
__webpack_require__.r(roomstay_blog_customer_case_list_card_2_builder_component_namespaceObject);
__webpack_require__.d(roomstay_blog_customer_case_list_card_2_builder_component_namespaceObject, {
  "RoomStayBlogCustomerCaseListCard2BuilderConfig": function() { return RoomStayBlogCustomerCaseListCard2BuilderConfig; },
  "default": function() { return roomstay_blog_customer_case_list_card_2_builder_component; }
});

// NAMESPACE OBJECT: ./components/roomstay-blog-customer-case-list-card/roomstay-blog-customer-case-list-card.builder-component.ts
var roomstay_blog_customer_case_list_card_builder_component_namespaceObject = {};
__webpack_require__.r(roomstay_blog_customer_case_list_card_builder_component_namespaceObject);
__webpack_require__.d(roomstay_blog_customer_case_list_card_builder_component_namespaceObject, {
  "RoomStayBlogCustomerCaseListCardBuilderConfig": function() { return RoomStayBlogCustomerCaseListCardBuilderConfig; },
  "default": function() { return roomstay_blog_customer_case_list_card_builder_component; }
});

// NAMESPACE OBJECT: ./components/roomstay-blog-fade-up/roomstay-blog-fade-up.builder-component.ts
var roomstay_blog_fade_up_builder_component_namespaceObject = {};
__webpack_require__.r(roomstay_blog_fade_up_builder_component_namespaceObject);
__webpack_require__.d(roomstay_blog_fade_up_builder_component_namespaceObject, {
  "RoomstayBlogFadeUpBuilderConfig": function() { return RoomstayBlogFadeUpBuilderConfig; },
  "default": function() { return roomstay_blog_fade_up_builder_component; }
});

// NAMESPACE OBJECT: ./components/roomstay-blog-featured-card/roomstay-blog-featured-card.builder-component.ts
var roomstay_blog_featured_card_builder_component_namespaceObject = {};
__webpack_require__.r(roomstay_blog_featured_card_builder_component_namespaceObject);
__webpack_require__.d(roomstay_blog_featured_card_builder_component_namespaceObject, {
  "RoomstayBlogFeaturedCardBuilderConfig": function() { return RoomstayBlogFeaturedCardBuilderConfig; },
  "default": function() { return roomstay_blog_featured_card_builder_component; }
});

// NAMESPACE OBJECT: ./components/roomstay-blog-footer-layout-2/roomstay-blog-footer-layout-2.builder-component.ts
var roomstay_blog_footer_layout_2_builder_component_namespaceObject = {};
__webpack_require__.r(roomstay_blog_footer_layout_2_builder_component_namespaceObject);
__webpack_require__.d(roomstay_blog_footer_layout_2_builder_component_namespaceObject, {
  "RoomstayBlogFooterLayout2BuilderConfig": function() { return RoomstayBlogFooterLayout2BuilderConfig; },
  "default": function() { return roomstay_blog_footer_layout_2_builder_component; }
});

// NAMESPACE OBJECT: ./components/roomstay-blog-footer-layout-form/roomstay-blog-footer-layout-form.builder-component.ts
var roomstay_blog_footer_layout_form_builder_component_namespaceObject = {};
__webpack_require__.r(roomstay_blog_footer_layout_form_builder_component_namespaceObject);
__webpack_require__.d(roomstay_blog_footer_layout_form_builder_component_namespaceObject, {
  "RoomstayBlogFooterLayoutFormBuilderConfig": function() { return RoomstayBlogFooterLayoutFormBuilderConfig; },
  "default": function() { return roomstay_blog_footer_layout_form_builder_component; }
});

// NAMESPACE OBJECT: ./components/roomstay-blog-hero-pricing/roomstay-blog-hero-pricing.builder-component.ts
var roomstay_blog_hero_pricing_builder_component_namespaceObject = {};
__webpack_require__.r(roomstay_blog_hero_pricing_builder_component_namespaceObject);
__webpack_require__.d(roomstay_blog_hero_pricing_builder_component_namespaceObject, {
  "RoomstayBlogHeroPricingBuilderConfig": function() { return RoomstayBlogHeroPricingBuilderConfig; },
  "default": function() { return roomstay_blog_hero_pricing_builder_component; }
});

// NAMESPACE OBJECT: ./components/roomstay-blog-hero-product/roomstay-blog-hero-product.builder-component.ts
var roomstay_blog_hero_product_builder_component_namespaceObject = {};
__webpack_require__.r(roomstay_blog_hero_product_builder_component_namespaceObject);
__webpack_require__.d(roomstay_blog_hero_product_builder_component_namespaceObject, {
  "RoomStayBlogHeroProductBuilderConfig": function() { return RoomStayBlogHeroProductBuilderConfig; },
  "default": function() { return roomstay_blog_hero_product_builder_component; }
});

// NAMESPACE OBJECT: ./components/roomstay-blog-home-headline/roomstay-blog-home-headline.builder-component.ts
var roomstay_blog_home_headline_builder_component_namespaceObject = {};
__webpack_require__.r(roomstay_blog_home_headline_builder_component_namespaceObject);
__webpack_require__.d(roomstay_blog_home_headline_builder_component_namespaceObject, {
  "RoomstayBlogHomeHeadlineBuilderConfig": function() { return RoomstayBlogHomeHeadlineBuilderConfig; },
  "default": function() { return roomstay_blog_home_headline_builder_component; }
});

// NAMESPACE OBJECT: ./components/roomstay-blog-home-hero/roomstay-blog-home-hero.builder-component.ts
var roomstay_blog_home_hero_builder_component_namespaceObject = {};
__webpack_require__.r(roomstay_blog_home_hero_builder_component_namespaceObject);
__webpack_require__.d(roomstay_blog_home_hero_builder_component_namespaceObject, {
  "RoomstayBlogHomeHeroBuilderConfig": function() { return RoomstayBlogHomeHeroBuilderConfig; },
  "default": function() { return roomstay_blog_home_hero_builder_component; }
});

// NAMESPACE OBJECT: ./components/roomstay-blog-home-image-block/roomstay-blog-home-image-block.builder-component.ts
var roomstay_blog_home_image_block_builder_component_namespaceObject = {};
__webpack_require__.r(roomstay_blog_home_image_block_builder_component_namespaceObject);
__webpack_require__.d(roomstay_blog_home_image_block_builder_component_namespaceObject, {
  "RoomstayBlogHomeImageBlockBuilderConfig": function() { return RoomstayBlogHomeImageBlockBuilderConfig; },
  "default": function() { return roomstay_blog_home_image_block_builder_component; }
});

// NAMESPACE OBJECT: ./components/roomstay-blog-home-introduction/roomstay-blog-home-introduction.builder-component.ts
var roomstay_blog_home_introduction_builder_component_namespaceObject = {};
__webpack_require__.r(roomstay_blog_home_introduction_builder_component_namespaceObject);
__webpack_require__.d(roomstay_blog_home_introduction_builder_component_namespaceObject, {
  "RoomstayBlogIntroductionBuilderConfig": function() { return RoomstayBlogIntroductionBuilderConfig; },
  "default": function() { return roomstay_blog_home_introduction_builder_component; }
});

// NAMESPACE OBJECT: ./components/roomstay-blog-home-youtube/roomstay-blog-home-youtube.builder-component.ts
var roomstay_blog_home_youtube_builder_component_namespaceObject = {};
__webpack_require__.r(roomstay_blog_home_youtube_builder_component_namespaceObject);
__webpack_require__.d(roomstay_blog_home_youtube_builder_component_namespaceObject, {
  "RoomstayBlogHomeYoutubeBuilderConfig": function() { return RoomstayBlogHomeYoutubeBuilderConfig; },
  "default": function() { return roomstay_blog_home_youtube_builder_component; }
});

// NAMESPACE OBJECT: ./components/roomstay-blog-hotel-brand-carousel/roomstay-blog-image-block.builder-component.ts
var roomstay_blog_image_block_builder_component_namespaceObject = {};
__webpack_require__.r(roomstay_blog_image_block_builder_component_namespaceObject);
__webpack_require__.d(roomstay_blog_image_block_builder_component_namespaceObject, {
  "config": function() { return roomstay_blog_image_block_builder_component_config; },
  "default": function() { return roomstay_blog_image_block_builder_component; }
});

// NAMESPACE OBJECT: ./components/roomstay-blog-image-block/roomstay-blog-image-block.builder-component.ts
var roomstay_blog_image_block_roomstay_blog_image_block_builder_component_namespaceObject = {};
__webpack_require__.r(roomstay_blog_image_block_roomstay_blog_image_block_builder_component_namespaceObject);
__webpack_require__.d(roomstay_blog_image_block_roomstay_blog_image_block_builder_component_namespaceObject, {
  "config": function() { return roomstay_blog_image_block_roomstay_blog_image_block_builder_component_config; },
  "default": function() { return roomstay_blog_image_block_roomstay_blog_image_block_builder_component; }
});

// NAMESPACE OBJECT: ./components/roomstay-blog-image-grid/roomstay-blog-image-grid.builder-component.ts
var roomstay_blog_image_grid_builder_component_namespaceObject = {};
__webpack_require__.r(roomstay_blog_image_grid_builder_component_namespaceObject);
__webpack_require__.d(roomstay_blog_image_grid_builder_component_namespaceObject, {
  "RoomstayBlogImageGridBuilderConfig": function() { return RoomstayBlogImageGridBuilderConfig; },
  "default": function() { return roomstay_blog_image_grid_builder_component; }
});

// NAMESPACE OBJECT: ./components/roomstay-blog-img-clipped/roomstay-blog-use-case-img-clipped.builder-component.ts
var roomstay_blog_use_case_img_clipped_builder_component_namespaceObject = {};
__webpack_require__.r(roomstay_blog_use_case_img_clipped_builder_component_namespaceObject);
__webpack_require__.d(roomstay_blog_use_case_img_clipped_builder_component_namespaceObject, {
  "RoomstayBlogClippedBackgroundBuilderConfig": function() { return RoomstayBlogClippedBackgroundBuilderConfig; },
  "default": function() { return roomstay_blog_use_case_img_clipped_builder_component; }
});

// NAMESPACE OBJECT: ./components/roomstay-blog-increase/roomstay-blog-increase.builder-component.ts
var roomstay_blog_increase_builder_component_namespaceObject = {};
__webpack_require__.r(roomstay_blog_increase_builder_component_namespaceObject);
__webpack_require__.d(roomstay_blog_increase_builder_component_namespaceObject, {
  "RoomstayBlogImageGridBuilderConfig": function() { return roomstay_blog_increase_builder_component_RoomstayBlogImageGridBuilderConfig; },
  "default": function() { return roomstay_blog_increase_builder_component; }
});

// NAMESPACE OBJECT: ./components/roomstay-blog-integrations/roomstay-blog-integrations.builder-component.ts
var roomstay_blog_integrations_builder_component_namespaceObject = {};
__webpack_require__.r(roomstay_blog_integrations_builder_component_namespaceObject);
__webpack_require__.d(roomstay_blog_integrations_builder_component_namespaceObject, {
  "RoomstayBlogIntegrationsBuilderConfig": function() { return RoomstayBlogIntegrationsBuilderConfig; },
  "default": function() { return roomstay_blog_integrations_builder_component; }
});

// NAMESPACE OBJECT: ./components/roomstay-blog-intro-rev-par/roomstay-blog-intro-revpar.builder-component.ts
var roomstay_blog_intro_revpar_builder_component_namespaceObject = {};
__webpack_require__.r(roomstay_blog_intro_revpar_builder_component_namespaceObject);
__webpack_require__.d(roomstay_blog_intro_revpar_builder_component_namespaceObject, {
  "RoomstayBlogIntroRevParBuilderConfig": function() { return RoomstayBlogIntroRevParBuilderConfig; },
  "default": function() { return roomstay_blog_intro_revpar_builder_component; }
});

// NAMESPACE OBJECT: ./components/roomstay-blog-list-card/roomstay-blog-list-card.builder-component.ts
var roomstay_blog_list_card_builder_component_namespaceObject = {};
__webpack_require__.r(roomstay_blog_list_card_builder_component_namespaceObject);
__webpack_require__.d(roomstay_blog_list_card_builder_component_namespaceObject, {
  "RoomstayBlogListCardBuilderConfig": function() { return RoomstayBlogListCardBuilderConfig; },
  "default": function() { return roomstay_blog_list_card_builder_component; }
});

// NAMESPACE OBJECT: ./components/roomstay-blog-our-promise/roomstay-blog-our-promise.builder-component.ts
var roomstay_blog_our_promise_builder_component_namespaceObject = {};
__webpack_require__.r(roomstay_blog_our_promise_builder_component_namespaceObject);
__webpack_require__.d(roomstay_blog_our_promise_builder_component_namespaceObject, {
  "RoomstayBlogOurPromiseBuilderConfig": function() { return RoomstayBlogOurPromiseBuilderConfig; },
  "default": function() { return roomstay_blog_our_promise_builder_component; }
});

// NAMESPACE OBJECT: ./components/roomstay-blog-product-hero/roomstay-blog-product-hero.builder-component.ts
var roomstay_blog_product_hero_builder_component_namespaceObject = {};
__webpack_require__.r(roomstay_blog_product_hero_builder_component_namespaceObject);
__webpack_require__.d(roomstay_blog_product_hero_builder_component_namespaceObject, {
  "RoomstayBlogProductsHeroBuilderConfig": function() { return RoomstayBlogProductsHeroBuilderConfig; },
  "default": function() { return roomstay_blog_product_hero_builder_component; }
});

// NAMESPACE OBJECT: ./components/roomstay-blog-product-theme/roomstay-blog-product-theme.builder-component.ts
var roomstay_blog_product_theme_builder_component_namespaceObject = {};
__webpack_require__.r(roomstay_blog_product_theme_builder_component_namespaceObject);
__webpack_require__.d(roomstay_blog_product_theme_builder_component_namespaceObject, {
  "RoomstayBlogProductThemeBuilderConfig": function() { return RoomstayBlogProductThemeBuilderConfig; },
  "default": function() { return roomstay_blog_product_theme_builder_component; }
});

// NAMESPACE OBJECT: ./components/roomstay-blog-products-card/roomstay-blog-product-card.builder-component.ts
var roomstay_blog_product_card_builder_component_namespaceObject = {};
__webpack_require__.r(roomstay_blog_product_card_builder_component_namespaceObject);
__webpack_require__.d(roomstay_blog_product_card_builder_component_namespaceObject, {
  "RoomstayBlogProductCardBuilderConfig": function() { return RoomstayBlogProductCardBuilderConfig; },
  "default": function() { return roomstay_blog_product_card_builder_component; }
});

// NAMESPACE OBJECT: ./components/roomstay-blog-quote/roomstay-blog-quote.builder-component.ts
var roomstay_blog_quote_builder_component_namespaceObject = {};
__webpack_require__.r(roomstay_blog_quote_builder_component_namespaceObject);
__webpack_require__.d(roomstay_blog_quote_builder_component_namespaceObject, {
  "RoomstayBlogQuoteBuilderConfig": function() { return RoomstayBlogQuoteBuilderConfig; },
  "default": function() { return roomstay_blog_quote_builder_component; }
});

// NAMESPACE OBJECT: ./components/roomstay-blog-revpar/roomtay-blog-revpar.builder-component.ts
var roomtay_blog_revpar_builder_component_namespaceObject = {};
__webpack_require__.r(roomtay_blog_revpar_builder_component_namespaceObject);
__webpack_require__.d(roomtay_blog_revpar_builder_component_namespaceObject, {
  "RoomstayBlogProductThemeBuilderConfig": function() { return roomtay_blog_revpar_builder_component_RoomstayBlogProductThemeBuilderConfig; },
  "default": function() { return roomtay_blog_revpar_builder_component; }
});

// NAMESPACE OBJECT: ./components/roomstay-blog-sem-helpdesk-form/roomstay-blog-sem-helpdesk-form.builder-component.ts
var roomstay_blog_sem_helpdesk_form_builder_component_namespaceObject = {};
__webpack_require__.r(roomstay_blog_sem_helpdesk_form_builder_component_namespaceObject);
__webpack_require__.d(roomstay_blog_sem_helpdesk_form_builder_component_namespaceObject, {
  "config": function() { return roomstay_blog_sem_helpdesk_form_builder_component_config; },
  "default": function() { return roomstay_blog_sem_helpdesk_form_builder_component; }
});

// NAMESPACE OBJECT: ./components/roomstay-blog-sem-hero/roomstay-blog-sem-hero.builder-component.ts
var roomstay_blog_sem_hero_builder_component_namespaceObject = {};
__webpack_require__.r(roomstay_blog_sem_hero_builder_component_namespaceObject);
__webpack_require__.d(roomstay_blog_sem_hero_builder_component_namespaceObject, {
  "RoomstayBlogQuoteBuilderConfig": function() { return roomstay_blog_sem_hero_builder_component_RoomstayBlogQuoteBuilderConfig; },
  "default": function() { return roomstay_blog_sem_hero_builder_component; }
});

// NAMESPACE OBJECT: ./components/roomstay-blog-sem-list-solutions/roomstay-blog-sem-list-solution.builder-component.ts
var roomstay_blog_sem_list_solution_builder_component_namespaceObject = {};
__webpack_require__.r(roomstay_blog_sem_list_solution_builder_component_namespaceObject);
__webpack_require__.d(roomstay_blog_sem_list_solution_builder_component_namespaceObject, {
  "RoomstayBlogOurPromiseBuilderConfig": function() { return roomstay_blog_sem_list_solution_builder_component_RoomstayBlogOurPromiseBuilderConfig; },
  "default": function() { return roomstay_blog_sem_list_solution_builder_component; }
});

// NAMESPACE OBJECT: ./components/roomstay-blog-sem-list/roomstay-blog-sem-list.builder-component.ts
var roomstay_blog_sem_list_builder_component_namespaceObject = {};
__webpack_require__.r(roomstay_blog_sem_list_builder_component_namespaceObject);
__webpack_require__.d(roomstay_blog_sem_list_builder_component_namespaceObject, {
  "RoomstayBlogQuoteBuilderConfig": function() { return roomstay_blog_sem_list_builder_component_RoomstayBlogQuoteBuilderConfig; },
  "default": function() { return roomstay_blog_sem_list_builder_component; }
});

// NAMESPACE OBJECT: ./components/roomstay-blog-sem-theme/roomstay-blog-sem-theme.builder-component.ts
var roomstay_blog_sem_theme_builder_component_namespaceObject = {};
__webpack_require__.r(roomstay_blog_sem_theme_builder_component_namespaceObject);
__webpack_require__.d(roomstay_blog_sem_theme_builder_component_namespaceObject, {
  "RoomstayBlogProductThemeBuilderConfig": function() { return roomstay_blog_sem_theme_builder_component_RoomstayBlogProductThemeBuilderConfig; },
  "default": function() { return roomstay_blog_sem_theme_builder_component; }
});

// NAMESPACE OBJECT: ./components/roomstay-blog-summing-up/roomstay-blog-summing-up.builder-component.ts
var roomstay_blog_summing_up_builder_component_namespaceObject = {};
__webpack_require__.r(roomstay_blog_summing_up_builder_component_namespaceObject);
__webpack_require__.d(roomstay_blog_summing_up_builder_component_namespaceObject, {
  "RoomstayBlogSummingUpBuilderConfig": function() { return RoomstayBlogSummingUpBuilderConfig; },
  "default": function() { return roomstay_blog_summing_up_builder_component; }
});

// NAMESPACE OBJECT: ./components/roomstay-blog-text-booking/roomstay-blog-text-booking.builder-component.ts
var roomstay_blog_text_booking_builder_component_namespaceObject = {};
__webpack_require__.r(roomstay_blog_text_booking_builder_component_namespaceObject);
__webpack_require__.d(roomstay_blog_text_booking_builder_component_namespaceObject, {
  "RoomStayBlogTextBookingBuilderConfig": function() { return RoomStayBlogTextBookingBuilderConfig; },
  "default": function() { return roomstay_blog_text_booking_builder_component; }
});

// NAMESPACE OBJECT: ./components/roomstay-blog-text-caption/roomstay-blog-text-caption.builder-component.ts
var roomstay_blog_text_caption_builder_component_namespaceObject = {};
__webpack_require__.r(roomstay_blog_text_caption_builder_component_namespaceObject);
__webpack_require__.d(roomstay_blog_text_caption_builder_component_namespaceObject, {
  "RoomstayBlogTextCaptionBuilderConfig": function() { return RoomstayBlogTextCaptionBuilderConfig; },
  "default": function() { return roomstay_blog_text_caption_builder_component; }
});

// NAMESPACE OBJECT: ./components/roomstay-blog-text-footer/roomstay-blog-text-footer.builder-component.ts
var roomstay_blog_text_footer_builder_component_namespaceObject = {};
__webpack_require__.r(roomstay_blog_text_footer_builder_component_namespaceObject);
__webpack_require__.d(roomstay_blog_text_footer_builder_component_namespaceObject, {
  "RoomStayBlogTextFooterBuilderConfig": function() { return RoomStayBlogTextFooterBuilderConfig; },
  "default": function() { return roomstay_blog_text_footer_builder_component; }
});

// NAMESPACE OBJECT: ./components/roomstay-blog-text-intro-user/roomstay-blog-text-intro-user.builder-component.ts
var roomstay_blog_text_intro_user_builder_component_namespaceObject = {};
__webpack_require__.r(roomstay_blog_text_intro_user_builder_component_namespaceObject);
__webpack_require__.d(roomstay_blog_text_intro_user_builder_component_namespaceObject, {
  "RoomStayBlogTextIntroUserBuilderConfig": function() { return RoomStayBlogTextIntroUserBuilderConfig; },
  "default": function() { return roomstay_blog_text_intro_user_builder_component; }
});

// NAMESPACE OBJECT: ./components/roomstay-blog-text-synxis-booking/roomstay-blog-text-synxis-booking.builder-component.ts
var roomstay_blog_text_synxis_booking_builder_component_namespaceObject = {};
__webpack_require__.r(roomstay_blog_text_synxis_booking_builder_component_namespaceObject);
__webpack_require__.d(roomstay_blog_text_synxis_booking_builder_component_namespaceObject, {
  "RoomStayBlogTextSynXisBookingBuilderConfig": function() { return RoomStayBlogTextSynXisBookingBuilderConfig; },
  "default": function() { return roomstay_blog_text_synxis_booking_builder_component; }
});

// NAMESPACE OBJECT: ./components/roomstay-blog-text-wrap/roomstay-blog-text-wrap.builder-component.ts
var roomstay_blog_text_wrap_builder_component_namespaceObject = {};
__webpack_require__.r(roomstay_blog_text_wrap_builder_component_namespaceObject);
__webpack_require__.d(roomstay_blog_text_wrap_builder_component_namespaceObject, {
  "config": function() { return roomstay_blog_text_wrap_builder_component_config; },
  "default": function() { return roomstay_blog_text_wrap_builder_component; }
});

// NAMESPACE OBJECT: ./components/roomstay-blog-use-case-hero/roomstay-blog-use-case-hero.builder-component.ts
var roomstay_blog_use_case_hero_builder_component_namespaceObject = {};
__webpack_require__.r(roomstay_blog_use_case_hero_builder_component_namespaceObject);
__webpack_require__.d(roomstay_blog_use_case_hero_builder_component_namespaceObject, {
  "RoomstayBlogHeroUseCasesBuilderConfig": function() { return RoomstayBlogHeroUseCasesBuilderConfig; },
  "default": function() { return roomstay_blog_use_case_hero_builder_component; }
});

// NAMESPACE OBJECT: ./components/roomstay-integration-module/roomstay-integration-module.builder-component.ts
var roomstay_integration_module_builder_component_namespaceObject = {};
__webpack_require__.r(roomstay_integration_module_builder_component_namespaceObject);
__webpack_require__.d(roomstay_integration_module_builder_component_namespaceObject, {
  "config": function() { return roomstay_integration_module_builder_component_config; },
  "default": function() { return roomstay_integration_module_builder_component; }
});

// NAMESPACE OBJECT: ./components/roomstay-members/roomstay-members.builder-component.ts
var roomstay_members_builder_component_namespaceObject = {};
__webpack_require__.r(roomstay_members_builder_component_namespaceObject);
__webpack_require__.d(roomstay_members_builder_component_namespaceObject, {
  "RoomstayMemberBuilderConfig": function() { return RoomstayMemberBuilderConfig; },
  "default": function() { return roomstay_members_builder_component; }
});

// NAMESPACE OBJECT: ./components/roomstay-stats/roomstay-stats.builder-component.ts
var roomstay_stats_builder_component_namespaceObject = {};
__webpack_require__.r(roomstay_stats_builder_component_namespaceObject);
__webpack_require__.d(roomstay_stats_builder_component_namespaceObject, {
  "RoomstayStatsBuilderConfig": function() { return RoomstayStatsBuilderConfig; },
  "default": function() { return roomstay_stats_builder_component; }
});

// NAMESPACE OBJECT: ./components/roonstay-blog-helpdesk-form/roomstay-blog-helpdesk-form.builder-component.ts
var roomstay_blog_helpdesk_form_builder_component_namespaceObject = {};
__webpack_require__.r(roomstay_blog_helpdesk_form_builder_component_namespaceObject);
__webpack_require__.d(roomstay_blog_helpdesk_form_builder_component_namespaceObject, {
  "config": function() { return roomstay_blog_helpdesk_form_builder_component_config; },
  "default": function() { return roomstay_blog_helpdesk_form_builder_component; }
});

// EXTERNAL MODULE: ./node_modules/@builder.io/sdk/dist/index.esm.js
var index_esm = __webpack_require__(1183);
// EXTERNAL MODULE: ./components/book-a-demo/index.tsx
var book_a_demo = __webpack_require__(4443);
;// CONCATENATED MODULE: ./components/book-a-demo/roomstay-blog-book-a-demo.builder-component.ts

var RoomstayBlogBookADemoConfig = {
    name: "Button Custom",
    inputs: [
        {
            name: "headline",
            type: "html"
        },
        {
            name: "subHeadline",
            type: "html"
        },
        {
            name: "buttonName",
            type: "string"
        },
        {
            name: "buttonLink",
            type: "string"
        }, 
    ]
};
var builderConfig = {
    component: book_a_demo/* default */.Z,
    config: RoomstayBlogBookADemoConfig
};
/* harmony default export */ var roomstay_blog_book_a_demo_builder_component = (builderConfig);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(4924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(315);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(5407);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(6779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/spinner/spinner.tsx
var spinner = __webpack_require__(9295);
// EXTERNAL MODULE: ./components/ButtonBookADemo/button.module.scss
var button_module = __webpack_require__(1756);
var button_module_default = /*#__PURE__*/__webpack_require__.n(button_module);
;// CONCATENATED MODULE: ./components/ButtonBookADemo/index.tsx









var ButtonBookADemo = function(props) {
    var children = props.children, link = props.link, className = props.className, _icon = props.icon, icon = _icon === void 0 ? true : _icon, buttonName = props.buttonName, loading = props.loading, hideShadow = props.hideShadow, onClick = props.onClick, _type = props.type, type = _type === void 0 ? "primary" : _type, _size = props.size, size = _size === void 0 ? "default" : _size, color = props.color, iconFillColor = props.iconFillColor, htmlType = props.htmlType, _border = props.border, border = _border === void 0 ? false : _border, theme = props.theme, sectionId = props.sectionId, buttonProps = (0,_object_without_properties/* default */.Z)(props, [
        "children",
        "link",
        "className",
        "icon",
        "buttonName",
        "loading",
        "hideShadow",
        "onClick",
        "type",
        "size",
        "color",
        "iconFillColor",
        "htmlType",
        "border",
        "theme",
        "sectionId"
    ]);
    var router = (0,next_router.useRouter)();
    var handleScrollElementById = function() {
        var element = document.getElementById(sectionId || "");
        if (sectionId === (element === null || element === void 0 ? void 0 : element.id)) {}
        if (element) {
            element.scrollIntoView({
                behavior: "smooth",
                inline: "center"
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, buttonProps), {
        disabled: loading,
        className: classnames_default()((button_module_default()).btn, (button_module_default())["btn-".concat(type)], (button_module_default())["btn-".concat(size)], (button_module_default())["btn-theme-".concat(theme)], (button_module_default())["btn-border-".concat(border)], (button_module_default())["btn-color-".concat(color)], className, (0,_define_property/* default */.Z)({}, (button_module_default()).shadowNone, hideShadow)),
        onClick: function(e) {
            if (link) {
                router.push(link);
            }
            if (sectionId) {
                handleScrollElementById();
            } else onClick === null || onClick === void 0 ? void 0 : onClick(e);
        },
        children: [
            icon && iconFillColor ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "33",
                height: "33",
                viewBox: "0 0 33 33",
                fill: "none",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M7.16663 16.2637H25.8333",
                        stroke: "white",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M16.5 6.93036L25.8333 16.2637L16.5 25.597",
                        stroke: "white",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "32",
                height: "33",
                viewBox: "0 0 32 33",
                fill: "none",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                        clipPath: "url(#clip0)",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M6.6665 16.5H25.3332",
                                stroke: "url(#paint0_linear_15517_1999)",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M16 7.1665L25.3333 16.4998L16 25.8332",
                                stroke: "url(#paint1_linear_15517_1999)",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                                id: "paint0_linear_15517_1999",
                                x1: "6.6665",
                                y1: "17.5",
                                x2: "6.77334",
                                y2: "15.5057",
                                gradientUnits: "userSpaceOnUse",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                        stopColor: "#7C39FF"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                        offset: "0.491191",
                                        stopColor: "#BC1DB5"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                        offset: "1",
                                        stopColor: "#FF0068"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                                id: "paint1_linear_15517_1999",
                                x1: "16",
                                y1: "25.8332",
                                x2: "30.9333",
                                y2: "18.3665",
                                gradientUnits: "userSpaceOnUse",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                        stopColor: "#7C39FF"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                        offset: "0.491191",
                                        stopColor: "#BC1DB5"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                        offset: "1",
                                        stopColor: "#FF0068"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(spinner/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: children || buttonName
            })
        ]
    }));
};
/* harmony default export */ var components_ButtonBookADemo = (ButtonBookADemo);

;// CONCATENATED MODULE: ./components/ButtonBookADemo/roomstay-blog-button-custom.builder-component.ts

var RoomstayBlogButtonCustomConfig = {
    name: "Button Custom",
    inputs: [
        {
            name: "buttonName",
            type: "string"
        },
        {
            name: "theme",
            type: "string",
            enum: [
                "transparent",
                "black",
                "purple"
            ]
        },
        {
            name: "sectionId",
            type: "string"
        },
        {
            name: "color",
            type: "string",
            enum: [
                "black",
                "white"
            ]
        },
        {
            name: "border",
            type: "string",
            enum: [
                "transparent",
                "color"
            ]
        },
        {
            name: "iconFillColor",
            type: "boolean"
        }, 
    ]
};
var roomstay_blog_button_custom_builder_component_builderConfig = {
    component: components_ButtonBookADemo,
    config: RoomstayBlogButtonCustomConfig
};
/* harmony default export */ var roomstay_blog_button_custom_builder_component = (roomstay_blog_button_custom_builder_component_builderConfig);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(253);
// EXTERNAL MODULE: ./components/lazy-load-image/index.tsx + 2 modules
var lazy_load_image = __webpack_require__(1618);
// EXTERNAL MODULE: ./components/roomstay-blog-about-hero/image-grid/image-grid.module.scss
var image_grid_module = __webpack_require__(3773);
var image_grid_module_default = /*#__PURE__*/__webpack_require__.n(image_grid_module);
;// CONCATENATED MODULE: ./components/roomstay-blog-about-hero/image-grid/image-grid.tsx




var ImageGrid = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var _images = props.images, images = _images === void 0 ? [] : _images;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (image_grid_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (image_grid_module_default()).content,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (image_grid_module_default()).col,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()((image_grid_module_default()).row, (image_grid_module_default())["row--1"]),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (image_grid_module_default()).wrapImg,
                                children: ((ref = images[0]) === null || ref === void 0 ? void 0 : ref.image) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(lazy_load_image/* LazyLoadImage */.e6, {
                                    imageUrl: (ref1 = images[0]) === null || ref1 === void 0 ? void 0 : ref1.image,
                                    alt: "",
                                    layout: "fill",
                                    objectFit: "cover"
                                }) : null
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classnames_default()((image_grid_module_default()).squares, "d-flex", "justify-content-end", "align-items-end"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: classnames_default()((image_grid_module_default()).squareContainer, (image_grid_module_default()).fillCyan, (image_grid_module_default()).mdHide)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: classnames_default()((image_grid_module_default()).squareContainer, (image_grid_module_default()).fillAztecPurple, (image_grid_module_default()).mdHide)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: classnames_default()((image_grid_module_default()).squareContainer, (image_grid_module_default()).fillWhite, (image_grid_module_default()).mdShow, (image_grid_module_default()).maxHeight50)
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()((image_grid_module_default()).row, (image_grid_module_default())["row--2"]),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (image_grid_module_default()).wrapImg,
                                children: ((ref2 = images[1]) === null || ref2 === void 0 ? void 0 : ref2.image) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(lazy_load_image/* LazyLoadImage */.e6, {
                                    imageUrl: (ref3 = images[1]) === null || ref3 === void 0 ? void 0 : ref3.image,
                                    alt: "",
                                    layout: "fill",
                                    objectFit: "cover"
                                }) : null
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (image_grid_module_default()).wrapImg,
                                children: ((ref4 = images[2]) === null || ref4 === void 0 ? void 0 : ref4.image) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(lazy_load_image/* LazyLoadImage */.e6, {
                                    imageUrl: (ref5 = images[2]) === null || ref5 === void 0 ? void 0 : ref5.image,
                                    alt: "",
                                    layout: "fill",
                                    objectFit: "cover"
                                }) : null
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()((image_grid_module_default()).row, (image_grid_module_default())["row--3"]),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classnames_default()((image_grid_module_default()).row, (image_grid_module_default())["row--3--1"]),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: classnames_default()((image_grid_module_default()).wrapImg),
                                        children: ((ref6 = images[3]) === null || ref6 === void 0 ? void 0 : ref6.image) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(lazy_load_image/* LazyLoadImage */.e6, {
                                            imageUrl: (ref7 = images[3]) === null || ref7 === void 0 ? void 0 : ref7.image,
                                            alt: "",
                                            layout: "fill",
                                            objectFit: "cover"
                                        }) : null
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: classnames_default()((image_grid_module_default()).squares, "d-flex", "justify-content-md-end", "justify-content-start", "align-items-start", "flex-column"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: classnames_default()((image_grid_module_default()).squareContainer, (image_grid_module_default()).fillCyan, (image_grid_module_default()).mdShow)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: classnames_default()((image_grid_module_default()).squareContainer, (image_grid_module_default()).fillAztecPurple, (image_grid_module_default()).mdShow)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: classnames_default()((image_grid_module_default()).squareContainer, (image_grid_module_default()).fillWhite, (image_grid_module_default()).mdHide)
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()((image_grid_module_default()).wrapImg, (image_grid_module_default()).mdHide),
                                children: ((ref8 = images[4]) === null || ref8 === void 0 ? void 0 : ref8.image) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(lazy_load_image/* LazyLoadImage */.e6, {
                                    imageUrl: (ref9 = images[4]) === null || ref9 === void 0 ? void 0 : ref9.image,
                                    alt: "",
                                    layout: "fill",
                                    objectFit: "cover"
                                }) : null
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var image_grid = (ImageGrid);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(2991);
// EXTERNAL MODULE: ./components/roomstay-blog-about-hero/text-intro/text-intro.module.scss
var text_intro_module = __webpack_require__(3839);
var text_intro_module_default = /*#__PURE__*/__webpack_require__.n(text_intro_module);
;// CONCATENATED MODULE: ./components/roomstay-blog-about-hero/text-intro/text-intro.tsx



var TextIntro = function(props, ref) {
    var title = props.title, description = props.description;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: ref,
        className: (text_intro_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: (text_intro_module_default()).title,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (text_intro_module_default()).description,
                children: description
            })
        ]
    });
};
/* harmony default export */ var text_intro = (/*#__PURE__*/(0,react.forwardRef)(TextIntro));

// EXTERNAL MODULE: ./node_modules/usehooks-ts/dist/esm/index.js + 36 modules
var esm = __webpack_require__(4660);
// EXTERNAL MODULE: ./components/roomstay-blog-image-block/clipped-box.tsx
var clipped_box = __webpack_require__(974);
// EXTERNAL MODULE: ./components/roomstay-blog-about-hero/roomstay-blog-about-hero.module.scss
var roomstay_blog_about_hero_module = __webpack_require__(5966);
var roomstay_blog_about_hero_module_default = /*#__PURE__*/__webpack_require__.n(roomstay_blog_about_hero_module);
;// CONCATENATED MODULE: ./components/roomstay-blog-about-hero/roomstay-blog-about-hero.tsx








var RoomstayBlogAboutHero = function(props) {
    var title = props.title, description = props.description, images = props.images;
    var ref = (0,_sliced_to_array/* default */.Z)((0,esm/* useElementSize */.h4)(), 2), containerRef = ref[0], height = ref[1].height;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,esm/* useElementSize */.h4)(), 2), introRef = ref1[0], ref2 = ref1[1], introHeight = ref2.height;
    var ref3 = (0,esm/* useWindowSize */.iP)(), windowWidth = ref3.width;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: containerRef,
        className: (roomstay_blog_about_hero_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(clipped_box/* default */.Z, {
                configs: [],
                className: (roomstay_blog_about_hero_module_default()).background,
                style: {
                    backgroundColor: "#ff0068",
                    maxHeight: "".concat(height / 2, "px")
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(clipped_box/* default */.Z, {
                configs: [
                    {
                        rad: Math.atan(515 / 1920),
                        position: clipped_box/* POSITION.BottomRight */.V.BottomRight
                    }, 
                ],
                className: classnames_default()((roomstay_blog_about_hero_module_default()).background, (roomstay_blog_about_hero_module_default()).backgroundClipped),
                style: {
                    backgroundColor: "#ff0068",
                    maxHeight: "".concat(windowWidth > 768 ? introHeight + 130 + 100 : introHeight + 77 + 60, "px"),
                    marginTop: "-2px"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(text_intro, {
                ref: introRef,
                title: title,
                description: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(image_grid, {
                images: images
            })
        ]
    });
};
/* harmony default export */ var roomstay_blog_about_hero = (RoomstayBlogAboutHero);

;// CONCATENATED MODULE: ./components/roomstay-blog-about-hero/roomstay-blog-about-hero.builder-component.ts

var RoomstayBlogAboutHeroBuilderConfig = {
    name: "About Hero",
    inputs: [
        {
            name: "title",
            type: "text"
        },
        {
            name: "description",
            type: "text"
        },
        {
            name: "images",
            type: "list",
            subFields: [
                {
                    name: "image",
                    type: "file"
                }, 
            ]
        }, 
    ]
};
var roomstay_blog_about_hero_builder_component_builderConfig = {
    component: roomstay_blog_about_hero,
    config: RoomstayBlogAboutHeroBuilderConfig
};
/* harmony default export */ var roomstay_blog_about_hero_builder_component = (roomstay_blog_about_hero_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/roomstay-blog-all-articles/roomstay-blog-all-articles.builder-component.ts
var roomstay_blog_all_articles_builder_component = __webpack_require__(1176);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(6899);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/button/index.tsx
var components_button = __webpack_require__(6811);
// EXTERNAL MODULE: ./components/lazy-load-image/lazy-load-image.tsx
var lazy_load_image_lazy_load_image = __webpack_require__(1087);
// EXTERNAL MODULE: ./components/roomstay-blog-article-card/article-card/article-card.module.scss
var article_card_module = __webpack_require__(6033);
var article_card_module_default = /*#__PURE__*/__webpack_require__.n(article_card_module);
;// CONCATENATED MODULE: ./components/roomstay-blog-article-card/article-card/article-card.tsx





var ArticleCard = function(props) {
    var image = props.image, title = props.title, description = props.description, url = props.url;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: url || "",
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            className: (article_card_module_default()).root,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (article_card_module_default()).zoomedImageContainer,
                    children: image ? /*#__PURE__*/ (0,jsx_runtime.jsx)(lazy_load_image_lazy_load_image/* default */.Z, {
                        className: (article_card_module_default()).zoomedImage,
                        imageUrl: image,
                        objectFit: "cover",
                        relativeContainer: false
                    }) : null
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (article_card_module_default()).main,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (article_card_module_default()).content,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (article_card_module_default()).title,
                                dangerouslySetInnerHTML: {
                                    __html: title || ""
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (article_card_module_default()).description,
                                dangerouslySetInnerHTML: {
                                    __html: description || ""
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (article_card_module_default()).btnLearnMore,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                    color: "primary",
                                    children: "Learn more"
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var article_card = (ArticleCard);

// EXTERNAL MODULE: ./components/roomstay-blog-article-card/roomstay-blog-article-card.module.scss
var roomstay_blog_article_card_module = __webpack_require__(5039);
var roomstay_blog_article_card_module_default = /*#__PURE__*/__webpack_require__.n(roomstay_blog_article_card_module);
;// CONCATENATED MODULE: ./components/roomstay-blog-article-card/roomstay-blog-article-card.tsx



var RoomStayBlogArticleCard = function(props) {
    var _articleCard = props.articleCard, articleCard = _articleCard === void 0 ? [] : _articleCard;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (roomstay_blog_article_card_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (roomstay_blog_article_card_module_default()).header,
                children: "Explore more RoomStay Products"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (roomstay_blog_article_card_module_default()).wrapper,
                children: articleCard.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(article_card, {
                        image: item.image,
                        category: item.category,
                        date: item.date,
                        title: item.title,
                        description: item.description,
                        url: item.url
                    }, index);
                })
            })
        ]
    });
};
/* harmony default export */ var roomstay_blog_article_card = (RoomStayBlogArticleCard);

;// CONCATENATED MODULE: ./components/roomstay-blog-article-card/roomstay-blog-article-card.builder-component.ts

var RoomstayBlogArticleCardBuilderConfig = {
    name: "RoomStay Article Card",
    inputs: [
        {
            name: "articleCard",
            type: "list",
            subFields: [
                {
                    name: "image",
                    type: "file"
                },
                {
                    name: "title",
                    type: "html"
                },
                {
                    name: "description",
                    type: "html"
                },
                {
                    name: "url",
                    type: "string"
                }, 
            ]
        }, 
    ]
};
var roomstay_blog_article_card_builder_component_builderConfig = {
    component: roomstay_blog_article_card,
    config: RoomstayBlogArticleCardBuilderConfig
};
/* harmony default export */ var roomstay_blog_article_card_builder_component = (roomstay_blog_article_card_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/share-icons/share-icons.tsx + 5 modules
var share_icons = __webpack_require__(7465);
// EXTERNAL MODULE: ./components/roomstay-blog-article-text-list/roomstay-blog-article-text-list.module.scss
var roomstay_blog_article_text_list_module = __webpack_require__(8086);
var roomstay_blog_article_text_list_module_default = /*#__PURE__*/__webpack_require__.n(roomstay_blog_article_text_list_module);
;// CONCATENATED MODULE: ./components/roomstay-blog-article-text-list/roomstay-blog-article-text-list.tsx





var RoomstayBlogArticleTextList = function(props) {
    var hideShareIcons = props.hideShareIcons, contents = props.contents;
    var width = (0,esm/* useWindowSize */.iP)().width;
    var targetUrl;
    if (true) {
        targetUrl = location.href;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (roomstay_blog_article_text_list_module_default()).container,
        children: [
            hideShareIcons ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (roomstay_blog_article_text_list_module_default()).shareIcons,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(share_icons/* default */.Z, {
                    vertical: width > 768,
                    shareUrl: targetUrl
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (roomstay_blog_article_text_list_module_default()).content,
                children: contents === null || contents === void 0 ? void 0 : contents.map(function(content) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()((roomstay_blog_article_text_list_module_default()).item, (roomstay_blog_article_text_list_module_default())[content.type]),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (roomstay_blog_article_text_list_module_default()).arrow
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: content.text
                            })
                        ]
                    }, Math.random());
                })
            })
        ]
    });
};
/* harmony default export */ var roomstay_blog_article_text_list = (RoomstayBlogArticleTextList);

;// CONCATENATED MODULE: ./components/roomstay-blog-article-text-list/roomstay-blog-article-text-list.builder-component.ts

var RoomstayBlogArticleTextListBuilderConfig = {
    name: "Article Text List",
    inputs: [
        {
            name: "hideShareIcons",
            type: "boolean"
        },
        {
            name: "contents",
            type: "list",
            subFields: [
                {
                    name: "text",
                    type: "string"
                },
                {
                    name: "type",
                    type: "text",
                    enum: [
                        "default",
                        "list"
                    ]
                }, 
            ]
        }, 
    ]
};
var roomstay_blog_article_text_list_builder_component_builderConfig = {
    component: roomstay_blog_article_text_list,
    config: RoomstayBlogArticleTextListBuilderConfig
};
/* harmony default export */ var roomstay_blog_article_text_list_builder_component = (roomstay_blog_article_text_list_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/roomstay-blog-blog-hero/roomstay-blog-blog-hero.builder-component.ts + 4 modules
var roomstay_blog_blog_hero_builder_component = __webpack_require__(7520);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(9113);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
;// CONCATENATED MODULE: ./components/Inputs/InputGroup.tsx




function InputGroup(props) {
    var classes = classnames_default()("be-form-group", (0,_define_property/* default */.Z)({}, "s-".concat(props.dimensions), !!props.dimensions));
    var classNameProps = classnames_default()("helpdesk-form", (0,_define_property/* default */.Z)({}, "s-".concat(props.dimensions), !!props.dimensions));
    var innerLayout;
    var childrenArray = react.Children.toArray(props.children);
    switch(props.dimensions){
        case "1/3":
        case "3/1":
        case "2/2":
            innerLayout = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: childrenArray[0]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: childrenArray[1].type.name === InputGroup.name ? "no-marg" : "",
                        children: childrenArray[1]
                    })
                ]
            });
            break;
        case "1":
        default:
            innerLayout = props.children;
            break;
    }
    return props.className ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classNameProps,
        children: innerLayout
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classes,
        children: innerLayout
    });
}

// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var dist_index_esm = __webpack_require__(7536);
;// CONCATENATED MODULE: ./components/roomstay-blog-book-demo-form/roomstay-blog-book-demo-form.tsx








var RoomstayBlogBookDemoForm = function(param) {
    var title = param.title, description = param.description, successMessage = param.successMessage;
    var formMethods = (0,dist_index_esm/* useForm */.cI)({
        mode: "onChange"
    });
    var ref = (0,react.useState)(false), sending = ref[0], setSending = ref[1];
    var ref1 = (0,react.useState)(false), success = ref1[0], setSuccess = ref1[1];
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var values, response;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setSending(true);
                        values = formMethods.getValues();
                        _ctx.prev = 2;
                        _ctx.next = 5;
                        return fetch("/api/book-demo", {
                            method: "POST",
                            body: JSON.stringify({
                                forename: values.forename,
                                surname: values.surname,
                                subject: values.subject,
                                number: values.number,
                                email: values.email,
                                message: values.message
                            })
                        });
                    case 5:
                        response = _ctx.sent;
                        formMethods.reset();
                        setSuccess(response.ok);
                        setSending(false);
                        _ctx.next = 14;
                        break;
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](2);
                        setSending(false);
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    11
                ]
            ]);
        }));
        return function onSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "centered-body",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "container",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row justify-content-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-md-6 col-lg-5 col-xl-4",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                        onSubmit: formMethods.handleSubmit(onSubmit),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "u-marg-bottom",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: "headline --primary-gradient u-text-center",
                                    children: title
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "u-marg-bottom--largest",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "body-text u-text-center",
                                    children: description
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "helpdesk-inputs",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "u-marg-bottom",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputGroup, {
                                            dimensions: "2/2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                                    type: "text",
                                                    required: true,
                                                    className: "text-input",
                                                    placeholder: "First Name",
                                                    tabIndex: 1
                                                }, formMethods.register("forename", {
                                                    required: true
                                                }))),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                                    type: "text",
                                                    required: true,
                                                    className: "text-input",
                                                    placeholder: "Last Name",
                                                    tabIndex: 2
                                                }, formMethods.register("surname", {
                                                    required: true
                                                })))
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "u-marg-bottom",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                            type: "text",
                                            required: true,
                                            className: "text-input",
                                            placeholder: "Your email",
                                            tabIndex: 3
                                        }, formMethods.register("email", {
                                            required: true
                                        })))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "u-marg-bottom",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                            type: "text",
                                            required: true,
                                            className: "text-input",
                                            placeholder: "Your Phone number",
                                            tabIndex: 4
                                        }, formMethods.register("number", {
                                            required: true
                                        })))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "u-marg-bottom",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                            type: "text",
                                            required: true,
                                            className: "text-input",
                                            placeholder: "Subject",
                                            tabIndex: 5
                                        }, formMethods.register("subject", {
                                            required: true
                                        })))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "u-marg-bottom",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", (0,_object_spread/* default */.Z)({
                                            className: "text-input",
                                            placeholder: "Your Message",
                                            tabIndex: 6
                                        }, formMethods.register("message", {
                                            required: true
                                        })))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "d-flex justify-content-between align-items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        className: "body-text --small --cyan u-pad-right",
                                        style: {
                                            opacity: success ? 1 : 0
                                        },
                                        children: successMessage || "Thanks! Message sent."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                        type: "primary",
                                        loading: sending,
                                        htmlType: "submit",
                                        onSubmit: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                                            return runtime_default().wrap(function _callee$(_ctx) {
                                                while(1)switch(_ctx.prev = _ctx.next){
                                                    case 0:
                                                        _ctx.next = 2;
                                                        return formMethods.handleSubmit(onSubmit)();
                                                    case 2:
                                                    case "end":
                                                        return _ctx.stop();
                                                }
                                            }, _callee);
                                        })),
                                        style: {
                                            flexShrink: 1,
                                            display: "flex",
                                            whiteSpace: "nowrap"
                                        },
                                        children: "Book a Demo"
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ var roomstay_blog_book_demo_form = (RoomstayBlogBookDemoForm);

;// CONCATENATED MODULE: ./components/roomstay-blog-book-demo-form/roomstay-blog-book-demo-form.builder-component.ts

var config = {
    name: "Book Demo Form",
    inputs: [
        {
            name: "title",
            type: "string"
        },
        {
            name: "description",
            type: "string"
        },
        {
            name: "successMessage",
            type: "string"
        }, 
    ]
};
var roomstay_blog_book_demo_form_builder_component_builderConfig = {
    component: roomstay_blog_book_demo_form,
    config: config
};
/* harmony default export */ var roomstay_blog_book_demo_form_builder_component = (roomstay_blog_book_demo_form_builder_component_builderConfig);

;// CONCATENATED MODULE: ./components/roomstay-blog-button/roomstay-blog-button.tsx


var RoomstayBlogButton = function(props) {
    var text = props.text, link = props.link;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
        link: link,
        children: text
    });
};
/* harmony default export */ var roomstay_blog_button = (RoomstayBlogButton);

;// CONCATENATED MODULE: ./components/roomstay-blog-button/roomstay-blog-button.builder-component.ts

var RoomstayBlogButtonBuilderConfig = {
    name: "Button",
    inputs: [
        {
            name: "text",
            type: "text"
        },
        {
            name: "link",
            type: "url"
        }, 
    ]
};
var roomstay_blog_button_builder_component_builderConfig = {
    component: roomstay_blog_button,
    config: RoomstayBlogButtonBuilderConfig
};
/* harmony default export */ var roomstay_blog_button_builder_component = (roomstay_blog_button_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/roomstay-blog-card-pricing/roomstay-blog-card-pricing.module.scss
var roomstay_blog_card_pricing_module = __webpack_require__(6710);
var roomstay_blog_card_pricing_module_default = /*#__PURE__*/__webpack_require__.n(roomstay_blog_card_pricing_module);
;// CONCATENATED MODULE: ./components/roomstay-blog-card-pricing/roomstay-blog-card-pricing.tsx









var RoomStayBlogCardPricing = function(props) {
    var contentText = props.contentText, contentForm = props.contentForm;
    var formMethods = (0,dist_index_esm/* useForm */.cI)({
        mode: "onChange"
    });
    var ref = (0,react.useState)(false), sending = ref[0], setSending = ref[1];
    var ref1 = (0,react.useState)(false), success = ref1[0], setSuccess = ref1[1];
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var values, response;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setSending(true);
                        values = formMethods.getValues();
                        _ctx.prev = 2;
                        _ctx.next = 5;
                        return fetch("/api/book-demo", {
                            method: "POST",
                            body: JSON.stringify({
                                email: values.email,
                                message: values.message || " ",
                                forename: values.forename,
                                surname: values.surname,
                                companyName: values.companyName,
                                number: values.number,
                                formType: "PPC"
                            })
                        });
                    case 5:
                        response = _ctx.sent;
                        formMethods.reset();
                        setSuccess(response.ok);
                        setSending(false);
                        _ctx.next = 14;
                        break;
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](2);
                        setSending(false);
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    11
                ]
            ]);
        }));
        return function onSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (roomstay_blog_card_pricing_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (roomstay_blog_card_pricing_module_default()).wrapperContent,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (roomstay_blog_card_pricing_module_default()).gridContent,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (roomstay_blog_card_pricing_module_default()).contentText,
                        children: [
                            (contentText === null || contentText === void 0 ? void 0 : contentText.subTitle) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (roomstay_blog_card_pricing_module_default()).subTitle,
                                dangerouslySetInnerHTML: {
                                    __html: contentText === null || contentText === void 0 ? void 0 : contentText.subTitle
                                }
                            }),
                            (contentText === null || contentText === void 0 ? void 0 : contentText.title) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (roomstay_blog_card_pricing_module_default()).title,
                                dangerouslySetInnerHTML: {
                                    __html: contentText === null || contentText === void 0 ? void 0 : contentText.title
                                }
                            }),
                            (contentText === null || contentText === void 0 ? void 0 : contentText.description) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (roomstay_blog_card_pricing_module_default()).description,
                                dangerouslySetInnerHTML: {
                                    __html: (contentText === null || contentText === void 0 ? void 0 : contentText.description) || ""
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (roomstay_blog_card_pricing_module_default()).contentForm,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                            onSubmit: formMethods.handleSubmit(onSubmit),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (roomstay_blog_card_pricing_module_default()).helpdeskInputs,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputGroup, {
                                            dimensions: "2/2",
                                            className: "be-form-group",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (roomstay_blog_card_pricing_module_default()).margBottom,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                                        type: "text",
                                                        required: true,
                                                        className: "text-input",
                                                        placeholder: "First name",
                                                        tabIndex: 1
                                                    }, formMethods.register("forename")))
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (roomstay_blog_card_pricing_module_default()).margBottom,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                                        type: "text",
                                                        required: true,
                                                        className: "text-input",
                                                        placeholder: "Last name",
                                                        tabIndex: 1
                                                    }, formMethods.register("surname")))
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (roomstay_blog_card_pricing_module_default()).margBottom,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                                type: "email",
                                                required: true,
                                                className: "text-input",
                                                placeholder: "Your email",
                                                tabIndex: 1
                                            }, formMethods.register("email")))
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (roomstay_blog_card_pricing_module_default()).margBottom,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                                type: "phone",
                                                required: true,
                                                className: "text-input",
                                                placeholder: "Your phone number",
                                                tabIndex: 1
                                            }, formMethods.register("number")))
                                        }),
                                        (contentForm === null || contentForm === void 0 ? void 0 : contentForm.showMessage) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (roomstay_blog_card_pricing_module_default()).margBottom,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", (0,_object_spread/* default */.Z)({
                                                className: "text-input",
                                                placeholder: "Your message",
                                                tabIndex: 1
                                            }, formMethods.register("message")))
                                        }),
                                        !(contentForm === null || contentForm === void 0 ? void 0 : contentForm.showMessage) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (roomstay_blog_card_pricing_module_default()).margBottom,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                                type: "companyName",
                                                required: true,
                                                className: "text-input",
                                                placeholder: "Number of rooms",
                                                tabIndex: 1
                                            }, formMethods.register("companyName")))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "align-items-center",
                                    children: [
                                        (contentForm === null || contentForm === void 0 ? void 0 : contentForm.successMessage) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "body-text --small --cyan u-pad-right",
                                            style: {
                                                display: success ? "block" : "none",
                                                marginBottom: 20
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                children: contentForm.successMessage || "Thanks! Message sent."
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ButtonBookADemo, {
                                            className: (roomstay_blog_card_pricing_module_default()).button,
                                            type: "secondary",
                                            loading: sending,
                                            htmlType: "submit",
                                            theme: "purple",
                                            color: "white",
                                            iconFillColor: true,
                                            size: "small",
                                            onSubmit: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                                                return runtime_default().wrap(function _callee$(_ctx) {
                                                    while(1)switch(_ctx.prev = _ctx.next){
                                                        case 0:
                                                            _ctx.next = 2;
                                                            return formMethods.handleSubmit(onSubmit)();
                                                        case 2:
                                                        case "end":
                                                            return _ctx.stop();
                                                    }
                                                }, _callee);
                                            })),
                                            style: {
                                                flexShrink: 1,
                                                display: "flex",
                                                whiteSpace: "nowrap",
                                                marginBottom: "0"
                                            },
                                            children: "Get a personalised quote"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (roomstay_blog_card_pricing_module_default()).description,
                                            children: "No hidden fees, no surprises. Just a simple step towards bigger earnings and happier guests!"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var roomstay_blog_card_pricing = (RoomStayBlogCardPricing);

;// CONCATENATED MODULE: ./components/roomstay-blog-card-pricing/roomstay-blog-card-pricing.builder-component.ts

var RoomStayBlogCardPricingBuilderConfig = {
    name: "Pricing Card",
    inputs: [
        {
            name: "contentText",
            type: "object",
            subFields: [
                {
                    name: "subTitle",
                    type: "html",
                    defaultValue: ""
                },
                {
                    name: "title",
                    type: "html",
                    defaultValue: ""
                },
                {
                    name: "description",
                    type: "html",
                    defaultValue: ""
                }, 
            ]
        },
        {
            name: "contentForm",
            type: "object",
            subFields: [
                {
                    name: "backgroundColor",
                    type: "color",
                    defaultValue: ""
                },
                {
                    name: "successMessage",
                    type: "string"
                }, 
            ]
        }, 
    ]
};
var roomstay_blog_card_pricing_builder_component_builderConfig = {
    component: roomstay_blog_card_pricing,
    config: RoomStayBlogCardPricingBuilderConfig
};
/* harmony default export */ var roomstay_blog_card_pricing_builder_component = (roomstay_blog_card_pricing_builder_component_builderConfig);

;// CONCATENATED MODULE: ./components/roomstay-blog-clipped-section/roomstay-blog-clipped-section.tsx





var EColor;
(function(EColor) {
    EColor["White"] = "White";
    EColor["Dark"] = "Dark";
})(EColor || (EColor = {}));
var EBackgroundColor;
(function(EBackgroundColor) {
    EBackgroundColor["Light"] = "Light";
    EBackgroundColor["Dark"] = "Dark";
})(EBackgroundColor || (EBackgroundColor = {}));
var EJoinerColor;
(function(EJoinerColor) {
    EJoinerColor["Navy"] = "Navy";
    EJoinerColor["White"] = "White";
})(EJoinerColor || (EJoinerColor = {}));
var RoomstayBlogClippedSection = function(param) {
    var children = param.children, noPaddingTop = param.noPaddingTop, container = param.container, color = param.color, backgroundColor = param.backgroundColor, joinerColor = param.joinerColor;
    var getColor = function() {
        switch(color){
            case EColor.Dark:
                return "--dark";
            case EColor.White:
                return "--white";
        }
    };
    var getBackgroundColor = function() {
        switch(backgroundColor){
            case EBackgroundColor.Light:
                return "--theme-light";
            case EBackgroundColor.Dark:
                return "--theme-dark";
        }
    };
    var getJoinerColor = function() {
        switch(joinerColor){
            case EJoinerColor.Navy:
                return "--to-navy";
            case EJoinerColor.White:
                return "--to-white";
        }
    };
    var Container, props = {};
    if (container) {
        Container = "div";
        props = {
            className: "container"
        };
    } else {
        Container = react.Fragment;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()("centered-body", "--no-min-height", getColor(), getBackgroundColor(), {
            "pt-0": noPaddingTop
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()("centered-body--joiner", getJoinerColor())
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                children: children
            }))
        ]
    });
};
/* harmony default export */ var roomstay_blog_clipped_section = (RoomstayBlogClippedSection);

// EXTERNAL MODULE: ./node_modules/@builder.io/react/dist/builder-react.es5.js
var builder_react_es5 = __webpack_require__(5102);
;// CONCATENATED MODULE: ./components/roomstay-blog-clipped-section/roomstay-blog-clipped-section.builder-component.ts


var RoomstayBlogClippedSectionBuilderConfig = {
    name: "Clipped Section",
    inputs: [
        {
            name: "color",
            type: "string",
            enum: Object.values(EColor)
        },
        {
            name: "backgroundColor",
            type: "string",
            enum: Object.values(EBackgroundColor)
        },
        {
            name: "joinerColor",
            type: "string",
            enum: Object.values(EJoinerColor)
        },
        {
            name: "container",
            type: "boolean"
        },
        {
            name: "noPaddingTop",
            type: "boolean"
        }
    ]
};
var roomstay_blog_clipped_section_builder_component_builderConfig = {
    component: (0,builder_react_es5/* withChildren */.u7)(roomstay_blog_clipped_section),
    config: RoomstayBlogClippedSectionBuilderConfig
};
/* harmony default export */ var roomstay_blog_clipped_section_builder_component = (roomstay_blog_clipped_section_builder_component_builderConfig);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(6305);
// EXTERNAL MODULE: ./components/roomstay-blog-customer-case-accordion-2/roomstay-blog-customer-case-accordion-2.module.scss
var roomstay_blog_customer_case_accordion_2_module = __webpack_require__(5885);
var roomstay_blog_customer_case_accordion_2_module_default = /*#__PURE__*/__webpack_require__.n(roomstay_blog_customer_case_accordion_2_module);
;// CONCATENATED MODULE: ./components/roomstay-blog-customer-case-accordion-2/roomstay-blog-customer-case-accordion-2.tsx









var RoomStayBlogCustomerCaseAccordion = function(props) {
    var tag = props.tag, title = props.title, description = props.description, ctaButton = props.ctaButton, cards = props.cards;
    var ref = (0,react.useState)(cards.map(function() {
        return null;
    })), expandedIndices = ref[0], setExpandedIndices = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,esm/* useElementSize */.h4)(), 2), containerRef = ref1[0], height = ref1[1].height;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,esm/* useElementSize */.h4)(), 2), introRef = ref2[0], ref3 = ref2[1], introHeight = ref3.height;
    var ref4 = (0,esm/* useWindowSize */.iP)(), windowWidth = ref4.width;
    var isMobile = windowWidth <= 768;
    var isTablet = windowWidth <= 991;
    var handleToggle = function(cardIndex, accordionIndex) {
        setExpandedIndices(function(prev) {
            var newIndices = (0,_to_consumable_array/* default */.Z)(prev);
            newIndices[cardIndex] = newIndices[cardIndex] === accordionIndex ? null : accordionIndex;
            return newIndices;
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: containerRef,
        className: (roomstay_blog_customer_case_accordion_2_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(clipped_box/* default */.Z, {
                configs: [
                    {
                        rad: isMobile ? Math.atan(110 / 1920) : isTablet ? Math.atan(101 / 1920) : Math.atan(101 / 1920),
                        position: clipped_box/* POSITION.BottomRight */.V.BottomRight
                    }, 
                ],
                className: (roomstay_blog_customer_case_accordion_2_module_default()).background,
                style: {
                    backgroundColor: "#1C1624",
                    maxHeight: "".concat(windowWidth > 998 ? introHeight + 230 : introHeight + 70, "px"),
                    transform: "rotate(180deg)"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(clipped_box/* default */.Z, {
                configs: [
                    {
                        rad: Math.atan(171 / 1920),
                        position: clipped_box/* POSITION.BottomRight */.V.BottomRight
                    }, 
                ],
                className: (roomstay_blog_customer_case_accordion_2_module_default()).backgroundBottom,
                style: {
                    backgroundColor: "red",
                    maxHeight: "".concat(windowWidth > 768 ? introHeight + 240 : introHeight + 90, "px"),
                    transform: "rotate(180deg)",
                    marginTop: "0px"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (roomstay_blog_customer_case_accordion_2_module_default()).backgroundColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (roomstay_blog_customer_case_accordion_2_module_default()).wrapperBox,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (roomstay_blog_customer_case_accordion_2_module_default()).boxLeft,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (roomstay_blog_customer_case_accordion_2_module_default()).wrapperTag,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (roomstay_blog_customer_case_accordion_2_module_default()).tag,
                                    dangerouslySetInnerHTML: {
                                        __html: tag || ""
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: (roomstay_blog_customer_case_accordion_2_module_default()).title,
                                dangerouslySetInnerHTML: {
                                    __html: title || ""
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (roomstay_blog_customer_case_accordion_2_module_default()).description,
                                dangerouslySetInnerHTML: {
                                    __html: description || ""
                                }
                            }),
                            (ctaButton === null || ctaButton === void 0 ? void 0 : ctaButton.text) && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ButtonBookADemo, {
                                className: (roomstay_blog_customer_case_accordion_2_module_default()).button,
                                icon: false,
                                iconFillColor: false,
                                type: "highty",
                                size: "default",
                                htmlType: "button",
                                sectionId: ctaButton === null || ctaButton === void 0 ? void 0 : ctaButton.href,
                                children: (ctaButton === null || ctaButton === void 0 ? void 0 : ctaButton.text) || "Book a Demo"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (roomstay_blog_customer_case_accordion_2_module_default()).boxRight,
                        children: [
                            cards === null || cards === void 0 ? void 0 : cards.map(function(card, cardIndex) {
                                var ref;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (roomstay_blog_customer_case_accordion_2_module_default()).boxCard,
                                        style: {
                                            backgroundColor: "".concat(card.backgroundCard || "white")
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (roomstay_blog_customer_case_accordion_2_module_default()).wrapperCardContent,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (roomstay_blog_customer_case_accordion_2_module_default()).cardNumber,
                                                        dangerouslySetInnerHTML: {
                                                            __html: card.number || ""
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (roomstay_blog_customer_case_accordion_2_module_default()).cardText,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                className: (roomstay_blog_customer_case_accordion_2_module_default()).cardTitle,
                                                                dangerouslySetInnerHTML: {
                                                                    __html: card.titleCard || ""
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (roomstay_blog_customer_case_accordion_2_module_default()).cardDescription,
                                                                dangerouslySetInnerHTML: {
                                                                    __html: card.descriptionCard || ""
                                                                }
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (roomstay_blog_customer_case_accordion_2_module_default()).cardDivider,
                                                style: {
                                                    backgroundColor: "".concat(card.backgroundDivider)
                                                }
                                            }),
                                            card === null || card === void 0 ? void 0 : (ref = card.accordion) === null || ref === void 0 ? void 0 : ref.map(function(item, accordionIndex) {
                                                var isExpanded = expandedIndices[cardIndex] === accordionIndex;
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "".concat((roomstay_blog_customer_case_accordion_2_module_default()).wrapperItem, " ").concat(isExpanded ? (roomstay_blog_customer_case_accordion_2_module_default()).expanded : ""),
                                                    onClick: function() {
                                                        return handleToggle(cardIndex, accordionIndex);
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (roomstay_blog_customer_case_accordion_2_module_default()).wrapperHeader,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: (roomstay_blog_customer_case_accordion_2_module_default()).headerLeft,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: (roomstay_blog_customer_case_accordion_2_module_default()).icon,
                                                                            style: {
                                                                                backgroundColor: "".concat(item.backgroundIcon || "white", " ")
                                                                            },
                                                                            children: item.icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(lazy_load_image/* LazyLoadImage */.e6, {
                                                                                className: (roomstay_blog_customer_case_accordion_2_module_default()).image,
                                                                                imageUrl: item.icon,
                                                                                alt: "",
                                                                                objectFit: "cover"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                            className: (roomstay_blog_customer_case_accordion_2_module_default()).text,
                                                                            dangerouslySetInnerHTML: {
                                                                                __html: item.text || ""
                                                                            }
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: (roomstay_blog_customer_case_accordion_2_module_default()).headerRight,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "".concat((roomstay_blog_customer_case_accordion_2_module_default()).arrow, " ").concat(isExpanded ? (roomstay_blog_customer_case_accordion_2_module_default()).rotated : ""),
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                                            width: "16",
                                                                            height: "16",
                                                                            viewBox: "0 0 16 16",
                                                                            fill: "none",
                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                                d: "M1.50635 6.91016L0.504394 7.91211L7.86963 15.2686L15.2261 7.91211L14.2329 6.91016L8.59033 12.5527L8.59033 0.731445L7.18408 0.731445L7.18408 12.5967L1.50635 6.91016Z",
                                                                                fill: "".concat(item.colorArrow || "white")
                                                                            })
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "".concat((roomstay_blog_customer_case_accordion_2_module_default()).wrapperDescription, " ").concat(isExpanded ? (roomstay_blog_customer_case_accordion_2_module_default()).show : ""),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (roomstay_blog_customer_case_accordion_2_module_default()).description,
                                                                dangerouslySetInnerHTML: {
                                                                    __html: item.description || ""
                                                                }
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (roomstay_blog_customer_case_accordion_2_module_default()).dividerAccordion,
                                                            style: {
                                                                backgroundColor: "".concat(card.backgroundDivider)
                                                            }
                                                        })
                                                    ]
                                                }, accordionIndex);
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (roomstay_blog_customer_case_accordion_2_module_default()).cardDescription2,
                                                dangerouslySetInnerHTML: {
                                                    __html: card.descriptionCard2 || ""
                                                }
                                            })
                                        ]
                                    })
                                }, cardIndex);
                            }),
                            (ctaButton === null || ctaButton === void 0 ? void 0 : ctaButton.text) && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ButtonBookADemo, {
                                className: (roomstay_blog_customer_case_accordion_2_module_default()).button,
                                icon: false,
                                iconFillColor: false,
                                type: "highty",
                                size: "default",
                                htmlType: "button",
                                sectionId: ctaButton === null || ctaButton === void 0 ? void 0 : ctaButton.href,
                                children: (ctaButton === null || ctaButton === void 0 ? void 0 : ctaButton.text) || "Book a Demo"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var roomstay_blog_customer_case_accordion_2 = (RoomStayBlogCustomerCaseAccordion);

;// CONCATENATED MODULE: ./components/roomstay-blog-customer-case-accordion-2/roomstay-blog-customer-case-accordion-2.builder-component.ts

var RoomStayBlogCustomerAccordion2BuilderConfig = {
    name: "Customer Accordion Case 2",
    inputs: [
        {
            name: "tag",
            type: "html",
            defaultValue: ""
        },
        {
            name: "title",
            type: "html",
            defaultValue: ""
        },
        {
            name: "description",
            type: "richText",
            defaultValue: ""
        },
        {
            name: "ctaButton",
            type: "object",
            subFields: [
                {
                    name: "text",
                    type: "string"
                },
                {
                    name: "href",
                    type: "string"
                }, 
            ]
        },
        {
            name: "cards",
            type: "list",
            subFields: [
                {
                    name: "number",
                    type: "richText",
                    defaultValue: ""
                },
                {
                    name: "titleCard",
                    type: "richText",
                    defaultValue: ""
                },
                {
                    name: "descriptionCard",
                    type: "richText",
                    defaultValue: ""
                },
                {
                    name: "backgroundCard",
                    type: "color",
                    defaultValue: ""
                },
                {
                    name: "backgroundDivider",
                    type: "color",
                    defaultValue: ""
                },
                {
                    name: "accordion",
                    type: "list",
                    subFields: [
                        {
                            name: "icon",
                            type: "file",
                            defaultValue: ""
                        },
                        {
                            name: "backgroundIcon",
                            type: "color",
                            defaultValue: ""
                        },
                        {
                            name: "colorArrow",
                            type: "color",
                            defaultValue: ""
                        },
                        {
                            name: "text",
                            type: "richText",
                            defaultValue: ""
                        },
                        {
                            name: "description",
                            type: "richText",
                            defaultValue: ""
                        }, 
                    ]
                },
                {
                    name: "descriptionCard2",
                    type: "richText",
                    defaultValue: ""
                }, 
            ]
        }, 
    ]
};
var roomstay_blog_customer_case_accordion_2_builder_component_builderConfig = {
    component: roomstay_blog_customer_case_accordion_2,
    config: RoomStayBlogCustomerAccordion2BuilderConfig
};
/* harmony default export */ var roomstay_blog_customer_case_accordion_2_builder_component = (roomstay_blog_customer_case_accordion_2_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/roomstay-blog-customer-case-accordion/roomstay-blog-customer-case-accordion.module.scss
var roomstay_blog_customer_case_accordion_module = __webpack_require__(4279);
var roomstay_blog_customer_case_accordion_module_default = /*#__PURE__*/__webpack_require__.n(roomstay_blog_customer_case_accordion_module);
;// CONCATENATED MODULE: ./components/roomstay-blog-customer-case-accordion/roomstay-blog-customer-case-accordion.tsx






var roomstay_blog_customer_case_accordion_RoomStayBlogCustomerCaseAccordion = function(props) {
    var tag = props.tag, title = props.title, description = props.description, subDescription = props.subDescription, ctaButton = props.ctaButton, accordion = props.accordion;
    var ref = (0,react.useState)([]), expandedIndices = ref[0], setExpandedIndices = ref[1];
    var handleToggle = function(index) {
        setExpandedIndices(function(prevIndices) {
            return prevIndices.includes(index) ? prevIndices.filter(function(i) {
                return i !== index;
            }) : (0,_to_consumable_array/* default */.Z)(prevIndices).concat([
                index
            ]);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (roomstay_blog_customer_case_accordion_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (roomstay_blog_customer_case_accordion_module_default()).wrapperBox,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (roomstay_blog_customer_case_accordion_module_default()).boxLeft,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (roomstay_blog_customer_case_accordion_module_default()).wrapperTag,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (roomstay_blog_customer_case_accordion_module_default()).tag,
                                dangerouslySetInnerHTML: {
                                    __html: tag || ""
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: (roomstay_blog_customer_case_accordion_module_default()).title,
                            dangerouslySetInnerHTML: {
                                __html: title || ""
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (roomstay_blog_customer_case_accordion_module_default()).description,
                            dangerouslySetInnerHTML: {
                                __html: description || ""
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (roomstay_blog_customer_case_accordion_module_default()).subDescription,
                            dangerouslySetInnerHTML: {
                                __html: subDescription || ""
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (roomstay_blog_customer_case_accordion_module_default()).boxRight,
                    children: [
                        accordion.map(function(item, index) {
                            var isExpanded = expandedIndices.includes(index);
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat((roomstay_blog_customer_case_accordion_module_default()).wrapperItem, " ").concat(isExpanded ? (roomstay_blog_customer_case_accordion_module_default()).expanded : ""),
                                onClick: function() {
                                    return handleToggle(index);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (roomstay_blog_customer_case_accordion_module_default()).wrapperHeader,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (roomstay_blog_customer_case_accordion_module_default()).headerLeft,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (roomstay_blog_customer_case_accordion_module_default()).icon,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lazy_load_image/* LazyLoadImage */.e6, {
                                                            className: (roomstay_blog_customer_case_accordion_module_default()).image,
                                                            imageUrl: item.icon,
                                                            alt: "",
                                                            objectFit: "cover"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                        className: (roomstay_blog_customer_case_accordion_module_default()).text,
                                                        dangerouslySetInnerHTML: {
                                                            __html: item.text || ""
                                                        }
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (roomstay_blog_customer_case_accordion_module_default()).headerRight,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "".concat((roomstay_blog_customer_case_accordion_module_default()).arrow, " ").concat(isExpanded ? (roomstay_blog_customer_case_accordion_module_default()).rotated : ""),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                        width: "16",
                                                        height: "16",
                                                        viewBox: "0 0 16 16",
                                                        fill: "none",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M1.50635 6.91016L0.504394 7.91211L7.86963 15.2686L15.2261 7.91211L14.2329 6.91016L8.59033 12.5527L8.59033 0.731445L7.18408 0.731445L7.18408 12.5967L1.50635 6.91016Z",
                                                            fill: "#FF0068"
                                                        })
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((roomstay_blog_customer_case_accordion_module_default()).wrapperDescription, " ").concat(isExpanded ? (roomstay_blog_customer_case_accordion_module_default()).show : ""),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (roomstay_blog_customer_case_accordion_module_default()).description,
                                            dangerouslySetInnerHTML: {
                                                __html: item.description || ""
                                            }
                                        })
                                    })
                                ]
                            }, index);
                        }),
                        (ctaButton === null || ctaButton === void 0 ? void 0 : ctaButton.text) && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                            className: (roomstay_blog_customer_case_accordion_module_default()).button,
                            type: "primary",
                            theme: "default",
                            size: "default",
                            htmlType: "button",
                            link: ctaButton === null || ctaButton === void 0 ? void 0 : ctaButton.href,
                            children: (ctaButton === null || ctaButton === void 0 ? void 0 : ctaButton.text) || "Book a Demo"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var roomstay_blog_customer_case_accordion = (roomstay_blog_customer_case_accordion_RoomStayBlogCustomerCaseAccordion);

;// CONCATENATED MODULE: ./components/roomstay-blog-customer-case-accordion/roomstay-blog-customer-case-accordion.builder-component.ts

var RoomStayBlogCustomerAccordionBuilderConfig = {
    name: "Customer Accordion Case",
    inputs: [
        {
            name: "tag",
            type: "html",
            defaultValue: ""
        },
        {
            name: "title",
            type: "html",
            defaultValue: ""
        },
        {
            name: "description",
            type: "richText",
            defaultValue: ""
        },
        {
            name: "subDescription",
            type: "richText",
            defaultValue: ""
        },
        {
            name: "ctaButton",
            type: "object",
            subFields: [
                {
                    name: "text",
                    type: "string"
                },
                {
                    name: "href",
                    type: "string"
                }, 
            ]
        },
        {
            name: "accordion",
            type: "list",
            subFields: [
                {
                    name: "icon",
                    type: "file",
                    defaultValue: ""
                },
                {
                    name: "text",
                    type: "html",
                    defaultValue: ""
                },
                {
                    name: "description",
                    type: "richText",
                    defaultValue: ""
                }, 
            ]
        }, 
    ]
};
var roomstay_blog_customer_case_accordion_builder_component_builderConfig = {
    component: roomstay_blog_customer_case_accordion,
    config: RoomStayBlogCustomerAccordionBuilderConfig
};
/* harmony default export */ var roomstay_blog_customer_case_accordion_builder_component = (roomstay_blog_customer_case_accordion_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/roomstay-blog-customer-case-block/roomstay-blog-customer-case-block.module.scss
var roomstay_blog_customer_case_block_module = __webpack_require__(1433);
var roomstay_blog_customer_case_block_module_default = /*#__PURE__*/__webpack_require__.n(roomstay_blog_customer_case_block_module);
;// CONCATENATED MODULE: ./components/roomstay-blog-customer-case-block/roomstay-blog-customer-case-block.tsx







var RoomStayBlogCustomerCaseBlock = function(props) {
    var avatar = props.avatar, textMain = props.textMain, title = props.title, description = props.description, image = props.image, backgroundBottom = props.backgroundBottom, backgroundTop = props.backgroundTop;
    var ref = (0,_sliced_to_array/* default */.Z)((0,esm/* useElementSize */.h4)(), 2), containerRef = ref[0], height = ref[1].height;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,esm/* useElementSize */.h4)(), 2), introRef = ref1[0], ref2 = ref1[1], introHeight = ref2.height;
    var ref3 = (0,esm/* useWindowSize */.iP)(), windowWidth = ref3.width;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (roomstay_blog_customer_case_block_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (roomstay_blog_customer_case_block_module_default()).backgroundColor
            }),
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(clipped_box/* default */.Z, {
                configs: [
                    {
                        rad: Math.atan(190 / 1920),
                        position: clipped_box/* POSITION.BottomRight */.V.BottomRight
                    }, 
                ],
                className: (roomstay_blog_customer_case_block_module_default()).background,
                style: {
                    // background: `red`,
                    maxHeight: "".concat(windowWidth > 998 ? introHeight + 168 : windowWidth > 768 ? introHeight + 110 : introHeight + 90, "px"),
                    transform: "rotate(180deg)"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(clipped_box/* default */.Z, {
                configs: [
                    {
                        rad: Math.atan(171 / 1920),
                        position: clipped_box/* POSITION.BottomRight */.V.BottomRight
                    }, 
                ],
                className: (roomstay_blog_customer_case_block_module_default()).backgroundBottom,
                style: {
                    // backgroundColor: `red`,
                    maxHeight: "".concat(windowWidth > 768 ? introHeight + 140 : introHeight + 90, "px"),
                    transform: "rotate(180deg)",
                    marginTop: "0px"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (roomstay_blog_customer_case_block_module_default()).wrapperContent,
                children: [
                    avatar && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (roomstay_blog_customer_case_block_module_default()).wrapperAvatar,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lazy_load_image/* LazyLoadImage */.e6, {
                            className: (roomstay_blog_customer_case_block_module_default()).wrapperImg,
                            imageUrl: avatar,
                            objectFit: "cover"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (roomstay_blog_customer_case_block_module_default()).textMain,
                        dangerouslySetInnerHTML: {
                            __html: textMain || ""
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (roomstay_blog_customer_case_block_module_default()).title,
                        dangerouslySetInnerHTML: {
                            __html: title || ""
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (roomstay_blog_customer_case_block_module_default()).description,
                        dangerouslySetInnerHTML: {
                            __html: description || ""
                        }
                    }),
                    image && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (roomstay_blog_customer_case_block_module_default()).wrapperImage,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (roomstay_blog_customer_case_block_module_default()).image,
                            children: [
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(lazy_load_image/* LazyLoadImage */.e6, {
                                    imageUrl: image,
                                    objectFit: "cover"
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var roomstay_blog_customer_case_block = (RoomStayBlogCustomerCaseBlock);

;// CONCATENATED MODULE: ./components/roomstay-blog-customer-case-block/roomstay-blog-customer-case-block.builder-component.ts

var RoomStayBlogCustomerCaseBlockBuilderConfig = {
    name: "Customer Case Block",
    inputs: [
        {
            name: "avatar",
            type: "file",
            defaultValue: ""
        },
        {
            name: "textMain",
            type: "html",
            defaultValue: ""
        },
        {
            name: "title",
            type: "html",
            defaultValue: ""
        },
        {
            name: "description",
            type: "html",
            defaultValue: ""
        },
        {
            name: "image",
            type: "file",
            defaultValue: ""
        },
        {
            name: "backgroundColor",
            type: "color",
            defaultValue: ""
        },
        {
            name: "backgroundTop",
            type: "color",
            defaultValue: ""
        },
        {
            name: "backgroundBottom",
            type: "color",
            defaultValue: ""
        }, 
    ]
};
var roomstay_blog_customer_case_block_builder_component_builderConfig = {
    component: roomstay_blog_customer_case_block,
    config: RoomStayBlogCustomerCaseBlockBuilderConfig
};
/* harmony default export */ var roomstay_blog_customer_case_block_builder_component = (roomstay_blog_customer_case_block_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/roomstay-blog-customer-case-hero/roomstay-blog-customer-case-hero.module.scss
var roomstay_blog_customer_case_hero_module = __webpack_require__(4981);
var roomstay_blog_customer_case_hero_module_default = /*#__PURE__*/__webpack_require__.n(roomstay_blog_customer_case_hero_module);
;// CONCATENATED MODULE: ./components/roomstay-blog-customer-case-hero/roomstay-blog-customer-case-hero.tsx









var RoomStayCustomerCaseHero = function(props) {
    var subTitle = props.subTitle, title = props.title, description = props.description, ctaButton = props.ctaButton, graphic = props.graphic;
    var ref = (0,_sliced_to_array/* default */.Z)((0,esm/* useElementSize */.h4)(), 2), introRef = ref[0], ref1 = ref[1], introHeight = ref1.height;
    var ref2 = (0,esm/* useWindowSize */.iP)(), windowWidth = ref2.width;
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,esm/* useElementSize */.h4)(), 2), containerRef = ref3[0], height = ref3[1].height;
    var width = (0,esm/* useWindowSize */.iP)().width;
    var isSmallMobile = windowWidth <= 578;
    var isMobile = windowWidth <= 768;
    var isTablet = windowWidth <= 991;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: containerRef,
        className: (roomstay_blog_customer_case_hero_module_default()).container,
        children: [
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (roomstay_blog_customer_case_hero_module_default()).background,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(clipped_box/* default */.Z, {
                    configs: [
                        {
                            rad: isMobile ? Math.tan(60 / 375) : isTablet ? Math.tan(220 / 1920) : Math.tan(720 / 1920),
                            position: clipped_box/* POSITION.BottomRight */.V.BottomRight
                        }, 
                    ],
                    className: classnames_default()((roomstay_blog_customer_case_hero_module_default()).background, (roomstay_blog_customer_case_hero_module_default()).backgroundClippedBottom),
                    style: {
                        backgroundColor: "#fff",
                        maxHeight: isSmallMobile ? 50 : isMobile ? 80 : isTablet ? 120 : 280,
                        transform: "rotate(180deg)",
                        marginBottom: -1
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (roomstay_blog_customer_case_hero_module_default()).wrapperContent,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (roomstay_blog_customer_case_hero_module_default()).contentBoxLeft,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (roomstay_blog_customer_case_hero_module_default()).wrapperText,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (roomstay_blog_customer_case_hero_module_default()).subTitle,
                                    dangerouslySetInnerHTML: {
                                        __html: subTitle || ""
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: (roomstay_blog_customer_case_hero_module_default()).title,
                                    dangerouslySetInnerHTML: {
                                        __html: title || ""
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (roomstay_blog_customer_case_hero_module_default()).imageMobile,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (roomstay_blog_customer_case_hero_module_default()).imgMobile,
                                        children: graphic && /*#__PURE__*/ (0,jsx_runtime.jsx)(lazy_load_image/* LazyLoadImage */.e6, {
                                            imageUrl: graphic,
                                            alt: "",
                                            objectFit: "cover"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (roomstay_blog_customer_case_hero_module_default()).description,
                                    dangerouslySetInnerHTML: {
                                        __html: description || ""
                                    }
                                }),
                                " ",
                                (ctaButton === null || ctaButton === void 0 ? void 0 : ctaButton.text) && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ButtonBookADemo, {
                                    className: (roomstay_blog_customer_case_hero_module_default()).button,
                                    icon: false,
                                    iconFillColor: false,
                                    type: "highty",
                                    size: "default",
                                    htmlType: "button",
                                    sectionId: ctaButton === null || ctaButton === void 0 ? void 0 : ctaButton.href,
                                    children: (ctaButton === null || ctaButton === void 0 ? void 0 : ctaButton.text) || "Book a Demo"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (roomstay_blog_customer_case_hero_module_default()).contentBoxRight,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (roomstay_blog_customer_case_hero_module_default()).img,
                            children: graphic && /*#__PURE__*/ (0,jsx_runtime.jsx)(lazy_load_image/* LazyLoadImage */.e6, {
                                imageUrl: graphic,
                                alt: "",
                                objectFit: "cover"
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var roomstay_blog_customer_case_hero = (RoomStayCustomerCaseHero);

;// CONCATENATED MODULE: ./components/roomstay-blog-customer-case-hero/roomstay-blog-customer-case-hero.builder-component.ts

var RoomStayBlogCustomerCaseBuilderConfig = {
    name: "Customer Hero Case",
    inputs: [
        {
            name: "subTitle",
            type: "html",
            defaultValue: ""
        },
        {
            name: "title",
            type: "html",
            defaultValue: ""
        },
        {
            name: "description",
            type: "richText",
            defaultValue: ""
        },
        {
            name: "ctaButton",
            type: "object",
            subFields: [
                {
                    name: "text",
                    type: "string"
                },
                {
                    name: "href",
                    type: "string"
                }, 
            ]
        },
        {
            name: "graphic",
            type: "file"
        }, 
    ]
};
var roomstay_blog_customer_case_hero_builder_component_builderConfig = {
    component: roomstay_blog_customer_case_hero,
    config: RoomStayBlogCustomerCaseBuilderConfig
};
/* harmony default export */ var roomstay_blog_customer_case_hero_builder_component = (roomstay_blog_customer_case_hero_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/roomstay-blog-customer-case-image/roomstay-blog-customer-case-image.module.scss
var roomstay_blog_customer_case_image_module = __webpack_require__(580);
var roomstay_blog_customer_case_image_module_default = /*#__PURE__*/__webpack_require__.n(roomstay_blog_customer_case_image_module);
;// CONCATENATED MODULE: ./components/roomstay-blog-customer-case-image/roomstay-blog-customer-case-image.tsx







var RoomStayBlogCustomerCaseImage = function(props) {
    var image = props.image, backgroundBottom = props.backgroundBottom, backgroundTop = props.backgroundTop;
    var ref = (0,_sliced_to_array/* default */.Z)((0,esm/* useElementSize */.h4)(), 2), containerRef = ref[0], height = ref[1].height;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,esm/* useElementSize */.h4)(), 2), introRef = ref1[0], ref2 = ref1[1], introHeight = ref2.height;
    var ref3 = (0,esm/* useWindowSize */.iP)(), windowWidth = ref3.width;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: containerRef,
        className: (roomstay_blog_customer_case_image_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(clipped_box/* default */.Z, {
                configs: [
                    {
                        rad: Math.atan(81 / 1920),
                        position: clipped_box/* POSITION.TopLeft */.V.TopLeft
                    }, 
                ],
                className: (roomstay_blog_customer_case_image_module_default()).background,
                style: {
                    backgroundColor: "".concat(backgroundTop),
                    maxHeight: "".concat(windowWidth > 768 ? introHeight + 120 : introHeight + 40, "px"),
                    transform: "rotate(180deg)"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(clipped_box/* default */.Z, {
                configs: [
                    {
                        rad: Math.atan(81 / 1920),
                        position: clipped_box/* POSITION.BottomRight */.V.BottomRight
                    }, 
                ],
                className: (roomstay_blog_customer_case_image_module_default()).backgroundBottom,
                style: {
                    backgroundColor: "#fff",
                    maxHeight: "".concat(windowWidth > 768 ? introHeight + 70 : introHeight + 40, "px"),
                    transform: "rotate(180deg)",
                    marginTop: "0px"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(lazy_load_image/* LazyLoadImage */.e6, {
                className: (roomstay_blog_customer_case_image_module_default()).wrapperImg,
                imageUrl: image,
                objectFit: "cover"
            })
        ]
    });
};
/* harmony default export */ var roomstay_blog_customer_case_image = (RoomStayBlogCustomerCaseImage);

;// CONCATENATED MODULE: ./components/roomstay-blog-customer-case-image/roomstay-blog-customer-case-image.builder-component.ts

var RoomStayBlogCustomerCaseImageBuilderConfig = {
    name: "Customer Case Image",
    inputs: [
        {
            name: "image",
            type: "file",
            defaultValue: ""
        },
        {
            name: "backgroundTop",
            type: "color",
            defaultValue: ""
        },
        {
            name: "backgroundBottom",
            type: "color",
            defaultValue: ""
        }, 
    ]
};
var roomstay_blog_customer_case_image_builder_component_builderConfig = {
    component: roomstay_blog_customer_case_image,
    config: RoomStayBlogCustomerCaseImageBuilderConfig
};
/* harmony default export */ var roomstay_blog_customer_case_image_builder_component = (roomstay_blog_customer_case_image_builder_component_builderConfig);

// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(2426);
// EXTERNAL MODULE: ./components/roomstay-blog-customer-case-list-card-2/roomstay-blog-customer-case-list-card-2.module.scss
var roomstay_blog_customer_case_list_card_2_module = __webpack_require__(7944);
var roomstay_blog_customer_case_list_card_2_module_default = /*#__PURE__*/__webpack_require__.n(roomstay_blog_customer_case_list_card_2_module);
;// CONCATENATED MODULE: ./components/roomstay-blog-customer-case-list-card-2/roomstay-blog-customer-case-list-card-2.tsx











var options = {
    slidesPerView: "auto",
    spaceBetween: 16,
    allowTouchMove: true,
    noSwiping: false,
    freeMode: true,
    breakpoints: {
        992: {
            watchOverflow: true
        }
    }
};
var RoomStayBlogCustomerCaseListCard = function(props) {
    var tag = props.tag, title = props.title, description = props.description, cards = props.cards;
    var ref = (0,_sliced_to_array/* default */.Z)((0,esm/* useElementSize */.h4)(), 2), containerRef = ref[0], height = ref[1].height;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,esm/* useElementSize */.h4)(), 2), introRef = ref1[0], ref2 = ref1[1], introHeight = ref2.height;
    var ref3 = (0,esm/* useWindowSize */.iP)(), windowWidth = ref3.width;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: containerRef,
        className: (roomstay_blog_customer_case_list_card_2_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (roomstay_blog_customer_case_list_card_2_module_default()).backgroundColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(clipped_box/* default */.Z, {
                configs: [
                    {
                        rad: windowWidth > 768 ? Math.atan(71 / 1920) : Math.atan(100 / 1920),
                        position: clipped_box/* POSITION.BottomRight */.V.BottomRight
                    }, 
                ],
                className: (roomstay_blog_customer_case_list_card_2_module_default()).backgroundClipped,
                style: {
                    backgroundColor: "#00D7E1",
                    maxHeight: "".concat(windowWidth > 768 ? introHeight + 120 : introHeight + 120, "px"),
                    transform: "rotate(180deg)"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(clipped_box/* default */.Z, {
                configs: [
                    {
                        rad: Math.atan(221 / 1920),
                        position: clipped_box/* POSITION.TopLeft */.V.TopLeft
                    }, 
                ],
                className: (roomstay_blog_customer_case_list_card_2_module_default()).backgroundBottom,
                style: {
                    background: "#00D7E1",
                    maxHeight: "".concat(windowWidth > 768 ? introHeight + 490 : introHeight + 120, "px"),
                    transform: "rotate(0deg)",
                    marginTop: "0px"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (roomstay_blog_customer_case_list_card_2_module_default()).wrapperTag,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (roomstay_blog_customer_case_list_card_2_module_default()).tag,
                    dangerouslySetInnerHTML: {
                        __html: tag || ""
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: (roomstay_blog_customer_case_list_card_2_module_default()).title,
                dangerouslySetInnerHTML: {
                    __html: title || ""
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (roomstay_blog_customer_case_list_card_2_module_default()).description,
                dangerouslySetInnerHTML: {
                    __html: description || ""
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (roomstay_blog_customer_case_list_card_2_module_default()).wrapperCard,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (roomstay_blog_customer_case_list_card_2_module_default()).box,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, options), {
                        children: cards === null || cards === void 0 ? void 0 : cards.map(function(card, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: classnames_default()((roomstay_blog_customer_case_list_card_2_module_default()).item),
                                    style: {
                                        backgroundColor: "".concat(card.background)
                                    },
                                    children: [
                                        card.icon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (roomstay_blog_customer_case_list_card_2_module_default()).icon,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lazy_load_image/* LazyLoadImage */.e6, {
                                                className: (roomstay_blog_customer_case_list_card_2_module_default()).wrapperImg,
                                                imageUrl: card.icon,
                                                objectFit: "cover"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: (roomstay_blog_customer_case_list_card_2_module_default()).titleCard,
                                            dangerouslySetInnerHTML: {
                                                __html: card.titleCard || ""
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (roomstay_blog_customer_case_list_card_2_module_default()).descriptionCard,
                                            dangerouslySetInnerHTML: {
                                                __html: card.descriptionCard || ""
                                            }
                                        })
                                    ]
                                })
                            }, index);
                        })
                    }))
                })
            })
        ]
    });
};
/* harmony default export */ var roomstay_blog_customer_case_list_card_2 = (RoomStayBlogCustomerCaseListCard);

;// CONCATENATED MODULE: ./components/roomstay-blog-customer-case-list-card-2/roomstay-blog-customer-case-list-card-2.builder-component.ts

var RoomStayBlogCustomerCaseListCard2BuilderConfig = {
    name: "Customer Case List Card 2",
    inputs: [
        {
            name: "tag",
            type: "string",
            defaultValue: ""
        },
        {
            name: "title",
            type: "html",
            defaultValue: ""
        },
        {
            name: "description",
            type: "html",
            defaultValue: ""
        },
        {
            name: "cards",
            type: "list",
            subFields: [
                {
                    name: "icon",
                    type: "file"
                },
                {
                    name: "titleCard",
                    type: "richText",
                    defaultValue: ""
                },
                {
                    name: "descriptionCard",
                    type: "richText",
                    defaultValue: ""
                },
                {
                    name: "background",
                    type: "color",
                    defaultValue: ""
                }, 
            ]
        }, 
    ]
};
var roomstay_blog_customer_case_list_card_2_builder_component_builderConfig = {
    component: roomstay_blog_customer_case_list_card_2,
    config: RoomStayBlogCustomerCaseListCard2BuilderConfig
};
/* harmony default export */ var roomstay_blog_customer_case_list_card_2_builder_component = (roomstay_blog_customer_case_list_card_2_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/roomstay-blog-customer-case-list-card/roomstay-blog-customer-case-list-card.module.scss
var roomstay_blog_customer_case_list_card_module = __webpack_require__(7665);
var roomstay_blog_customer_case_list_card_module_default = /*#__PURE__*/__webpack_require__.n(roomstay_blog_customer_case_list_card_module);
;// CONCATENATED MODULE: ./components/roomstay-blog-customer-case-list-card/roomstay-blog-customer-case-list-card.tsx











var roomstay_blog_customer_case_list_card_options = {
    slidesPerView: "auto",
    spaceBetween: 16,
    allowTouchMove: true,
    noSwiping: false,
    freeMode: true,
    breakpoints: {
        992: {
            watchOverflow: true
        }
    }
};
var roomstay_blog_customer_case_list_card_RoomStayBlogCustomerCaseListCard = function(props) {
    var tag = props.tag, title = props.title, cards = props.cards, ctaButton = props.ctaButton;
    var ref = (0,_sliced_to_array/* default */.Z)((0,esm/* useElementSize */.h4)(), 2), containerRef = ref[0], height = ref[1].height;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,esm/* useElementSize */.h4)(), 2), introRef = ref1[0], ref2 = ref1[1], introHeight = ref2.height;
    var ref3 = (0,esm/* useWindowSize */.iP)(), windowWidth = ref3.width;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: containerRef,
        className: (roomstay_blog_customer_case_list_card_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(clipped_box/* default */.Z, {
                configs: [
                    {
                        rad: windowWidth > 768 ? Math.atan(71 / 1920) : Math.atan(191 / 1920),
                        position: clipped_box/* POSITION.BottomRight */.V.BottomRight
                    }, 
                ],
                className: (roomstay_blog_customer_case_list_card_module_default()).backgroundClipped,
                style: {
                    backgroundColor: "#fff",
                    maxHeight: "".concat(windowWidth > 768 ? introHeight + 87 : introHeight + 60, "px"),
                    transform: "rotate(180deg)"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(clipped_box/* default */.Z, {
                configs: [
                    {
                        rad: Math.atan(121 / 1920),
                        position: clipped_box/* POSITION.TopLeft */.V.TopLeft
                    }, 
                ],
                className: (roomstay_blog_customer_case_list_card_module_default()).backgroundBottom,
                style: {
                    background: "linear-gradient(65deg, rgb(124, 57, 255) -43.79%, rgb(188, 29, 181) 34.45%, rgb(255, 0, 104) 98.93%)",
                    maxHeight: "".concat(windowWidth > 768 ? introHeight + 140 : introHeight + 90, "px"),
                    transform: "rotate(0deg)",
                    marginTop: "0px"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (roomstay_blog_customer_case_list_card_module_default()).wrapperTag,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (roomstay_blog_customer_case_list_card_module_default()).tag,
                    dangerouslySetInnerHTML: {
                        __html: tag || ""
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: (roomstay_blog_customer_case_list_card_module_default()).title,
                dangerouslySetInnerHTML: {
                    __html: title || ""
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (roomstay_blog_customer_case_list_card_module_default()).wrapperCard,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (roomstay_blog_customer_case_list_card_module_default()).box,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, roomstay_blog_customer_case_list_card_options), {
                        children: cards === null || cards === void 0 ? void 0 : cards.map(function(card, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: classnames_default()((roomstay_blog_customer_case_list_card_module_default()).item),
                                    style: {
                                        background: "".concat(card.background)
                                    },
                                    children: [
                                        card.number && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (roomstay_blog_customer_case_list_card_module_default()).number,
                                            dangerouslySetInnerHTML: {
                                                __html: card.number
                                            }
                                        }),
                                        card.number2 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (roomstay_blog_customer_case_list_card_module_default()).number2,
                                            dangerouslySetInnerHTML: {
                                                __html: card.number2
                                            }
                                        }),
                                        card.title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: (roomstay_blog_customer_case_list_card_module_default()).title,
                                            dangerouslySetInnerHTML: {
                                                __html: card.title
                                            }
                                        }),
                                        card.subTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (roomstay_blog_customer_case_list_card_module_default()).subTitle,
                                            dangerouslySetInnerHTML: {
                                                __html: card.subTitle
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (roomstay_blog_customer_case_list_card_module_default()).description,
                                            dangerouslySetInnerHTML: {
                                                __html: card.description || ""
                                            }
                                        })
                                    ]
                                })
                            }, index);
                        })
                    }))
                })
            }),
            (ctaButton === null || ctaButton === void 0 ? void 0 : ctaButton.text) && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ButtonBookADemo, {
                className: (roomstay_blog_customer_case_list_card_module_default()).button,
                icon: false,
                iconFillColor: false,
                type: "highty",
                size: "default",
                htmlType: "button",
                sectionId: ctaButton === null || ctaButton === void 0 ? void 0 : ctaButton.href,
                children: (ctaButton === null || ctaButton === void 0 ? void 0 : ctaButton.text) || "Book a Demo"
            })
        ]
    });
};
/* harmony default export */ var roomstay_blog_customer_case_list_card = (roomstay_blog_customer_case_list_card_RoomStayBlogCustomerCaseListCard);

;// CONCATENATED MODULE: ./components/roomstay-blog-customer-case-list-card/roomstay-blog-customer-case-list-card.builder-component.ts

var RoomStayBlogCustomerCaseListCardBuilderConfig = {
    name: "Customer Case List Card",
    inputs: [
        {
            name: "tag",
            type: "string",
            defaultValue: ""
        },
        {
            name: "title",
            type: "html",
            defaultValue: ""
        },
        {
            name: "cards",
            type: "list",
            subFields: [
                {
                    name: "number",
                    type: "richText",
                    defaultValue: ""
                },
                {
                    name: "number2",
                    type: "richText",
                    defaultValue: ""
                },
                {
                    name: "title",
                    type: "richText",
                    defaultValue: ""
                },
                {
                    name: "subTitle",
                    type: "richText",
                    defaultValue: ""
                },
                {
                    name: "description",
                    type: "richText",
                    defaultValue: ""
                },
                {
                    name: "background",
                    type: "string",
                    defaultValue: ""
                }, 
            ]
        },
        {
            name: "ctaButton",
            type: "object",
            subFields: [
                {
                    name: "text",
                    type: "string"
                },
                {
                    name: "href",
                    type: "string"
                }, 
            ]
        },
        {
            name: "graphic",
            type: "file"
        }, 
    ]
};
var roomstay_blog_customer_case_list_card_builder_component_builderConfig = {
    component: roomstay_blog_customer_case_list_card,
    config: RoomStayBlogCustomerCaseListCardBuilderConfig
};
/* harmony default export */ var roomstay_blog_customer_case_list_card_builder_component = (roomstay_blog_customer_case_list_card_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/animations/FadeUpOnVisible.tsx
var FadeUpOnVisible = __webpack_require__(6892);
;// CONCATENATED MODULE: ./components/roomstay-blog-fade-up/roomstay-blog-fade-up.tsx


var RoomstayBlogFadeUp = function(props) {
    var autoPadding = props.autoPadding, children = props.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "container".concat(autoPadding ? " --padded" : ""),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FadeUpOnVisible/* default */.Z, {
            children: children
        })
    });
};
/* harmony default export */ var roomstay_blog_fade_up = (RoomstayBlogFadeUp);

;// CONCATENATED MODULE: ./components/roomstay-blog-fade-up/roomstay-blog-fade-up.builder-component.ts


var RoomstayBlogFadeUpBuilderConfig = {
    name: "Fade Up",
    inputs: [
        {
            name: "autoPadding",
            type: "boolean",
            defaultValue: true
        }, 
    ]
};
var roomstay_blog_fade_up_builder_component_builderConfig = {
    component: (0,builder_react_es5/* withChildren */.u7)(roomstay_blog_fade_up),
    config: RoomstayBlogFadeUpBuilderConfig
};
/* harmony default export */ var roomstay_blog_fade_up_builder_component = (roomstay_blog_fade_up_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/roomstay-blog-featured-articles/roomstay-blog-featured-articles.builder-component.ts
var roomstay_blog_featured_articles_builder_component = __webpack_require__(7998);
;// CONCATENATED MODULE: ./models/AnimationDelay.ts
var AnimationDelay;
(function(AnimationDelay) {
    AnimationDelay["A200"] = "--a-d-200";
    AnimationDelay["A400"] = "--a-d-400";
    AnimationDelay["A600"] = "--a-d-600";
    AnimationDelay["A800"] = "--a-d-800";
    AnimationDelay["A1S"] = "--a-d-1000";
})(AnimationDelay || (AnimationDelay = {}));
/* harmony default export */ var models_AnimationDelay = (AnimationDelay);

// EXTERNAL MODULE: ./components/roomstay-blog-featured-card/roomstay-blog-featured-card.module.scss
var roomstay_blog_featured_card_module = __webpack_require__(7166);
var roomstay_blog_featured_card_module_default = /*#__PURE__*/__webpack_require__.n(roomstay_blog_featured_card_module);
;// CONCATENATED MODULE: ./components/roomstay-blog-featured-card/roomstay-blog-featured-card.tsx






var RoomstayBlogFeaturedCard = function(props) {
    var classes = classnames_default()("row feature-card", {
        "--right": props.inverted,
        "--left": !props.inverted
    });
    var firstChildClasses = classnames_default()("col-md-6", {
        "offset-md-1": props.inverted
    });
    var secondChildClasses = classnames_default()("col-md-5", {
        "offset-md-1": !props.inverted
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: firstChildClasses,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FadeUpOnVisible/* default */.Z, {
                    delay: models_AnimationDelay.A200,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lazy_load_image/* LazyLoadImage */.e6, {
                        imageUrl: props.graphic || "",
                        className: (roomstay_blog_featured_card_module_default()).mw100
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: secondChildClasses,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FadeUpOnVisible/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: classnames_default()("headline ", {
                                "--medium": props.fontSize === "medium",
                                "--default": props.fontSize === "default"
                            }),
                            dangerouslySetInnerHTML: {
                                __html: props.title || ""
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                backgroundColor: props.dividerColor
                            },
                            className: "divider"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "body-text",
                            dangerouslySetInnerHTML: {
                                __html: props.description || ""
                            }
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var roomstay_blog_featured_card = (RoomstayBlogFeaturedCard);

;// CONCATENATED MODULE: ./components/roomstay-blog-featured-card/roomstay-blog-featured-card.builder-component.ts


var RoomstayBlogFeaturedCardBuilderConfig = {
    name: "Featured Card",
    inputs: [
        {
            name: "graphic",
            type: "file"
        },
        {
            name: "title",
            type: "html"
        },
        {
            name: "description",
            type: "html"
        },
        {
            name: "inverted",
            type: "boolean"
        },
        {
            name: "fontSize",
            type: "text",
            enum: [
                "default",
                "medium"
            ]
        },
        {
            name: "dividerColor",
            type: "color"
        }, 
    ]
};
var roomstay_blog_featured_card_builder_component_builderConfig = {
    component: (0,builder_react_es5/* withChildren */.u7)(roomstay_blog_featured_card),
    config: RoomstayBlogFeaturedCardBuilderConfig
};
/* harmony default export */ var roomstay_blog_featured_card_builder_component = (roomstay_blog_featured_card_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/roomstay-blog-sem-helpdesk-form/roomstay-blog-sem-helpdesk-form.module.scss
var roomstay_blog_sem_helpdesk_form_module = __webpack_require__(5421);
var roomstay_blog_sem_helpdesk_form_module_default = /*#__PURE__*/__webpack_require__.n(roomstay_blog_sem_helpdesk_form_module);
;// CONCATENATED MODULE: ./components/roomstay-blog-sem-helpdesk-form/roomstay-blog-sem-helpdesk-form.tsx










var RoomstaySemHelpdeskForm = function(props) {
    var titleForm = props.titleForm, description = props.description, padding = props.padding, fontSizeTitle = props.fontSizeTitle, successMessage = props.successMessage, buttonText = props.buttonText, showMessage = props.showMessage, _className = props.className, className = _className === void 0 ? "helpdesk-form" : _className;
    var formMethods = (0,dist_index_esm/* useForm */.cI)({
        mode: "onChange"
    });
    var ref = (0,react.useState)(false), sending = ref[0], setSending = ref[1];
    var ref1 = (0,react.useState)(false), success = ref1[0], setSuccess = ref1[1];
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var values, response;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setSending(true);
                        values = formMethods.getValues();
                        _ctx.prev = 2;
                        _ctx.next = 5;
                        return fetch("/api/book-demo", {
                            method: "POST",
                            body: JSON.stringify({
                                email: values.email,
                                message: values.message || " ",
                                forename: values.forename,
                                surname: values.surname,
                                companyName: values.companyName,
                                number: values.number,
                                formType: "PPC"
                            })
                        });
                    case 5:
                        response = _ctx.sent;
                        formMethods.reset();
                        setSuccess(response.ok);
                        setSending(false);
                        _ctx.next = 14;
                        break;
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](2);
                        setSending(false);
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    11
                ]
            ]);
        }));
        return function onSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((roomstay_blog_sem_helpdesk_form_module_default()).centeredBody, (roomstay_blog_sem_helpdesk_form_module_default())["centeredBody-padding-".concat(padding)]),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (roomstay_blog_sem_helpdesk_form_module_default()).container,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                onSubmit: formMethods.handleSubmit(onSubmit),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (classnames_default()((roomstay_blog_sem_helpdesk_form_module_default()).title), (roomstay_blog_sem_helpdesk_form_module_default())["title-font-".concat(fontSizeTitle)]),
                        children: titleForm
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (roomstay_blog_sem_helpdesk_form_module_default()).helpdeskInputs,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputGroup, {
                                dimensions: "2/2",
                                className: className,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (roomstay_blog_sem_helpdesk_form_module_default()).margBottom,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                            type: "text",
                                            required: true,
                                            className: "text-input",
                                            placeholder: "First name",
                                            tabIndex: 1
                                        }, formMethods.register("forename")))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (roomstay_blog_sem_helpdesk_form_module_default()).margBottom,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                            type: "text",
                                            required: true,
                                            className: "text-input",
                                            placeholder: "Last name",
                                            tabIndex: 1
                                        }, formMethods.register("surname")))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (roomstay_blog_sem_helpdesk_form_module_default()).margBottom,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                    type: "email",
                                    required: true,
                                    className: "text-input",
                                    placeholder: "Your Email",
                                    tabIndex: 1
                                }, formMethods.register("email")))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (roomstay_blog_sem_helpdesk_form_module_default()).margBottom,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                    type: "phone",
                                    required: true,
                                    className: "text-input",
                                    placeholder: "Your phone number",
                                    tabIndex: 1
                                }, formMethods.register("number")))
                            }),
                            showMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (roomstay_blog_sem_helpdesk_form_module_default()).margBottom,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", (0,_object_spread/* default */.Z)({
                                    className: "text-input",
                                    placeholder: "Your message",
                                    tabIndex: 1
                                }, formMethods.register("message")))
                            }),
                            !showMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (roomstay_blog_sem_helpdesk_form_module_default()).margBottom,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                    type: "companyName",
                                    required: true,
                                    className: "text-input",
                                    placeholder: "Your company name",
                                    tabIndex: 1
                                }, formMethods.register("companyName")))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "align-items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "body-text --small --cyan u-pad-right",
                                style: {
                                    opacity: success ? 1 : 0,
                                    marginBottom: 20
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: successMessage || "Thanks! Message sent."
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ButtonBookADemo, {
                                className: (roomstay_blog_sem_helpdesk_form_module_default()).button,
                                type: "secondary",
                                loading: sending,
                                htmlType: "submit",
                                theme: "black",
                                color: "white",
                                iconFillColor: true,
                                onSubmit: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                                    return runtime_default().wrap(function _callee$(_ctx) {
                                        while(1)switch(_ctx.prev = _ctx.next){
                                            case 0:
                                                _ctx.next = 2;
                                                return formMethods.handleSubmit(onSubmit)();
                                            case 2:
                                            case "end":
                                                return _ctx.stop();
                                        }
                                    }, _callee);
                                })),
                                style: {
                                    flexShrink: 1,
                                    display: "flex",
                                    whiteSpace: "nowrap",
                                    marginBottom: "0"
                                },
                                children: buttonText
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var roomstay_blog_sem_helpdesk_form = (RoomstaySemHelpdeskForm);

// EXTERNAL MODULE: ./components/roomstay-blog-footer-layout-2/roomstay-blog-footer-layout-2.module.scss
var roomstay_blog_footer_layout_2_module = __webpack_require__(1375);
var roomstay_blog_footer_layout_2_module_default = /*#__PURE__*/__webpack_require__.n(roomstay_blog_footer_layout_2_module);
;// CONCATENATED MODULE: ./components/roomstay-blog-footer-layout-2/roomstay-blog-footer-layout-2.tsx




var RoomstayBlogFooterLayout2 = function(props) {
    var title = props.title, description = props.description, buttonText = props.buttonText, titleForm = props.titleForm, _showMessage = props.showMessage, showMessage = _showMessage === void 0 ? true : _showMessage, _padding = props.padding, padding = _padding === void 0 ? "none" : _padding, _fontSizeTitle = props.fontSizeTitle, fontSizeTitle = _fontSizeTitle === void 0 ? "small" : _fontSizeTitle, showTextFooter = props.showTextFooter, headlineFooter = props.headlineFooter, subHeadlineFooter = props.subHeadlineFooter, buttonNameFooter = props.buttonNameFooter, buttonLinkFooter = props.buttonLinkFooter, idSection = props.idSection;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: idSection,
        className: "footer-book-a-demo-form-container",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "footer-book-a-demo-form--background-container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                        className: "background--curve",
                        width: "100%",
                        height: "100%",
                        viewBox: "0 0 1919 50",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M-1 50C-1 50 479 0 959 0C1439 0 1919 50 1919 50H-1Z",
                            fill: "#7C39FF"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "background--main"
                    })
                ]
            }),
            showTextFooter ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (roomstay_blog_footer_layout_2_module_default()).wrapperText,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(book_a_demo/* default */.Z, {
                    headline: headlineFooter,
                    subHeadline: subHeadlineFooter,
                    buttonName: buttonNameFooter,
                    buttonLink: buttonLinkFooter
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (roomstay_blog_footer_layout_2_module_default()).wrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (roomstay_blog_footer_layout_2_module_default()).increase,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: (roomstay_blog_footer_layout_2_module_default()).title,
                                dangerouslySetInnerHTML: {
                                    __html: title || ""
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (roomstay_blog_footer_layout_2_module_default()).description,
                                dangerouslySetInnerHTML: {
                                    __html: description || ""
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (roomstay_blog_footer_layout_2_module_default()).mail,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(roomstay_blog_sem_helpdesk_form, {
                            titleForm: titleForm,
                            fontSizeTitle: "small",
                            padding: "none",
                            buttonText: buttonText,
                            showMessage: showMessage
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var roomstay_blog_footer_layout_2 = (RoomstayBlogFooterLayout2);

;// CONCATENATED MODULE: ./components/roomstay-blog-footer-layout-2/roomstay-blog-footer-layout-2.builder-component.ts

var RoomstayBlogFooterLayout2BuilderConfig = {
    name: "Footer Layout 2",
    inputs: [
        {
            name: "title",
            type: "html"
        },
        {
            name: "description",
            type: "html"
        },
        {
            name: "buttonText",
            type: "string"
        },
        {
            name: "titleForm",
            type: "string"
        },
        {
            name: "showTextFooter",
            type: "boolean"
        },
        {
            name: "showIconButton",
            type: "boolean"
        },
        {
            name: "headlineFooter",
            type: "html"
        },
        {
            name: "subHeadlineFooter",
            type: "html"
        },
        {
            name: "buttonNameFooter",
            type: "string"
        },
        {
            name: "buttonLinkFooter",
            type: "string"
        },
        {
            name: "idSection",
            type: "string"
        }, 
    ]
};
var roomstay_blog_footer_layout_2_builder_component_builderConfig = {
    component: roomstay_blog_footer_layout_2,
    config: RoomstayBlogFooterLayout2BuilderConfig
};
/* harmony default export */ var roomstay_blog_footer_layout_2_builder_component = (roomstay_blog_footer_layout_2_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/roomstay-blog-increase/roomstay-blog-increase.module.scss
var roomstay_blog_increase_module = __webpack_require__(5721);
var roomstay_blog_increase_module_default = /*#__PURE__*/__webpack_require__.n(roomstay_blog_increase_module);
;// CONCATENATED MODULE: ./components/roomstay-blog-increase/roomstay-blog-increase.tsx


var RoomstayBlogIncrease = function(props) {
    var title = props.title, booking = props.booking, revenue = props.revenue, aov = props.aov, extra = props.extra, description = props.description;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (roomstay_blog_increase_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (roomstay_blog_increase_module_default()).title,
                children: [
                    "With ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        style: {
                            background: "#6333C6"
                        },
                        children: "RoomStay"
                    }),
                    " you can increase:"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (roomstay_blog_increase_module_default()).booking,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (roomstay_blog_increase_module_default()).icon,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "32",
                            height: "32",
                            viewBox: "0 0 32 32",
                            fill: "none",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M26.6667 9.33331H5.33335C3.86059 9.33331 2.66669 10.5272 2.66669 12V25.3333C2.66669 26.8061 3.86059 28 5.33335 28H26.6667C28.1394 28 29.3334 26.8061 29.3334 25.3333V12C29.3334 10.5272 28.1394 9.33331 26.6667 9.33331Z",
                                    stroke: "white",
                                    strokeWidth: "3",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M21.3334 28V6.66667C21.3334 5.95942 21.0524 5.28115 20.5523 4.78105C20.0522 4.28095 19.3739 4 18.6667 4H13.3334C12.6261 4 11.9478 4.28095 11.4477 4.78105C10.9476 5.28115 10.6667 5.95942 10.6667 6.66667V28",
                                    stroke: "white",
                                    strokeWidth: "3",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (roomstay_blog_increase_module_default()).wrapper,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (roomstay_blog_increase_module_default()).text,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "Bookings onsite by up to "
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (roomstay_blog_increase_module_default()).inputText,
                                children: "190%"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (roomstay_blog_increase_module_default()).booking,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (roomstay_blog_increase_module_default()).icon,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "32",
                            height: "32",
                            viewBox: "0 0 32 32",
                            fill: "none",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M28.28 21.1866C27.4318 23.1926 26.1051 24.9603 24.4158 26.3351C22.7266 27.7098 20.7264 28.6499 18.5899 29.073C16.4535 29.4962 14.2459 29.3895 12.1602 28.7624C10.0745 28.1352 8.17418 27.0067 6.62537 25.4755C5.07656 23.9443 3.92643 22.057 3.27552 19.9786C2.62462 17.9002 2.49276 15.694 2.89147 13.5528C3.29019 11.4117 4.20734 9.40082 5.56274 7.69602C6.91814 5.99122 8.67052 4.64441 10.6667 3.77332",
                                    stroke: "white",
                                    strokeWidth: "3",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M29.3333 16C29.3333 14.2491 28.9885 12.5152 28.3184 10.8976C27.6483 9.2799 26.6662 7.81004 25.4281 6.57193C24.19 5.33382 22.7201 4.35169 21.1024 3.68163C19.4848 3.01156 17.751 2.66669 16 2.66669V16H29.3333Z",
                                    stroke: "white",
                                    strokeWidth: "3",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (roomstay_blog_increase_module_default()).wrapper,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (roomstay_blog_increase_module_default()).text,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "Revenue growth YOY by"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (roomstay_blog_increase_module_default()).inputText,
                                children: "90%"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (roomstay_blog_increase_module_default()).booking,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (roomstay_blog_increase_module_default()).icon,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "32",
                            height: "32",
                            viewBox: "0 0 32 32",
                            fill: "none",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                    clipPath: "url(#clip0_15520_3494)",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M30.6666 8L18 20.6667L11.3333 14L1.33331 24",
                                            stroke: "white",
                                            strokeWidth: "3",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M22.6667 8H30.6667V16",
                                            stroke: "white",
                                            strokeWidth: "3",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                                        id: "clip0_15520_3494",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                            width: "32",
                                            height: "32",
                                            fill: "white"
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (roomstay_blog_increase_module_default()).wrapper,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (roomstay_blog_increase_module_default()).text,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "Savings in monthly OTA fees* by"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (roomstay_blog_increase_module_default()).inputText,
                                children: "$50k+"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (roomstay_blog_increase_module_default()).extra,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (roomstay_blog_increase_module_default()).icon,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "32",
                            height: "32",
                            viewBox: "0 0 32 32",
                            fill: "none",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M26.6666 16V29.3333H5.33331V16",
                                    stroke: "white",
                                    strokeWidth: "3",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M29.3334 9.33331H2.66669V16H29.3334V9.33331Z",
                                    stroke: "white",
                                    strokeWidth: "3",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M16 29.3333V9.33331",
                                    stroke: "white",
                                    strokeWidth: "3",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M16 9.33335H10C9.11597 9.33335 8.26812 8.98216 7.643 8.35704C7.01788 7.73192 6.66669 6.88408 6.66669 6.00002C6.66669 5.11597 7.01788 4.26812 7.643 3.643C8.26812 3.01788 9.11597 2.66669 10 2.66669C14.6667 2.66669 16 9.33335 16 9.33335Z",
                                    stroke: "white",
                                    strokeWidth: "3",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M16 9.33335H22C22.8841 9.33335 23.7319 8.98216 24.357 8.35704C24.9821 7.73192 25.3333 6.88408 25.3333 6.00002C25.3333 5.11597 24.9821 4.26812 24.357 3.643C23.7319 3.01788 22.8841 2.66669 22 2.66669C17.3333 2.66669 16 9.33335 16 9.33335Z",
                                    stroke: "white",
                                    strokeWidth: "3",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (roomstay_blog_increase_module_default()).wrapper,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (roomstay_blog_increase_module_default()).text,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "Extra data points collected per day"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (roomstay_blog_increase_module_default()).inputText,
                                children: [
                                    "10,000",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                        children: "'"
                                    }),
                                    "s"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (roomstay_blog_increase_module_default()).description,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "Start increasing your direct revenue today by giving your guests the seamless booking experience they deserve."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "* Based on average customer data from 2024"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var roomstay_blog_increase = (RoomstayBlogIncrease);

// EXTERNAL MODULE: ./components/roomstay-blog-footer-layout-form/roomstay-blog-footer-layout-form.module.scss
var roomstay_blog_footer_layout_form_module = __webpack_require__(9486);
var roomstay_blog_footer_layout_form_module_default = /*#__PURE__*/__webpack_require__.n(roomstay_blog_footer_layout_form_module);
;// CONCATENATED MODULE: ./components/roomstay-blog-footer-layout-form/roomstay-blog-footer-layout-form.tsx





var RoomstayBlogFooterLayoutForm = function(props) {
    var buttonText = props.buttonText, titleForm = props.titleForm, _showMessage = props.showMessage, showMessage = _showMessage === void 0 ? true : _showMessage, _padding = props.padding, padding = _padding === void 0 ? "none" : _padding, _fontSizeTitle = props.fontSizeTitle, fontSizeTitle = _fontSizeTitle === void 0 ? "small" : _fontSizeTitle, showTextFooter = props.showTextFooter, headlineFooter = props.headlineFooter, subHeadlineFooter = props.subHeadlineFooter, buttonNameFooter = props.buttonNameFooter, buttonLinkFooter = props.buttonLinkFooter;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "footer-book-a-demo-form-container",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "footer-book-a-demo-form--background-container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                        className: "background--curve",
                        width: "100%",
                        height: "100%",
                        viewBox: "0 0 1919 50",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M-1 50C-1 50 479 0 959 0C1439 0 1919 50 1919 50H-1Z",
                            fill: "#7C39FF"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "background--main"
                    })
                ]
            }),
            showTextFooter ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (roomstay_blog_footer_layout_form_module_default()).wrapperText,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(book_a_demo/* default */.Z, {
                    headline: headlineFooter,
                    subHeadline: subHeadlineFooter,
                    buttonName: buttonNameFooter,
                    buttonLink: buttonLinkFooter
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (roomstay_blog_footer_layout_form_module_default()).wrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (roomstay_blog_footer_layout_form_module_default()).increase,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(roomstay_blog_increase, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (roomstay_blog_footer_layout_form_module_default()).divider
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (roomstay_blog_footer_layout_form_module_default()).mail,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(roomstay_blog_sem_helpdesk_form, {
                            titleForm: titleForm,
                            fontSizeTitle: "small",
                            padding: "none",
                            buttonText: buttonText,
                            showMessage: showMessage
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var roomstay_blog_footer_layout_form = (RoomstayBlogFooterLayoutForm);

;// CONCATENATED MODULE: ./components/roomstay-blog-footer-layout-form/roomstay-blog-footer-layout-form.builder-component.ts

var RoomstayBlogFooterLayoutFormBuilderConfig = {
    name: "Footer Layout Forms",
    inputs: [
        {
            name: "buttonText",
            type: "string"
        },
        {
            name: "titleForm",
            type: "string"
        },
        {
            name: "showTextFooter",
            type: "boolean"
        },
        {
            name: "headlineFooter",
            type: "html"
        },
        {
            name: "subHeadlineFooter",
            type: "html"
        },
        {
            name: "buttonNameFooter",
            type: "string"
        },
        {
            name: "buttonLinkFooter",
            type: "string"
        }, 
    ]
};
var roomstay_blog_footer_layout_form_builder_component_builderConfig = {
    component: roomstay_blog_footer_layout_form,
    config: RoomstayBlogFooterLayoutFormBuilderConfig
};
/* harmony default export */ var roomstay_blog_footer_layout_form_builder_component = (roomstay_blog_footer_layout_form_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/roomstay-blog-hero-pricing/roomstay-blog-hero-pricing.module.scss
var roomstay_blog_hero_pricing_module = __webpack_require__(9079);
var roomstay_blog_hero_pricing_module_default = /*#__PURE__*/__webpack_require__.n(roomstay_blog_hero_pricing_module);
;// CONCATENATED MODULE: ./components/roomstay-blog-hero-pricing/roomstay-blog-hero-pricing.tsx






var RoomStayBlogHeroPricing = function(props) {
    var title = props.title, subTitle = props.subTitle, subDescription = props.subDescription, description = props.description, cardPricing = props.cardPricing;
    var ref = (0,_sliced_to_array/* default */.Z)((0,esm/* useElementSize */.h4)(), 2), containerRef = ref[0], height = ref[1].height;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,esm/* useElementSize */.h4)(), 2), introRef = ref1[0], ref2 = ref1[1], introHeight = ref2.height;
    var ref3 = (0,esm/* useWindowSize */.iP)(), windowWidth = ref3.width;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: containerRef,
        className: (roomstay_blog_hero_pricing_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(clipped_box/* default */.Z, {
                configs: [
                    {
                        rad: Math.atan(405 / 1920),
                        position: clipped_box/* POSITION.BottomRight */.V.BottomRight
                    }, 
                ],
                className: (roomstay_blog_hero_pricing_module_default()).background,
                style: {
                    backgroundColor: "#F1ECFF",
                    maxHeight: "".concat(windowWidth > 768 ? introHeight + 1000 : introHeight + 1100, "px")
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (roomstay_blog_hero_pricing_module_default()).wrapperContent,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (roomstay_blog_hero_pricing_module_default()).content,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (roomstay_blog_hero_pricing_module_default()).contentIntro,
                            children: [
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (roomstay_blog_hero_pricing_module_default()).subTitle,
                                    children: subTitle
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: (roomstay_blog_hero_pricing_module_default()).title,
                                    dangerouslySetInnerHTML: {
                                        __html: title || ""
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (roomstay_blog_hero_pricing_module_default()).subDescription,
                                    children: subDescription
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (roomstay_blog_hero_pricing_module_default()).description,
                                    dangerouslySetInnerHTML: {
                                        __html: description || ""
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(roomstay_blog_card_pricing, {
                            contentText: {
                                subTitle: cardPricing === null || cardPricing === void 0 ? void 0 : cardPricing.subTitle,
                                title: cardPricing === null || cardPricing === void 0 ? void 0 : cardPricing.title,
                                description: cardPricing === null || cardPricing === void 0 ? void 0 : cardPricing.description
                            },
                            contentForm: {
                                successMessage: cardPricing === null || cardPricing === void 0 ? void 0 : cardPricing.successMessage
                            }
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var roomstay_blog_hero_pricing = (RoomStayBlogHeroPricing);

;// CONCATENATED MODULE: ./components/roomstay-blog-hero-pricing/roomstay-blog-hero-pricing.builder-component.ts

var RoomstayBlogHeroPricingBuilderConfig = {
    name: "Hero Pricing",
    inputs: [
        {
            name: "subTitle",
            type: "string"
        },
        {
            name: "title",
            type: "html"
        },
        {
            name: "subDescription",
            type: "string"
        },
        {
            name: "description",
            type: "html"
        },
        {
            name: "cardPricing",
            type: "object",
            subFields: [
                {
                    name: "subTitle",
                    type: "html"
                },
                {
                    name: "title",
                    type: "html"
                },
                {
                    name: "description",
                    type: "html"
                },
                {
                    name: "link",
                    type: "url"
                },
                {
                    name: "successMessage",
                    type: "string"
                }, 
            ]
        }, 
    ]
};
var roomstay_blog_hero_pricing_builder_component_builderConfig = {
    component: roomstay_blog_hero_pricing,
    config: RoomstayBlogHeroPricingBuilderConfig
};
/* harmony default export */ var roomstay_blog_hero_pricing_builder_component = (roomstay_blog_hero_pricing_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/roomstay-blog-hero-product/roomstay-blog-hero-product.module.scss
var roomstay_blog_hero_product_module = __webpack_require__(7085);
var roomstay_blog_hero_product_module_default = /*#__PURE__*/__webpack_require__.n(roomstay_blog_hero_product_module);
;// CONCATENATED MODULE: ./components/roomstay-blog-hero-product/roomstay-blog-hero-product.tsx








var RoomStayBlogHeroProduct = function(props) {
    var image = props.image, content = props.content, onClick = props.onClick;
    var ref = (0,_sliced_to_array/* default */.Z)((0,esm/* useElementSize */.h4)(), 2), containerRef = ref[0], height = ref[1].height;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,esm/* useElementSize */.h4)(), 2), introRef = ref1[0], ref2 = ref1[1], introHeight = ref2.height;
    var ref3 = (0,esm/* useWindowSize */.iP)(), windowWidth = ref3.width;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: containerRef,
        className: (roomstay_blog_hero_product_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(clipped_box/* default */.Z, {
                configs: [
                    {
                        rad: Math.atan(260 / 1920),
                        position: clipped_box/* POSITION.BottomRight */.V.BottomRight
                    }, 
                ],
                className: (roomstay_blog_hero_product_module_default()).background,
                style: {
                    backgroundColor: "#F3F3F5",
                    maxHeight: "calc(100% - ".concat(height / 7 * 2, "px)")
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (roomstay_blog_hero_product_module_default()).wrapperContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (roomstay_blog_hero_product_module_default()).wrapperContent,
                    ref: introRef,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (roomstay_blog_hero_product_module_default()).contentLeft,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (roomstay_blog_hero_product_module_default()).wrapperImage,
                                children: image ? /*#__PURE__*/ (0,jsx_runtime.jsx)(lazy_load_image/* LazyLoadImage */.e6, {
                                    objectFit: "contain",
                                    imageUrl: image
                                }) : null
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (roomstay_blog_hero_product_module_default()).contentText,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (roomstay_blog_hero_product_module_default()).subTitle,
                                    dangerouslySetInnerHTML: {
                                        __html: (content === null || content === void 0 ? void 0 : content.subTitle) || ""
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (roomstay_blog_hero_product_module_default()).title,
                                    dangerouslySetInnerHTML: {
                                        __html: (content === null || content === void 0 ? void 0 : content.title) || ""
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (roomstay_blog_hero_product_module_default()).button,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                        theme: "blackCurrant",
                                        link: content === null || content === void 0 ? void 0 : content.linkUrl,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (roomstay_blog_hero_product_module_default()).content,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "Book a Demo"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                    width: "32",
                                                    height: "32",
                                                    viewBox: "0 0 32 32",
                                                    fill: "none",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M6.66667 16H25.3333",
                                                            stroke: "white",
                                                            strokeWidth: "2",
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M16 6.66675L25.3333 16.0001L16 25.3334",
                                                            stroke: "white",
                                                            strokeWidth: "2",
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var roomstay_blog_hero_product = (RoomStayBlogHeroProduct);

;// CONCATENATED MODULE: ./components/roomstay-blog-hero-product/roomstay-blog-hero-product.builder-component.ts

var RoomStayBlogHeroProductBuilderConfig = {
    name: "Hero Product",
    inputs: [
        {
            name: "image",
            type: "file"
        },
        {
            name: "content",
            type: "object",
            subFields: [
                {
                    name: "subTitle",
                    type: "html",
                    defaultValue: "Sub Title"
                },
                {
                    name: "title",
                    type: "html",
                    defaultValue: "Title"
                },
                {
                    name: "linkUrl",
                    type: "url"
                }, 
            ]
        }, 
    ]
};
var roomstay_blog_hero_product_builder_component_builderConfig = {
    component: roomstay_blog_hero_product,
    config: RoomStayBlogHeroProductBuilderConfig
};
/* harmony default export */ var roomstay_blog_hero_product_builder_component = (roomstay_blog_hero_product_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/roomstay-blog-highlight-article/roomstay-blog-highlight-article.builder-component.ts
var roomstay_blog_highlight_article_builder_component = __webpack_require__(4490);
;// CONCATENATED MODULE: ./components/roomstay-blog-home-headline/roomstay-blog-home-headline.tsx



var RoomstayBlogHomeHeadline = function(param) {
    var text = param.text;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FadeUpOnVisible/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "d-flex align-items-center flex-column mt-5",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "headline --centered --larger",
                    dangerouslySetInnerHTML: {
                        __html: text || ""
                    }
                })
            })
        })
    });
};
/* harmony default export */ var roomstay_blog_home_headline = (RoomstayBlogHomeHeadline);

;// CONCATENATED MODULE: ./components/roomstay-blog-home-headline/roomstay-blog-home-headline.builder-component.ts

var RoomstayBlogHomeHeadlineBuilderConfig = {
    name: "Home Headline",
    inputs: [
        {
            name: "text",
            type: "html"
        }, 
    ]
};
var roomstay_blog_home_headline_builder_component_builderConfig = {
    component: roomstay_blog_home_headline,
    config: RoomstayBlogHomeHeadlineBuilderConfig
};
/* harmony default export */ var roomstay_blog_home_headline_builder_component = (roomstay_blog_home_headline_builder_component_builderConfig);

;// CONCATENATED MODULE: ./components/InfoBlock.tsx


function InfoBlock(props) {
    var _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "info-block " + "--".concat((_color = props.color) !== null && _color !== void 0 ? _color : "purple"),
        children: props.text
    });
};

;// CONCATENATED MODULE: ./components/HomepageDemoBlock.tsx



function HomepageDemoBlock(param) {
    var imageMain = param.imageMain, imageTop = param.imageTop, textCenter = param.textCenter, textBottom = param.textBottom;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "homepage-demo-block",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "homepage-demo-block--inner",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "homepage-demo-block--background",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lazy_load_image/* LazyLoadImage */.e6, {
                        width: 670,
                        height: 486,
                        layout: "intrinsic",
                        imageUrl: imageMain || "/assets/img/frontpage_image.webp",
                        alt: "Booking Engine Image",
                        unoptimized: true
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "homepage-demo-block--member-only-deal",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lazy_load_image/* LazyLoadImage */.e6, {
                        width: 580,
                        height: 170,
                        layout: "intrinsic",
                        imageUrl: imageTop || "/assets/img/member_only_deal.webp",
                        alt: "Member only Deal",
                        relativeContainer: false,
                        unoptimized: true
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "wrapperInfoBlock",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "homepage-demo-block--checkout",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoBlock, {
                                text: (textCenter === null || textCenter === void 0 ? void 0 : textCenter.text) || "Best in class UX for seamless checkout",
                                color: (textCenter === null || textCenter === void 0 ? void 0 : textCenter.color) || "purple"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "homepage-demo-block--no-exit",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoBlock, {
                                text: (textBottom === null || textBottom === void 0 ? void 0 : textBottom.text) || "No exit click from your hotel website",
                                color: (textBottom === null || textBottom === void 0 ? void 0 : textBottom.color) || "pink"
                            })
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./shared/env.ts
var env = __webpack_require__(7964);
;// CONCATENATED MODULE: ./components/roomstay-blog-home-hero/roomstay-blog-home-hero.tsx



var RoomstayBlogHomeHero = function(param) {
    var leftContentBlock = param.leftContentBlock, rightContentBlock = param.rightContentBlock;
    var ref, ref1, ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "centered-body --no-min-height",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "container",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row align-items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-xl-5",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "u-marg-bottom",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: "headline",
                                    dangerouslySetInnerHTML: {
                                        __html: (leftContentBlock === null || leftContentBlock === void 0 ? void 0 : leftContentBlock.title) || ""
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "u-marg-bottom--large",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "body-text --large",
                                    dangerouslySetInnerHTML: {
                                        __html: (leftContentBlock === null || leftContentBlock === void 0 ? void 0 : leftContentBlock.description) || ""
                                    }
                                })
                            }),
                            (leftContentBlock === null || leftContentBlock === void 0 ? void 0 : (ref = leftContentBlock.ctaButton) === null || ref === void 0 ? void 0 : ref.text) && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: (leftContentBlock === null || leftContentBlock === void 0 ? void 0 : (ref1 = leftContentBlock.ctaButton) === null || ref1 === void 0 ? void 0 : ref1.href) || "mailto:".concat(env/* NOREPLY_EMAIL */.dk),
                                className: "btn --primary",
                                children: leftContentBlock === null || leftContentBlock === void 0 ? void 0 : (ref2 = leftContentBlock.ctaButton) === null || ref2 === void 0 ? void 0 : ref2.text
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-xl-7",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HomepageDemoBlock, {
                            imageMain: rightContentBlock === null || rightContentBlock === void 0 ? void 0 : rightContentBlock.imageMain,
                            imageTop: rightContentBlock === null || rightContentBlock === void 0 ? void 0 : rightContentBlock.imageTop,
                            textCenter: rightContentBlock === null || rightContentBlock === void 0 ? void 0 : rightContentBlock.textCenter,
                            textBottom: rightContentBlock === null || rightContentBlock === void 0 ? void 0 : rightContentBlock.textBottom
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var roomstay_blog_home_hero = (RoomstayBlogHomeHero);

;// CONCATENATED MODULE: ./components/roomstay-blog-home-hero/roomstay-blog-home-hero.builder-component.ts

var RoomstayBlogHomeHeroBuilderConfig = {
    name: "Home Hero",
    inputs: [
        {
            name: "leftContentBlock",
            type: "object",
            subFields: [
                {
                    name: "title",
                    type: "html"
                },
                {
                    name: "description",
                    type: "html"
                },
                {
                    name: "ctaButton",
                    type: "object",
                    subFields: [
                        {
                            name: "text",
                            type: "string"
                        },
                        {
                            name: "href",
                            type: "string"
                        }, 
                    ]
                }, 
            ]
        },
        {
            name: "rightContentBlock",
            type: "object",
            subFields: [
                {
                    name: "imageMain",
                    type: "file"
                },
                {
                    name: "imageTop",
                    type: "file"
                },
                {
                    name: "textCenter",
                    type: "object",
                    subFields: [
                        {
                            name: "text",
                            type: "string"
                        },
                        {
                            name: "color",
                            type: "string",
                            enum: [
                                "purple",
                                "pink"
                            ]
                        }, 
                    ]
                },
                {
                    name: "textBottom",
                    type: "object",
                    subFields: [
                        {
                            name: "text",
                            type: "string"
                        },
                        {
                            name: "color",
                            type: "string",
                            enum: [
                                "purple",
                                "pink"
                            ]
                        }, 
                    ]
                }, 
            ]
        }, 
    ]
};
var roomstay_blog_home_hero_builder_component_builderConfig = {
    component: roomstay_blog_home_hero,
    config: RoomstayBlogHomeHeroBuilderConfig
};
/* harmony default export */ var roomstay_blog_home_hero_builder_component = (roomstay_blog_home_hero_builder_component_builderConfig);

;// CONCATENATED MODULE: ./components/roomstay-blog-home-image-block/roomstay-blog-home-image-block.tsx


var RoomstayBlogHomeImageBlock = function(param) {
    var image = param.image, title = param.title, description = param.description;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "container --padded",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "row align-items-center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-md-5",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "homepage-contained-image",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lazy_load_image/* LazyLoadImage */.e6, {
                            width: 700,
                            height: 467,
                            className: "bordered-image",
                            objectFit: "cover",
                            layout: "responsive",
                            imageUrl: image || "",
                            alt: "What Roomstay Solves Image"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "col-md-6 offset-md-1",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "headline --secondary --with-spacer",
                            dangerouslySetInnerHTML: {
                                __html: title || ""
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "body-text",
                            dangerouslySetInnerHTML: {
                                __html: description || ""
                            }
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var roomstay_blog_home_image_block = (RoomstayBlogHomeImageBlock);

;// CONCATENATED MODULE: ./components/roomstay-blog-home-image-block/roomstay-blog-home-image-block.builder-component.ts

var RoomstayBlogHomeImageBlockBuilderConfig = {
    name: "Home Image Block",
    inputs: [
        {
            name: "image",
            type: "file"
        },
        {
            name: "title",
            type: "html"
        },
        {
            name: "description",
            type: "html"
        }, 
    ]
};
var roomstay_blog_home_image_block_builder_component_builderConfig = {
    component: roomstay_blog_home_image_block,
    config: RoomstayBlogHomeImageBlockBuilderConfig
};
/* harmony default export */ var roomstay_blog_home_image_block_builder_component = (roomstay_blog_home_image_block_builder_component_builderConfig);

;// CONCATENATED MODULE: ./components/Card.tsx




function Card(props) {
    var theme = (props === null || props === void 0 ? void 0 : props.color) === "purple";
    var _obj;
    var classes = classnames_default()("card", (_obj = {}, (0,_define_property/* default */.Z)(_obj, props.color ? "--".concat(props.color) : "--primary", true), (0,_define_property/* default */.Z)(_obj, props.minheight ? "--mh".concat(props.minheight) : "", true), (0,_define_property/* default */.Z)(_obj, "--theme", theme), _obj));
    var setIcon = props.showIcon;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "content",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "headline --smaller --with-spacer",
                        dangerouslySetInnerHTML: {
                            __html: props.title
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "body-text",
                        dangerouslySetInnerHTML: {
                            __html: props.description
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "cardIcon",
                children: setIcon && props.icon
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/roomstay-blog-home-introduction/roomstay-blog-home-introduction.tsx





var roomstay_blog_home_introduction_EColor;
(function(EColor) {
    EColor["White"] = "White";
    EColor["Dark"] = "Dark";
})(roomstay_blog_home_introduction_EColor || (roomstay_blog_home_introduction_EColor = {}));
var SPACING_CONTENT;
(function(SPACING_CONTENT) {
    SPACING_CONTENT["baseSpace"] = "base-space";
    SPACING_CONTENT["small"] = "small";
    SPACING_CONTENT["large"] = "large";
    SPACING_CONTENT["largest"] = "largest";
})(SPACING_CONTENT || (SPACING_CONTENT = {}));
var spacingContent = {};
var STYLE_TITLE;
(function(STYLE_TITLE) {
    STYLE_TITLE["centered"] = "centered";
    STYLE_TITLE["normal"] = "normal";
})(STYLE_TITLE || (STYLE_TITLE = {}));
var RoomstayBlogHomeIntroduction = function(param) {
    var title = param.title, spacingContent = param.spacingContent, styleTitle = param.styleTitle, tmp = param.cards, ref = (0,_sliced_to_array/* default */.Z)(tmp === void 0 ? [] : tmp, 3), card1 = ref[0], card2 = ref[1], card3 = ref[2];
    var ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "container --padded",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FadeUpOnVisible/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "d-flex align-items-center flex-column u-marg-bottom--".concat(spacingContent || "largest"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "headline --".concat(styleTitle || "centered"),
                        dangerouslySetInnerHTML: {
                            __html: title || ""
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-md-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FadeUpOnVisible/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card, {
                                title: (card1 === null || card1 === void 0 ? void 0 : card1.title) || "",
                                description: (card1 === null || card1 === void 0 ? void 0 : card1.content) || "",
                                color: (ref1 = card1 === null || card1 === void 0 ? void 0 : card1.background) !== null && ref1 !== void 0 ? ref1 : "secondary",
                                showIcon: (ref2 = !(card1 === null || card1 === void 0 ? void 0 : card1.hideIcon)) !== null && ref2 !== void 0 ? ref2 : true,
                                minheight: (card1 === null || card1 === void 0 ? void 0 : card1.minHeight) ? "".concat(card1 === null || card1 === void 0 ? void 0 : card1.minHeight) : undefined,
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                    width: "40",
                                    height: "40",
                                    viewBox: "0 0 40 40",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                            clipPath: "url(#clip0)",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M38.5957 33.7297H34.5187V25.6663C34.5187 24.8962 33.9298 24.3073 33.1597 24.3073C32.3896 24.3073 31.8007 24.8962 31.8007 25.6663V33.7297H27.9049V22.903C27.9049 22.1329 27.316 21.544 26.5459 21.544C25.7758 21.544 25.1869 22.1329 25.1869 22.903V33.7297H21.3364V26.7535C21.3364 25.9834 20.7475 25.3945 19.9774 25.3945C19.2072 25.3945 18.6183 25.9834 18.6183 26.7535V33.7297H14.7678V21.2722C14.7678 20.5021 14.1789 19.9132 13.4088 19.9132C12.6387 19.9132 12.0498 20.5021 12.0498 21.2722V33.7297H8.15402V27.2971C8.15402 26.527 7.56512 25.9381 6.79502 25.9381C6.02492 25.9381 5.43601 26.527 5.43601 27.2971V33.7297H1.359C0.588901 33.7297 0 34.3186 0 35.0887C0 35.8588 0.588901 36.4478 1.359 36.4478H38.641C39.4111 36.4478 40 35.8588 40 35.0887C40 34.3186 39.3658 33.7297 38.5957 33.7297Z",
                                                    fill: "".concat((ref3 = card1 === null || card1 === void 0 ? void 0 : card1.iconFillColor) !== null && ref3 !== void 0 ? ref3 : "white")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M5.57191 16.8645C5.88901 16.8645 6.25141 16.7286 6.52321 16.5021L13.4541 9.84294L20.6568 15.5055C21.1552 15.9132 21.8347 15.9132 22.333 15.5055L32.1178 7.84974L31.8007 11.8814C31.7554 12.6515 32.299 13.2857 33.0691 13.331C33.1144 13.331 33.1597 13.331 33.1597 13.331C33.8845 13.331 34.4734 12.7874 34.5187 12.0626L35.0623 4.99584C35.0623 4.95054 35.0623 4.90524 35.0623 4.85994C35.0623 4.54284 34.9717 4.27104 34.7905 3.99924C34.4734 3.59154 33.9751 3.41034 33.4768 3.50094L26.1835 3.00263C25.4134 2.95733 24.7792 3.50093 24.7339 4.27104C24.6886 5.04114 25.2322 5.67534 26.0023 5.72064L30.034 5.99244L21.4723 12.6968L14.1789 6.94374C13.6353 6.53604 12.8652 6.58134 12.4122 7.03434L4.62061 14.5089C4.07701 15.0072 4.07701 15.8679 4.57531 16.4115C4.84711 16.7286 5.20951 16.8645 5.57191 16.8645Z",
                                                    fill: "".concat((ref4 = card1 === null || card1 === void 0 ? void 0 : card1.iconFillColor) !== null && ref4 !== void 0 ? ref4 : "white")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                                                id: "clip0",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                                    width: "40",
                                                    height: "40",
                                                    fill: "".concat((ref5 = card1 === null || card1 === void 0 ? void 0 : card1.iconFillColor) !== null && ref5 !== void 0 ? ref5 : "white")
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-md-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FadeUpOnVisible/* default */.Z, {
                            delay: models_AnimationDelay.A200,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card, {
                                title: (card2 === null || card2 === void 0 ? void 0 : card2.title) || "",
                                description: (card2 === null || card2 === void 0 ? void 0 : card2.content) || "",
                                showIcon: (ref6 = !card2.hideIcon) !== null && ref6 !== void 0 ? ref6 : true,
                                minheight: (card2 === null || card2 === void 0 ? void 0 : card2.minHeight) ? "".concat(card2 === null || card2 === void 0 ? void 0 : card2.minHeight) : undefined,
                                color: (ref7 = card2 === null || card2 === void 0 ? void 0 : card2.background) !== null && ref7 !== void 0 ? ref7 : "cyan",
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                    width: "40",
                                    height: "40",
                                    viewBox: "0 0 40 40",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M21.6026 12.3294C20.8062 13.1243 20.3582 14.2172 20.3582 15.4095C20.3582 16.6017 20.8062 17.645 21.6026 18.4895C22.4487 19.2843 23.5438 19.7314 24.6887 19.7314C25.7837 19.7314 26.9285 19.334 27.725 18.4895C29.3675 16.8501 29.3675 14.0185 27.725 12.3791C26.0824 10.6901 23.2452 10.6901 21.6026 12.3294ZM25.6344 16.3533C25.1366 16.8501 24.2407 16.8501 23.6931 16.3533C23.4443 16.1049 23.3447 15.7572 23.3447 15.4095C23.3447 15.0617 23.494 14.714 23.7429 14.4656C24.2407 13.9688 25.1864 13.9688 25.6842 14.4656C26.1321 14.9624 26.1321 15.8566 25.6344 16.3533Z",
                                            fill: "".concat((ref8 = card2 === null || card2 === void 0 ? void 0 : card2.iconFillColor) !== null && ref8 !== void 0 ? ref8 : "#1C1624")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M38.3271 0.00931459C38.7751 -0.0403633 39.2231 0.108671 39.5715 0.456416C39.9199 0.804161 40.0693 1.25126 39.9697 1.64868L38.6258 12.9256C38.576 13.2733 38.4267 13.5714 38.1778 13.8198L34.0464 17.943L34.594 25.196C34.6437 25.5934 34.4944 25.9908 34.2455 26.2889L26.6797 35.2806C26.381 35.6284 25.9828 35.8271 25.5348 35.8271C25.4851 35.8271 25.4353 35.8146 25.3855 35.8022C25.3357 35.7898 25.286 35.7774 25.2362 35.7774C24.6886 35.6284 24.2407 35.2806 24.0913 34.7341L22.4985 29.4683L21.1546 30.8096C20.8559 31.1077 20.5075 31.2567 20.1093 31.2567C19.8106 31.2567 19.512 31.1573 19.2631 31.0083L16.9237 35.2806C16.7246 35.678 16.2766 35.9761 15.8286 36.0258H15.6295C15.2313 36.0258 14.8829 35.8767 14.5842 35.5787L4.38024 25.3947C4.08159 25.0966 3.93226 24.5999 3.98204 24.1528C4.03181 23.7057 4.33047 23.3082 4.72867 23.0598L9.00936 20.725C8.86004 20.4766 8.76049 20.1785 8.76049 19.8805C8.76049 19.483 8.90981 19.1353 9.20847 18.8372L10.5524 17.4959L5.2762 15.9559C4.72867 15.7572 4.33047 15.3598 4.23092 14.8133C4.13136 14.2669 4.33047 13.7204 4.72867 13.3727L13.738 5.77195C14.0367 5.52356 14.3851 5.4242 14.7833 5.4242L22.1003 5.92098L26.1819 1.8474C26.4308 1.59901 26.7294 1.44997 27.0779 1.4003L38.3271 0.00931459ZM15.1815 8.45455L8.76049 13.8694L12.9416 15.1114L19.3129 8.75262L15.1815 8.45455ZM7.96408 24.7489L15.3309 32.1012L17.1228 28.8722L11.1995 22.9605L7.96408 24.7489ZM26.2317 31.3064L31.6074 24.8979L31.3586 20.7747L24.9873 27.1334L26.2317 31.3064ZM20.1591 27.6799L35.7388 12.1307L36.8339 3.23838L27.9738 4.33129L12.3443 19.9301L20.1591 27.6799Z",
                                            fill: "".concat((ref9 = card2 === null || card2 === void 0 ? void 0 : card2.iconFillColor) !== null && ref9 !== void 0 ? ref9 : "#1C1624")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M7.76498 32.2999C7.16767 31.7038 6.22194 31.7038 5.67441 32.2999L1.8417 36.0755C1.24439 36.6716 1.24439 37.6155 1.8417 38.1619C2.14035 38.46 2.53855 38.609 2.88698 38.609C3.28519 38.609 3.63361 38.46 3.93227 38.1619L7.76498 34.3864C8.36229 33.8399 8.36229 32.8961 7.76498 32.2999Z",
                                            fill: "".concat((ref10 = card2 === null || card2 === void 0 ? void 0 : card2.iconFillColor) !== null && ref10 !== void 0 ? ref10 : "#1C1624")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M8.81026 35.4296L6.76947 37.4664C6.17216 38.0626 6.17216 39.0064 6.76947 39.5529C7.06812 39.851 7.46632 40 7.81475 40C8.16318 40 8.56139 39.851 8.86004 39.5529L10.9008 37.5161C11.4981 36.92 11.4981 35.9761 10.9008 35.4296C10.3035 34.8832 9.40757 34.8832 8.81026 35.4296Z",
                                            fill: "".concat((ref11 = card2 === null || card2 === void 0 ? void 0 : card2.iconFillColor) !== null && ref11 !== void 0 ? ref11 : "#1C1624")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M4.57935 31.2567L2.53855 33.2935C2.2399 33.5916 1.89147 33.7406 1.49327 33.7406C1.14484 33.7406 0.746632 33.5916 0.447979 33.2935C-0.149326 32.747 -0.149326 31.8032 0.447979 31.207L2.48878 29.1702C3.03631 28.5741 3.98204 28.5741 4.57935 29.1702C5.17665 29.7167 5.17665 30.6606 4.57935 31.2567Z",
                                            fill: "".concat((ref12 = card2 === null || card2 === void 0 ? void 0 : card2.iconFillColor) !== null && ref12 !== void 0 ? ref12 : "#1C1624")
                                        })
                                    ]
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-md-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FadeUpOnVisible/* default */.Z, {
                            delay: models_AnimationDelay.A400,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card, {
                                title: (card3 === null || card3 === void 0 ? void 0 : card3.title) || "",
                                description: (card3 === null || card3 === void 0 ? void 0 : card3.content) || "",
                                showIcon: (ref13 = !(card3 === null || card3 === void 0 ? void 0 : card3.hideIcon)) !== null && ref13 !== void 0 ? ref13 : true,
                                minheight: (card3 === null || card3 === void 0 ? void 0 : card3.minHeight) ? "".concat(card3 === null || card3 === void 0 ? void 0 : card3.minHeight) : undefined,
                                color: (ref14 = card3 === null || card3 === void 0 ? void 0 : card3.background) !== null && ref14 !== void 0 ? ref14 : "primary",
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                    width: "40",
                                    height: "40",
                                    viewBox: "0 0 40 40",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M21.4485 18.4878V14.3435C24.2559 13.7197 26.3503 11.2243 26.3503 8.23855C26.3503 4.80736 23.5428 2 20.1116 2C16.6804 2 13.873 4.80736 13.873 8.23864C13.873 11.2243 15.9674 13.7197 18.7747 14.3436V17.0618L18.7748 26.3752C18.7746 26.3543 18.7748 26.8654 18.7748 26.3752C19.1759 26.598 21.4485 18.4878 21.4485 18.4878ZM16.5467 8.23864C16.5467 6.2779 18.1509 4.6737 20.1116 4.6737C22.0724 4.6737 23.6766 6.2779 23.6766 8.23864C23.6766 10.1994 22.0724 11.8036 20.1116 11.8036C18.1509 11.8036 16.5467 10.1994 16.5467 8.23864ZM20.1116 27.6675C20.8692 27.6675 21.4484 27.0882 21.4484 26.3307L21.4485 18.4878L18.7747 17.0618L18.7748 26.3752C18.7747 27.0882 19.354 27.6675 20.1116 27.6675Z",
                                            fill: "".concat((ref15 = card3 === null || card3 === void 0 ? void 0 : card3.iconFillColor) !== null && ref15 !== void 0 ? ref15 : "white")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M24 17C23.4477 17 23 17.4477 23 18C23 18.5523 23.4477 19 24 19V17ZM28 20V36H30V20H28ZM27 37H5V39H27V37ZM4 36V20H2V36H4ZM5 19H20V17H5V19ZM24 19H27V17H24V19ZM5 37C4.44772 37 4 36.5523 4 36H2C2 37.6569 3.34315 39 5 39V37ZM28 36C28 36.5523 27.5523 37 27 37V39C28.6569 39 30 37.6569 30 36H28ZM30 20C30 18.3431 28.6569 17 27 17V19C27.5523 19 28 19.4477 28 20H30ZM4 20C4 19.4477 4.44772 19 5 19V17C3.34315 17 2 18.3431 2 20H4Z",
                                            fill: "".concat((ref16 = card3 === null || card3 === void 0 ? void 0 : card3.iconFillColor) !== null && ref16 !== void 0 ? ref16 : "white")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M2 23H20",
                                            stroke: "".concat((ref17 = card3 === null || card3 === void 0 ? void 0 : card3.iconFillColor) !== null && ref17 !== void 0 ? ref17 : "white"),
                                            strokeWidth: "2"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M24 23H28",
                                            stroke: "".concat((ref18 = card3 === null || card3 === void 0 ? void 0 : card3.iconFillColor) !== null && ref18 !== void 0 ? ref18 : "white"),
                                            strokeWidth: "2",
                                            strokeLinecap: "round"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M11 15V14C11 12.8954 11.8954 12 13 12H17M32 32H35C36.1046 32 37 31.1046 37 30V14C37 12.8954 36.1046 12 35 12H23.5",
                                            stroke: "".concat((ref19 = card3 === null || card3 === void 0 ? void 0 : card3.iconFillColor) !== null && ref19 !== void 0 ? ref19 : "white"),
                                            strokeWidth: "2",
                                            strokeLinecap: "round"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M32 17H37",
                                            stroke: "".concat((ref20 = card3 === null || card3 === void 0 ? void 0 : card3.iconFillColor) !== null && ref20 !== void 0 ? ref20 : "white"),
                                            strokeWidth: "2",
                                            strokeLinecap: "round"
                                        })
                                    ]
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var roomstay_blog_home_introduction = (RoomstayBlogHomeIntroduction);

;// CONCATENATED MODULE: ./components/roomstay-blog-home-introduction/roomstay-blog-home-introduction.builder-component.ts

var RoomstayBlogIntroductionBuilderConfig = {
    name: "Home Introduction",
    inputs: [
        {
            name: "title",
            type: "html"
        },
        {
            name: "styleTitle",
            type: "string",
            enum: Object.values(STYLE_TITLE),
            defaultValue: Object.values(STYLE_TITLE.centered)
        },
        {
            name: "divider",
            type: "boolean"
        },
        {
            name: "spacingContent",
            type: "string",
            enum: Object.values(SPACING_CONTENT),
            defaultValue: Object.values(SPACING_CONTENT.largest)
        },
        {
            name: "cards",
            type: "list",
            copyOnAdd: false,
            subFields: [
                {
                    name: "title",
                    type: "html"
                },
                {
                    name: "content",
                    type: "html"
                },
                {
                    name: "hideIcon",
                    type: "boolean"
                },
                {
                    name: "background",
                    type: "string",
                    enum: [
                        "primary",
                        "secondary",
                        "cyan",
                        "navy",
                        "white",
                        "purple"
                    ]
                },
                {
                    name: "iconFillColor",
                    type: "color"
                },
                {
                    name: "minHeight",
                    type: "number"
                }, 
            ]
        }, 
    ]
};
var roomstay_blog_home_introduction_builder_component_builderConfig = {
    component: roomstay_blog_home_introduction,
    config: RoomstayBlogIntroductionBuilderConfig
};
/* harmony default export */ var roomstay_blog_home_introduction_builder_component = (roomstay_blog_home_introduction_builder_component_builderConfig);

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(4666);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./components/CentralYoutubeBlock.tsx





var ReactPlayer = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 592).then(__webpack_require__.bind(__webpack_require__, 6592));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6592)
            ];
        }
    },
    ssr: false
});
function CentralYoutubeBlock(props) {
    var url = props.url;
    var ref = (0,react.useState)(false), showVideo = ref[0], setShowVideo = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "central-video-block",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "central-video-block--content",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "central-video-block--video",
                    style: {
                        display: showVideo ? "block" : "none"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactPlayer, {
                        url: props.url,
                        playing: showVideo ? true : false
                    })
                }),
                !showVideo && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "central-video-block--placeholder",
                    onClick: function() {
                        return setShowVideo(true);
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(lazy_load_image/* LazyLoadImageNaturalSize */.Q$, {
                            unoptimized: true,
                            className: "central-video-block--placeholder-image",
                            imageUrl: props.placeholderImageSrc
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(lazy_load_image_lazy_load_image/* default */.Z, {
                            className: "central-video-block--placeholder-play",
                            imageUrl: "/assets/img/video-play.png",
                            alt: "Play the video",
                            relativeContainer: false,
                            unoptimized: true
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "central-video-block--colour-blocks",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "central-video-block--colour-block first"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "central-video-block--colour-block second"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "central-video-block--colour-block third"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "central-video-block--colour-block fourth"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "central-video-block--colour-block fifth"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "central-video-block--colour-block sixth"
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/roomstay-blog-home-youtube/roomstay-blog-home-youtube.tsx




var RoomstayBlogHomeYoutube = function(param) {
    var url = param.url, placeholder = param.placeholder;
    if (!url) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "container --padded",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FadeUpOnVisible/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CentralYoutubeBlock, {
                url: url,
                placeholderImageSrc: placeholder || ""
            })
        })
    });
};
/* harmony default export */ var roomstay_blog_home_youtube = (RoomstayBlogHomeYoutube);

;// CONCATENATED MODULE: ./components/roomstay-blog-home-youtube/roomstay-blog-home-youtube.builder-component.ts

var RoomstayBlogHomeYoutubeBuilderConfig = {
    name: "Home Youtube",
    inputs: [
        {
            name: "url",
            type: "url"
        },
        {
            name: "placeholder",
            type: "file"
        }, 
    ]
};
var roomstay_blog_home_youtube_builder_component_builderConfig = {
    component: roomstay_blog_home_youtube,
    config: RoomstayBlogHomeYoutubeBuilderConfig
};
/* harmony default export */ var roomstay_blog_home_youtube_builder_component = (roomstay_blog_home_youtube_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/roomstay-blog-hotel-brand-carousel/hotel-brand-item/hotel-brand-item.module.scss
var hotel_brand_item_module = __webpack_require__(1850);
var hotel_brand_item_module_default = /*#__PURE__*/__webpack_require__.n(hotel_brand_item_module);
;// CONCATENATED MODULE: ./components/roomstay-blog-hotel-brand-carousel/hotel-brand-item/hotel-brand-item.tsx



var HotelBrandItem = function(props) {
    var logo = props.logo, name = props.name, website = props.website;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (hotel_brand_item_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (hotel_brand_item_module_default()).logo,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lazy_load_image_lazy_load_image/* default */.Z, {
                    imageUrl: logo,
                    objectPosition: "left"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (hotel_brand_item_module_default()).info,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (hotel_brand_item_module_default()).name,
                        children: name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (hotel_brand_item_module_default()).website,
                        children: website
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var hotel_brand_item = (HotelBrandItem);

// EXTERNAL MODULE: ./components/roomstay-blog-hotel-brand-carousel/roomstay-blog-hotel-brand-carousel.module.scss
var roomstay_blog_hotel_brand_carousel_module = __webpack_require__(6871);
var roomstay_blog_hotel_brand_carousel_module_default = /*#__PURE__*/__webpack_require__.n(roomstay_blog_hotel_brand_carousel_module);
;// CONCATENATED MODULE: ./components/roomstay-blog-hotel-brand-carousel/roomstay-blog-hotel-brand-carousel.tsx






var roomstay_blog_hotel_brand_carousel_options = {
    slidesPerView: "auto",
    spaceBetween: 24,
    allowTouchMove: true,
    noSwiping: false,
    freeMode: true,
    breakpoints: {
        992: {
            watchOverflow: true
        }
    }
};
var HotelBrandCarousel = function(props) {
    var hotels = props.hotels;
    if (!(hotels === null || hotels === void 0 ? void 0 : hotels.length)) return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: "123123"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (roomstay_blog_hotel_brand_carousel_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (roomstay_blog_hotel_brand_carousel_module_default()).box,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, roomstay_blog_hotel_brand_carousel_options), {
                children: hotels.map(function(hotel) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (roomstay_blog_hotel_brand_carousel_module_default()).item,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(hotel_brand_item, (0,_object_spread/* default */.Z)({}, hotel), Math.random())
                        })
                    }, hotel.name);
                })
            }))
        })
    });
};
/* harmony default export */ var roomstay_blog_hotel_brand_carousel = (HotelBrandCarousel);

;// CONCATENATED MODULE: ./components/roomstay-blog-hotel-brand-carousel/roomstay-blog-image-block.builder-component.ts


var roomstay_blog_image_block_builder_component_config = {
    name: "Hotel Carousel",
    inputs: [
        {
            name: "hotels",
            type: "list",
            subFields: [
                {
                    name: "logo",
                    type: "file"
                },
                {
                    name: "name",
                    type: "string"
                },
                {
                    name: "website",
                    type: "string"
                }, 
            ]
        }, 
    ]
};
var roomstay_blog_image_block_builder_component_builderConfig = {
    component: (0,builder_react_es5/* withChildren */.u7)(roomstay_blog_hotel_brand_carousel),
    config: roomstay_blog_image_block_builder_component_config
};
/* harmony default export */ var roomstay_blog_image_block_builder_component = (roomstay_blog_image_block_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/roomstay-blog-text-wrap/roomstay-blog-text-wrap.module.scss
var roomstay_blog_text_wrap_module = __webpack_require__(6383);
var roomstay_blog_text_wrap_module_default = /*#__PURE__*/__webpack_require__.n(roomstay_blog_text_wrap_module);
;// CONCATENATED MODULE: ./components/roomstay-blog-text-wrap/roomstay-blog-text-wrap.tsx





var RoomstayBlogTextWrap = function(param, ref) {
    var text = param.text, dark = param.dark, noPadding = param.noPadding, positionText = param.positionText;
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: ref,
        style: {
            textAlign: positionText
        },
        className: classnames_default()((roomstay_blog_text_wrap_module_default()).root, (_obj = {}, (0,_define_property/* default */.Z)(_obj, (roomstay_blog_text_wrap_module_default()).dark, dark), (0,_define_property/* default */.Z)(_obj, (roomstay_blog_text_wrap_module_default()).noPadding, noPadding), _obj)),
        children: text && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (roomstay_blog_text_wrap_module_default()).caption,
            dangerouslySetInnerHTML: {
                __html: text
            }
        })
    });
};
/* harmony default export */ var roomstay_blog_text_wrap = (/*#__PURE__*/(0,react.forwardRef)(RoomstayBlogTextWrap));

// EXTERNAL MODULE: ./components/roomstay-blog-image-block/roomstay-blog-image-block.module.scss
var roomstay_blog_image_block_module = __webpack_require__(1237);
var roomstay_blog_image_block_module_default = /*#__PURE__*/__webpack_require__.n(roomstay_blog_image_block_module);
;// CONCATENATED MODULE: ./components/roomstay-blog-image-block/roomstay-blog-image-block.tsx









var IMAGE_POSITION;
(function(IMAGE_POSITION) {
    IMAGE_POSITION["Left"] = "Left";
    IMAGE_POSITION["Right"] = "Right";
})(IMAGE_POSITION || (IMAGE_POSITION = {}));
var MOBILE_TAN_ALPHA = 80 / 375;
var DESKTOP_TAN_ALPHA = 80 / 1920;
var RoomstayBlogImageBlock = function(param) {
    var text = param.text, image = param.image, bottomColor = param.bottomColor, children = param.children, topColor = param.topColor;
    var ref;
    var width = (0,esm/* useWindowSize */.iP)().width;
    var textRef = (0,react.useRef)(null);
    var imageRef = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(0), imageHeight = ref1[0], setImageHeight = ref1[1];
    var ref2 = (0,react.useState)(0), imageRatio = ref2[0], setImageRatio = ref2[1];
    var isOverflow = (image === null || image === void 0 ? void 0 : image.overflowValue) && image.overflowValue < 0;
    var isMobileFluid = width < 992;
    var isFluid = (image === null || image === void 0 ? void 0 : image.fluid) || isMobileFluid;
    var getTextHeight = function() {
        var ref;
        return ((ref = textRef.current) === null || ref === void 0 ? void 0 : ref.clientHeight) || 0;
    };
    (0,react.useEffect)(function() {
        if (image === null || image === void 0 ? void 0 : image.source) {
            var imageEl = new Image();
            imageEl.onload = function() {
                setImageRatio(imageEl.width / imageEl.height);
            };
            imageEl.src = image.source;
        }
    }, []);
    (0,react.useEffect)(function() {
        if (textRef.current) {
            if (!isFluid) {
                setImageHeight(getTextHeight() - (isOverflow ? (image === null || image === void 0 ? void 0 : image.overflowValue) || 0 : 0));
            }
        }
    }, [
        width,
        textRef.current,
        image === null || image === void 0 ? void 0 : image.overflowValue,
        isFluid,
        text === null || text === void 0 ? void 0 : text.paddingBottom,
        text === null || text === void 0 ? void 0 : text.paddingTop
    ]);
    var getBackgroundHeight = function(extraHeight) {
        var ref, ref1;
        if (imageRatio && ((ref = imageRef.current) === null || ref === void 0 ? void 0 : ref.clientWidth)) return (((ref1 = imageRef.current) === null || ref1 === void 0 ? void 0 : ref1.clientWidth) || 0) * (1 / imageRatio) * 0.5 + extraHeight;
        return 0;
    };
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((roomstay_blog_image_block_module_default()).fullWidth, (roomstay_blog_image_block_module_default()).root, (_obj = {}, (0,_define_property/* default */.Z)(_obj, (roomstay_blog_image_block_module_default()).fluid, isFluid), (0,_define_property/* default */.Z)(_obj, (roomstay_blog_image_block_module_default()).noOverflow, !isOverflow), (0,_define_property/* default */.Z)(_obj, (roomstay_blog_image_block_module_default()).left, IMAGE_POSITION.Left === (image === null || image === void 0 ? void 0 : image.position)), (0,_define_property/* default */.Z)(_obj, (roomstay_blog_image_block_module_default()).right, IMAGE_POSITION.Right === (image === null || image === void 0 ? void 0 : image.position)), _obj)),
        style: {
            backgroundColor: topColor
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            style: {
                paddingTop: !isFluid ? -((image === null || image === void 0 ? void 0 : image.overflowValue) || 0) : 0,
                backgroundColor: bottomColor
            },
            className: classnames_default()((roomstay_blog_image_block_module_default()).container, (roomstay_blog_image_block_module_default()).fullWidth),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(clipped_box/* default */.Z, {
                    style: {
                        backgroundColor: topColor,
                        height: isMobileFluid ? getBackgroundHeight(MOBILE_TAN_ALPHA * (((ref = imageRef.current) === null || ref === void 0 ? void 0 : ref.clientWidth) || 0) * 0.5) : -((image === null || image === void 0 ? void 0 : image.overflowValue) || 0)
                    },
                    configs: [
                        {
                            rad: isMobileFluid ? Math.atan(MOBILE_TAN_ALPHA) : Math.atan(DESKTOP_TAN_ALPHA),
                            position: clipped_box/* POSITION.BottomRight */.V.BottomRight
                        }, 
                    ],
                    className: classnames_default()((roomstay_blog_image_block_module_default()).fullWidth, (roomstay_blog_image_block_module_default()).background)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        paddingTop: !isOverflow ? image === null || image === void 0 ? void 0 : image.overflowValue : undefined
                    },
                    className: (roomstay_blog_image_block_module_default()).contentContainer,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (roomstay_blog_image_block_module_default()).textBlock,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (roomstay_blog_image_block_module_default()).textItem,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        ref: textRef,
                                        style: {
                                            paddingTop: !isMobileFluid ? text === null || text === void 0 ? void 0 : text.paddingTop : undefined,
                                            paddingBottom: !isMobileFluid ? text === null || text === void 0 ? void 0 : text.paddingBottom : undefined
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(roomstay_blog_text_wrap, {
                                            text: text === null || text === void 0 ? void 0 : text.text,
                                            dark: text === null || text === void 0 ? void 0 : text.dark,
                                            noPadding: true
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (roomstay_blog_image_block_module_default()).imageItem,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        ref: imageRef,
                                        style: {
                                            aspectRatio: isFluid ? imageRatio : undefined,
                                            height: !isFluid ? imageHeight : undefined
                                        },
                                        className: (roomstay_blog_image_block_module_default()).image,
                                        children: (image === null || image === void 0 ? void 0 : image.source) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(lazy_load_image/* LazyLoadImage */.e6, {
                                            imageUrl: image === null || image === void 0 ? void 0 : image.source,
                                            objectFit: "cover"
                                        }) : null
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (roomstay_blog_image_block_module_default()).content,
                            children: children
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var roomstay_blog_image_block = (RoomstayBlogImageBlock);

;// CONCATENATED MODULE: ./components/roomstay-blog-image-block/roomstay-blog-image-block.builder-component.ts


var roomstay_blog_image_block_roomstay_blog_image_block_builder_component_config = {
    name: "Image Block",
    inputs: [
        {
            name: "image",
            type: "object",
            subFields: [
                {
                    name: "source",
                    type: "file"
                },
                {
                    name: "overflowValue",
                    type: "number"
                },
                {
                    name: "fluid",
                    type: "boolean"
                },
                {
                    name: "position",
                    type: "string",
                    enum: Object.values(IMAGE_POSITION)
                }, 
            ]
        },
        {
            name: "text",
            type: "object",
            subFields: [
                {
                    name: "paddingTop",
                    type: "string"
                },
                {
                    name: "paddingBottom",
                    type: "string"
                },
                {
                    name: "dark",
                    type: "boolean"
                },
                {
                    name: "text",
                    type: "richText"
                }, 
            ]
        },
        {
            name: "topColor",
            type: "color"
        },
        {
            name: "bottomColor",
            type: "color"
        }, 
    ]
};
var roomstay_blog_image_block_roomstay_blog_image_block_builder_component_builderConfig = {
    component: (0,builder_react_es5/* withChildren */.u7)(roomstay_blog_image_block),
    config: roomstay_blog_image_block_roomstay_blog_image_block_builder_component_config
};
/* harmony default export */ var roomstay_blog_image_block_roomstay_blog_image_block_builder_component = (roomstay_blog_image_block_roomstay_blog_image_block_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/roomstay-blog-image-grid/roomstay-blog-image-grid.module.scss
var roomstay_blog_image_grid_module = __webpack_require__(4174);
var roomstay_blog_image_grid_module_default = /*#__PURE__*/__webpack_require__.n(roomstay_blog_image_grid_module);
;// CONCATENATED MODULE: ./components/roomstay-blog-image-grid/roomstay-blog-image-grid.tsx









var getVal = function(val) {
    if (typeof val === "string") {
        var number = Number.parseFloat(val);
        if (val) {
            return number;
        }
    }
    return val;
};
var RoomstayBlogImageGrid = function(props) {
    var _rows = props.rows, rows = _rows === void 0 ? [] : _rows;
    var ref = (0,esm/* useWindowSize */.iP)(), windowWidth = ref.width;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,esm/* useElementSize */.h4)(), 2), containerRef = ref1[0], size = ref1[1];
    var rowRefs = (0,react.useRef)([]);
    var ref2 = (0,react.useState)(true), isGroup = ref2[0], setIsGroup = ref2[1];
    var deferredContainerWidth = (0,react.useDeferredValue)(size.width);
    var checkRowWidth = (0,react.useCallback)(function() {
        var ref;
        var maxWidth = 0;
        (ref = rowRefs.current) === null || ref === void 0 ? void 0 : ref.forEach(function(row) {
            if (row && row.offsetWidth > maxWidth) {
                maxWidth = row.offsetWidth;
            }
        });
        setIsGroup(maxWidth > deferredContainerWidth);
    }, [
        deferredContainerWidth
    ]);
    (0,react.useEffect)(function() {
        checkRowWidth();
    }, [
        checkRowWidth
    ]);
    (0,react.useEffect)(function() {
        checkRowWidth();
    }, []);
    var renderImages = function(images) {
        return images === null || images === void 0 ? void 0 : images.map(function(param) {
            var image = param.image, width = param.width, widthMobile = param.widthMobile, tmp = param.height, itemHeight = tmp === void 0 ? 64 : tmp;
            if (!image) return null;
            var maxHeight = getVal(itemHeight);
            if (windowWidth < 768 && typeof maxHeight === "number") {
                maxHeight = maxHeight / 5 * 3;
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (roomstay_blog_image_grid_module_default()).item,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lazy_load_image/* RawLazyLoadImage */.Pq, {
                    className: (roomstay_blog_image_grid_module_default()).image,
                    imageUrl: image,
                    style: {
                        maxWidth: windowWidth < 768 ? getVal(widthMobile) : getVal(width),
                        maxHeight: maxHeight
                    },
                    priority: true
                })
            }, image);
        });
    };
    var renderRowGap = function() {
        if (props.rowGap) {
            var rowGap = "".concat(props.rowGap, "px");
            return {
                "--row-gap": rowGap
            };
        }
        return {};
    };
    var renderColumnGap = function() {
        if (props.columnGap) {
            var columnGap = "".concat(props.columnGap, "px");
            return {
                "--column-gap": columnGap
            };
        }
        return {};
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: containerRef,
        style: (0,_object_spread/* default */.Z)({}, renderRowGap(), renderColumnGap()),
        className: classnames_default()((roomstay_blog_image_grid_module_default()).container),
        children: [
            rows.map(function(row, index) {
                var ref;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    ref: function(ref) {
                        return rowRefs.current[index] = ref;
                    },
                    className: classnames_default()((roomstay_blog_image_grid_module_default()).row, (0,_define_property/* default */.Z)({}, (roomstay_blog_image_grid_module_default()).hide, isGroup)),
                    children: renderImages(row.images)
                }, "".concat(index, "_").concat((ref = row.images) === null || ref === void 0 ? void 0 : ref.length));
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((roomstay_blog_image_grid_module_default()).row, (roomstay_blog_image_grid_module_default()).wrap, (0,_define_property/* default */.Z)({}, (roomstay_blog_image_grid_module_default()).hide, !isGroup)),
                children: rows.map(function(row) {
                    return renderImages(row.images);
                })
            })
        ]
    });
};
/* harmony default export */ var roomstay_blog_image_grid = (RoomstayBlogImageGrid);

;// CONCATENATED MODULE: ./components/roomstay-blog-image-grid/roomstay-blog-image-grid.builder-component.ts

var RoomstayBlogImageGridBuilderConfig = {
    name: "Image Grid",
    inputs: [
        {
            name: "rows",
            type: "list",
            subFields: [
                {
                    name: "images",
                    type: "list",
                    copyOnAdd: false,
                    subFields: [
                        {
                            name: "image",
                            type: "file"
                        },
                        {
                            name: "width",
                            type: "string"
                        },
                        {
                            name: "widthMobile",
                            type: "string"
                        },
                        {
                            name: "height",
                            type: "string"
                        },
                        {
                            name: "col",
                            type: "number"
                        },
                        {
                            name: "row",
                            type: "number"
                        }, 
                    ]
                }, 
            ]
        },
        {
            name: "rowGap",
            type: "number"
        },
        {
            name: "columnGap",
            type: "number"
        }, 
    ]
};
var roomstay_blog_image_grid_builder_component_builderConfig = {
    component: roomstay_blog_image_grid,
    config: RoomstayBlogImageGridBuilderConfig
};
/* harmony default export */ var roomstay_blog_image_grid_builder_component = (roomstay_blog_image_grid_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/roomstay-blog-img-clipped/roomstay-blog-use-case-img-clipped.module.scss
var roomstay_blog_use_case_img_clipped_module = __webpack_require__(343);
var roomstay_blog_use_case_img_clipped_module_default = /*#__PURE__*/__webpack_require__.n(roomstay_blog_use_case_img_clipped_module);
;// CONCATENATED MODULE: ./components/roomstay-blog-img-clipped/roomstay-blog-use-case-img-clipped.tsx






var RoomstayBlogClippedBackgroundImg = function(props) {
    var image = props.image;
    var ref = (0,_sliced_to_array/* default */.Z)((0,esm/* useElementSize */.h4)(), 2), containerRef = ref[0], height = ref[1].height;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,esm/* useElementSize */.h4)(), 2), introRef = ref1[0], ref2 = ref1[1], introHeight = ref2.height;
    var ref3 = (0,esm/* useWindowSize */.iP)(), windowWidth = ref3.width;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: containerRef,
        className: (roomstay_blog_use_case_img_clipped_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(clipped_box/* default */.Z, {
                configs: [
                    {
                        rad: Math.atan(171 / 1920),
                        position: clipped_box/* POSITION.TopLeft */.V.TopLeft
                    }, 
                ],
                className: (roomstay_blog_use_case_img_clipped_module_default()).background,
                style: {
                    backgroundColor: "#ffffff",
                    maxHeight: "".concat(windowWidth > 768 ? introHeight + 230 : introHeight + 90, "px"),
                    transform: "rotate(180deg)"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(clipped_box/* default */.Z, {
                configs: [
                    {
                        rad: Math.atan(171 / 1920),
                        position: clipped_box/* POSITION.BottomRight */.V.BottomRight
                    }, 
                ],
                className: (roomstay_blog_use_case_img_clipped_module_default()).backgroundBottom,
                style: {
                    backgroundColor: "#ffffff",
                    maxHeight: "".concat(windowWidth > 768 ? introHeight + 240 : introHeight + 90, "px"),
                    transform: "rotate(180deg)",
                    marginTop: "0px"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(lazy_load_image/* LazyLoadImage */.e6, {
                className: (roomstay_blog_use_case_img_clipped_module_default()).wrapperImg,
                imageUrl: image,
                objectFit: "cover"
            })
        ]
    });
};
/* harmony default export */ var roomstay_blog_use_case_img_clipped = (RoomstayBlogClippedBackgroundImg);

;// CONCATENATED MODULE: ./components/roomstay-blog-img-clipped/roomstay-blog-use-case-img-clipped.builder-component.ts

var RoomstayBlogClippedBackgroundBuilderConfig = {
    name: "Background Image Clipped",
    inputs: [
        {
            name: "image",
            type: "file"
        }, 
    ]
};
var roomstay_blog_use_case_img_clipped_builder_component_builderConfig = {
    component: roomstay_blog_use_case_img_clipped,
    config: RoomstayBlogClippedBackgroundBuilderConfig
};
/* harmony default export */ var roomstay_blog_use_case_img_clipped_builder_component = (roomstay_blog_use_case_img_clipped_builder_component_builderConfig);

;// CONCATENATED MODULE: ./components/roomstay-blog-increase/roomstay-blog-increase.builder-component.ts

var roomstay_blog_increase_builder_component_RoomstayBlogImageGridBuilderConfig = {
    name: "Roomstay Increase",
    inputs: [
        {
            name: "title",
            type: "html"
        },
        {
            name: "booking",
            type: "text"
        },
        {
            name: "revenue",
            type: "text"
        },
        {
            name: "aov",
            type: "text"
        },
        {
            name: "extra",
            type: "text"
        },
        {
            name: "description",
            type: "text"
        }, 
    ]
};
var roomstay_blog_increase_builder_component_builderConfig = {
    component: roomstay_blog_increase,
    config: roomstay_blog_increase_builder_component_RoomstayBlogImageGridBuilderConfig
};
/* harmony default export */ var roomstay_blog_increase_builder_component = (roomstay_blog_increase_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/roomstay-blog-integrations/card-integrations/card.module.scss
var card_module = __webpack_require__(6170);
var card_module_default = /*#__PURE__*/__webpack_require__.n(card_module);
;// CONCATENATED MODULE: ./components/roomstay-blog-integrations/card-integrations/cardIntegrations.tsx






var CardContent = function(param) {
    var logo = param.logo, logoHeight = param.logoHeight, title = param.title, description = param.description;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (card_module_default()).card,
        children: [
            logo && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (card_module_default()).wrapLogo,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (card_module_default()).box,
                    style: {
                        height: logoHeight ? "".concat(logoHeight, "px") : ""
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lazy_load_image/* LazyLoadImage */.e6, {
                        className: (card_module_default()).logo,
                        imageUrl: logo,
                        objectPosition: "left"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (card_module_default()).title,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (card_module_default()).description,
                children: description
            })
        ]
    });
};
var CardIntegrations = function(_param) /*#__PURE__*/ {
    var linkTo = _param.linkTo, props = (0,_object_without_properties/* default */.Z)(_param, [
        "linkTo"
    ]);
    return (0,jsx_runtime.jsx)((link_default()), {
        href: linkTo || "",
        passHref: true,
        children: linkTo ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            target: "_blank",
            style: {
                textDecoration: "unset"
            },
            onClick: function(e) {
                return !linkTo && e.preventDefault();
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (card_module_default()).container,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent, (0,_object_spread/* default */.Z)({}, props))
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (card_module_default()).container,
            onClick: function(e) {
                return !linkTo && e.preventDefault();
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent, (0,_object_spread/* default */.Z)({}, props))
        })
    });
};
/* harmony default export */ var cardIntegrations = (CardIntegrations);

// EXTERNAL MODULE: ./components/roomstay-blog-integrations/roomstay-blog-integrations.module.scss
var roomstay_blog_integrations_module = __webpack_require__(3902);
var roomstay_blog_integrations_module_default = /*#__PURE__*/__webpack_require__.n(roomstay_blog_integrations_module);
;// CONCATENATED MODULE: ./components/roomstay-blog-integrations/roomstay-blog-integrations.tsx







var RoomstayBlogIntegrations = function(props) {
    var _cards = props.cards, cards = _cards === void 0 ? [] : _cards;
    var ref = (0,_sliced_to_array/* default */.Z)((0,esm/* useElementSize */.h4)(), 2), introRef = ref[0], ref1 = ref[1], introHeight = ref1.height;
    var ref2 = (0,esm/* useWindowSize */.iP)(), windowWidth = ref2.width;
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,esm/* useElementSize */.h4)(), 2), containerRef = ref3[0], height = ref3[1].height;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: containerRef,
        className: (roomstay_blog_integrations_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(clipped_box/* default */.Z, {
                configs: [],
                className: (roomstay_blog_integrations_module_default()).background,
                style: {
                    backgroundColor: "#F3F3F5",
                    maxHeight: "".concat(height / 2, "px")
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(clipped_box/* default */.Z, {
                configs: [
                    {
                        rad: Math.atan(515 / 1920),
                        position: clipped_box/* POSITION.BottomRight */.V.BottomRight
                    }, 
                ],
                className: classnames_default()((roomstay_blog_integrations_module_default()).background, (roomstay_blog_integrations_module_default()).backgroundClipped),
                style: {
                    backgroundColor: "#F3F3F5",
                    maxHeight: "".concat(windowWidth > 768 ? introHeight + 130 + 100 : introHeight + 77 + 60, "px"),
                    marginTop: "-2px"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                ref: introRef,
                className: (roomstay_blog_integrations_module_default()).textContent,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (roomstay_blog_integrations_module_default()).title,
                        dangerouslySetInnerHTML: {
                            __html: props.title
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (roomstay_blog_integrations_module_default()).description,
                        dangerouslySetInnerHTML: {
                            __html: props.description
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (roomstay_blog_integrations_module_default()).cardContent,
                children: cards.map(function(card, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (roomstay_blog_integrations_module_default()).cards,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(cardIntegrations, {
                            logo: card.logo,
                            logoHeight: card.logoHeight,
                            title: card.title,
                            description: card.description,
                            linkTo: card.linkTo
                        })
                    }, new Date().getTime() + index);
                })
            })
        ]
    });
};
/* harmony default export */ var roomstay_blog_integrations = (RoomstayBlogIntegrations);

;// CONCATENATED MODULE: ./components/roomstay-blog-integrations/roomstay-blog-integrations.builder-component.ts

var RoomstayBlogIntegrationsBuilderConfig = {
    name: "Integrations",
    inputs: [
        {
            name: "cards",
            type: "list",
            subFields: [
                {
                    name: "logo",
                    type: "file"
                },
                {
                    name: "logoHeight",
                    type: "number"
                },
                {
                    name: "title",
                    type: "text"
                },
                {
                    name: "description",
                    type: "text"
                },
                {
                    name: "linkTo",
                    type: "string"
                }, 
            ]
        }, 
    ]
};
var roomstay_blog_integrations_builder_component_builderConfig = {
    component: roomstay_blog_integrations,
    config: RoomstayBlogIntegrationsBuilderConfig
};
/* harmony default export */ var roomstay_blog_integrations_builder_component = (roomstay_blog_integrations_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/roomstay-blog-intro-rev-par/roomstay-blog-intro-revpar.module.scss
var roomstay_blog_intro_revpar_module = __webpack_require__(205);
var roomstay_blog_intro_revpar_module_default = /*#__PURE__*/__webpack_require__.n(roomstay_blog_intro_revpar_module);
;// CONCATENATED MODULE: ./components/roomstay-blog-intro-rev-par/roomstay-blog-intro-revpar.tsx






var roomstay_blog_intro_revpar_IMAGE_POSITION;
(function(IMAGE_POSITION) {
    IMAGE_POSITION["Left"] = "Left";
    IMAGE_POSITION["Right"] = "Right";
})(roomstay_blog_intro_revpar_IMAGE_POSITION || (roomstay_blog_intro_revpar_IMAGE_POSITION = {}));
var TITLE_SIZE;
(function(TITLE_SIZE) {
    TITLE_SIZE["Medium"] = "Medium";
    TITLE_SIZE["Large"] = "Large";
})(TITLE_SIZE || (TITLE_SIZE = {}));
var RoomstayBlogIntroRevPar = function(props) {
    var image = props.image, title = props.title, description = props.description, position = props.position, titleCenter = props.titleCenter, hideImage = props.hideImage, titleSize = props.titleSize, imageMobile = props.imageMobile;
    var ref = (0,esm/* useWindowSize */.iP)(), windowWidth = ref.width;
    var isMobile = windowWidth <= 992;
    var _obj, _obj1, _obj2, _obj3;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (roomstay_blog_intro_revpar_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()((roomstay_blog_intro_revpar_module_default()).wrapper, (_obj = {}, (0,_define_property/* default */.Z)(_obj, (roomstay_blog_intro_revpar_module_default()).left, position === roomstay_blog_intro_revpar_IMAGE_POSITION.Left), (0,_define_property/* default */.Z)(_obj, (roomstay_blog_intro_revpar_module_default()).right, position === roomstay_blog_intro_revpar_IMAGE_POSITION.Right), _obj)),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (roomstay_blog_intro_revpar_module_default()).wrapperText,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (roomstay_blog_intro_revpar_module_default()).wrapperBox,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()((roomstay_blog_intro_revpar_module_default()).title, (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, (roomstay_blog_intro_revpar_module_default()).titleCenter, titleCenter), (0,_define_property/* default */.Z)(_obj1, (roomstay_blog_intro_revpar_module_default()).titleMedium, titleSize === TITLE_SIZE.Medium), (0,_define_property/* default */.Z)(_obj1, (roomstay_blog_intro_revpar_module_default()).titleLarge, titleSize === TITLE_SIZE.Large), _obj1)),
                                dangerouslySetInnerHTML: {
                                    __html: title
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (roomstay_blog_intro_revpar_module_default()).description,
                                dangerouslySetInnerHTML: {
                                    __html: description
                                }
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()((roomstay_blog_intro_revpar_module_default()).wrapperImg, (0,_define_property/* default */.Z)({}, (roomstay_blog_intro_revpar_module_default()).hideImage, hideImage)),
                    children: !isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (roomstay_blog_intro_revpar_module_default()).positionImg,
                        children: image && /*#__PURE__*/ (0,jsx_runtime.jsx)(lazy_load_image/* LazyLoadImage */.e6, {
                            className: classnames_default()((roomstay_blog_intro_revpar_module_default()).img, (_obj2 = {}, (0,_define_property/* default */.Z)(_obj2, (roomstay_blog_intro_revpar_module_default()).left, position === roomstay_blog_intro_revpar_IMAGE_POSITION.Left), (0,_define_property/* default */.Z)(_obj2, (roomstay_blog_intro_revpar_module_default()).right, position === roomstay_blog_intro_revpar_IMAGE_POSITION.Right), _obj2)),
                            imageUrl: image,
                            alt: title,
                            objectFit: "cover"
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: imageMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(lazy_load_image/* LazyLoadImage */.e6, {
                            className: classnames_default()((roomstay_blog_intro_revpar_module_default()).img, (_obj3 = {}, (0,_define_property/* default */.Z)(_obj3, (roomstay_blog_intro_revpar_module_default()).left, position === roomstay_blog_intro_revpar_IMAGE_POSITION.Left), (0,_define_property/* default */.Z)(_obj3, (roomstay_blog_intro_revpar_module_default()).right, position === roomstay_blog_intro_revpar_IMAGE_POSITION.Right), _obj3)),
                            imageUrl: imageMobile,
                            alt: title,
                            objectFit: "contain"
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var roomstay_blog_intro_revpar = (RoomstayBlogIntroRevPar);

;// CONCATENATED MODULE: ./components/roomstay-blog-intro-rev-par/roomstay-blog-intro-revpar.builder-component.ts

var RoomstayBlogIntroRevParBuilderConfig = {
    name: "Intro RevPar",
    inputs: [
        {
            name: "image",
            type: "file"
        },
        {
            name: "imageMobile",
            type: "file"
        },
        {
            name: "position",
            type: "text",
            enum: [
                "Left",
                "Right"
            ]
        },
        {
            name: "hideImage",
            type: "boolean"
        },
        {
            name: "title",
            type: "html"
        },
        {
            name: "titleCenter",
            type: "boolean"
        },
        {
            name: "titleSize",
            type: "text",
            enum: [
                "Medium",
                "Large"
            ]
        },
        {
            name: "description",
            type: "html"
        }, 
    ]
};
var roomstay_blog_intro_revpar_builder_component_builderConfig = {
    component: roomstay_blog_intro_revpar,
    config: RoomstayBlogIntroRevParBuilderConfig
};
/* harmony default export */ var roomstay_blog_intro_revpar_builder_component = (roomstay_blog_intro_revpar_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/roomstay-blog-list-card/roomstay-blog-list-card.module.scss
var roomstay_blog_list_card_module = __webpack_require__(7302);
var roomstay_blog_list_card_module_default = /*#__PURE__*/__webpack_require__.n(roomstay_blog_list_card_module);
;// CONCATENATED MODULE: ./components/roomstay-blog-list-card/roomstay-blog-list-card.tsx


var RoomStayBlogListCard = function(props) {
    var _cards = props.cards, cards = _cards === void 0 ? [] : _cards;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (roomstay_blog_list_card_module_default()).container,
        children: cards.map(function(item, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (roomstay_blog_list_card_module_default()).card,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (roomstay_blog_list_card_module_default()).title,
                        dangerouslySetInnerHTML: {
                            __html: item.title
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (roomstay_blog_list_card_module_default()).divider
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (roomstay_blog_list_card_module_default()).description,
                        children: item.description
                    })
                ]
            }, new Date().getTime() + index);
        })
    });
};
/* harmony default export */ var roomstay_blog_list_card = (RoomStayBlogListCard);

;// CONCATENATED MODULE: ./components/roomstay-blog-list-card/roomstay-blog-list-card.builder-component.ts


var RoomstayBlogListCardBuilderConfig = {
    name: "List Card",
    inputs: [
        {
            name: "cards",
            type: "list",
            subFields: [
                {
                    name: "title",
                    type: "richText"
                },
                {
                    name: "description",
                    type: "string"
                }, 
            ]
        }, 
    ]
};
var roomstay_blog_list_card_builder_component_builderConfig = {
    component: (0,builder_react_es5/* withChildren */.u7)(roomstay_blog_list_card),
    config: RoomstayBlogListCardBuilderConfig
};
/* harmony default export */ var roomstay_blog_list_card_builder_component = (roomstay_blog_list_card_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/roomstay-blog-our-promise/roomstay-blog-our-promise.module.scss
var roomstay_blog_our_promise_module = __webpack_require__(8013);
var roomstay_blog_our_promise_module_default = /*#__PURE__*/__webpack_require__.n(roomstay_blog_our_promise_module);
;// CONCATENATED MODULE: ./components/roomstay-blog-our-promise/roomstay-blog-our-promise.tsx



var RoomStayOurPromise = function(props) {
    var _items = props.items, items = _items === void 0 ? [] : _items, title = props.title;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (roomstay_blog_our_promise_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (roomstay_blog_our_promise_module_default()).title,
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (roomstay_blog_our_promise_module_default()).content,
                    children: items.map(function(item, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (roomstay_blog_our_promise_module_default()).item,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (roomstay_blog_our_promise_module_default()).icon,
                                    children: item.icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(lazy_load_image/* LazyLoadImage */.e6, {
                                        imageUrl: item.icon,
                                        className: "w-100",
                                        alt: "avatar",
                                        ratio: "1/1",
                                        loadingPlaceholder: false
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (roomstay_blog_our_promise_module_default()).text,
                                    children: item.text
                                })
                            ]
                        }, new Date().getTime() + index);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var roomstay_blog_our_promise = (RoomStayOurPromise);

;// CONCATENATED MODULE: ./components/roomstay-blog-our-promise/roomstay-blog-our-promise.builder-component.ts

var RoomstayBlogOurPromiseBuilderConfig = {
    name: "List Our Promise",
    inputs: [
        {
            name: "title",
            type: "html"
        },
        {
            name: "items",
            type: "list",
            subFields: [
                {
                    name: "icon",
                    type: "file"
                },
                {
                    name: "text",
                    type: "text"
                }, 
            ]
        }, 
    ]
};
var roomstay_blog_our_promise_builder_component_builderConfig = {
    component: roomstay_blog_our_promise,
    config: RoomstayBlogOurPromiseBuilderConfig
};
/* harmony default export */ var roomstay_blog_our_promise_builder_component = (roomstay_blog_our_promise_builder_component_builderConfig);

;// CONCATENATED MODULE: ./components/roomstay-blog-products-card/roomstay-blog-product-card.tsx





var RoomstayBlogProductsCard = function(props) {
    var title = props.title, description = props.description, ctaButton = props.ctaButton, inverted = props.inverted, graphic = props.graphic;
    var productCardPositionClassName = inverted ? "--right" : "--left";
    var classes = classnames_default()("row product-card", productCardPositionClassName);
    var firstChildClasses = classnames_default()("col-md-6", productCardPositionClassName, {
        "--left offset-md-1": inverted
    });
    var secondChildClasses = classnames_default()("col-md-5", {
        "--left offset-md-1": !inverted
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: firstChildClasses,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FadeUpOnVisible/* default */.Z, {
                    delay: models_AnimationDelay.A200,
                    children: graphic && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: "w-100",
                        src: props.graphic,
                        alt: ""
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: secondChildClasses,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FadeUpOnVisible/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "title",
                            dangerouslySetInnerHTML: {
                                __html: title || ""
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "body-text",
                            dangerouslySetInnerHTML: {
                                __html: description || ""
                            }
                        }),
                        (ctaButton === null || ctaButton === void 0 ? void 0 : ctaButton.text) && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                            type: "secondary",
                            theme: "primary",
                            size: "default",
                            htmlType: "button",
                            link: ctaButton === null || ctaButton === void 0 ? void 0 : ctaButton.href,
                            children: (ctaButton === null || ctaButton === void 0 ? void 0 : ctaButton.text) || "Inquiry Now!"
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var roomstay_blog_product_card = (RoomstayBlogProductsCard);

// EXTERNAL MODULE: ./components/roomstay-blog-product-hero/list-button/list-button.module.scss
var list_button_module = __webpack_require__(7706);
var list_button_module_default = /*#__PURE__*/__webpack_require__.n(list_button_module);
;// CONCATENATED MODULE: ./components/roomstay-blog-product-hero/list-button/list-button.tsx



var ListButton = function(props) {
    var buttonName = props.buttonName, sectionId = props.sectionId;
    var handleScrollElementById = function() {
        var element = document.getElementById(sectionId || "");
        if (sectionId === (element === null || element === void 0 ? void 0 : element.id)) {}
        if (element) {
            element.scrollIntoView({
                behavior: "smooth",
                inline: "center"
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
        type: "secondary",
        size: "large",
        htmlType: "button",
        onClick: handleScrollElementById,
        className: (list_button_module_default()).unactive,
        children: buttonName
    });
};
/* harmony default export */ var list_button = (ListButton);

// EXTERNAL MODULE: ./components/roomstay-blog-product-hero/roomstay-blog-products-hero.module.scss
var roomstay_blog_products_hero_module = __webpack_require__(6627);
var roomstay_blog_products_hero_module_default = /*#__PURE__*/__webpack_require__.n(roomstay_blog_products_hero_module);
// EXTERNAL MODULE: ./components/roomstay-blog-product-hero/text-intro/text-intro.module.scss
var text_intro_text_intro_module = __webpack_require__(6640);
var text_intro_text_intro_module_default = /*#__PURE__*/__webpack_require__.n(text_intro_text_intro_module);
;// CONCATENATED MODULE: ./components/roomstay-blog-product-hero/text-intro/text-intro.tsx



var text_intro_TextIntro = function(props, ref) {
    var title = props.title, description = props.description;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: ref,
        className: (text_intro_text_intro_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: (text_intro_text_intro_module_default()).title,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (text_intro_text_intro_module_default()).description,
                children: description
            })
        ]
    });
};
/* harmony default export */ var text_intro_text_intro = (/*#__PURE__*/(0,react.forwardRef)(text_intro_TextIntro));

;// CONCATENATED MODULE: ./components/roomstay-blog-product-hero/roomstay-blog-products-hero.tsx








var RoomstayBlogProductsHero = function(props) {
    var title = props.title, description = props.description, card = props.card, buttons = props.buttons;
    var ref = (0,esm/* useWindowSize */.iP)(), windowWidth = ref.width;
    var isMobile = windowWidth <= 768;
    var isTablet = windowWidth <= 991;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (roomstay_blog_products_hero_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (roomstay_blog_products_hero_module_default()).background,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(clipped_box/* default */.Z, {
                    configs: [
                        {
                            rad: isMobile ? Math.tan(101 / 375) : Math.tan(511 / 1920),
                            position: clipped_box/* POSITION.BottomRight */.V.BottomRight
                        }, 
                    ],
                    className: classnames_default()((roomstay_blog_products_hero_module_default()).background, (roomstay_blog_products_hero_module_default()).backgroundClippedBottom),
                    style: {
                        backgroundColor: "#fff",
                        maxHeight: isMobile ? 101 : isTablet ? 300 : 500,
                        transform: "rotate(180deg)",
                        marginBottom: -1
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (roomstay_blog_products_hero_module_default()).text
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(text_intro_text_intro, {
                title: title,
                description: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (roomstay_blog_products_hero_module_default()).listButton,
                children: buttons === null || buttons === void 0 ? void 0 : buttons.map(function(button, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(list_button, {
                            buttonName: button.name,
                            sectionId: button.sectionId
                        })
                    }, new Date().getTime() + index);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(roomstay_blog_product_card, {
                title: card === null || card === void 0 ? void 0 : card.title,
                description: card === null || card === void 0 ? void 0 : card.description,
                graphic: card === null || card === void 0 ? void 0 : card.graphic,
                inverted: true,
                ctaButton: card.ctaButton
            })
        ]
    });
};
/* harmony default export */ var roomstay_blog_products_hero = (RoomstayBlogProductsHero);

;// CONCATENATED MODULE: ./components/roomstay-blog-product-hero/roomstay-blog-product-hero.builder-component.ts

var RoomstayBlogProductsHeroBuilderConfig = {
    name: "Product Hero",
    inputs: [
        {
            name: "title",
            type: "text"
        },
        {
            name: "description",
            type: "text"
        },
        {
            name: "buttons",
            type: "list",
            copyOnAdd: false,
            subFields: [
                {
                    name: "name",
                    type: "string"
                },
                {
                    name: "sectionId",
                    type: "string"
                }, 
            ]
        },
        {
            name: "card",
            type: "object",
            subFields: [
                {
                    name: "title",
                    type: "text"
                },
                {
                    name: "description",
                    type: "text"
                },
                {
                    name: "graphic",
                    type: "file"
                },
                {
                    name: "inverted",
                    type: "boolean"
                },
                {
                    name: "ctaButton",
                    type: "object",
                    subFields: [
                        {
                            name: "text",
                            type: "string"
                        },
                        {
                            name: "href",
                            type: "string"
                        }, 
                    ]
                }, 
            ]
        }, 
    ]
};
var roomstay_blog_product_hero_builder_component_builderConfig = {
    component: roomstay_blog_products_hero,
    config: RoomstayBlogProductsHeroBuilderConfig
};
/* harmony default export */ var roomstay_blog_product_hero_builder_component = (roomstay_blog_product_hero_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/roomstay-blog-product-theme/roomstay-blog-product-theme.module.scss
var roomstay_blog_product_theme_module = __webpack_require__(5740);
var roomstay_blog_product_theme_module_default = /*#__PURE__*/__webpack_require__.n(roomstay_blog_product_theme_module);
;// CONCATENATED MODULE: ./components/roomstay-blog-product-theme/roomstay-blog-product-theme.tsx






var RoomstayBlogProductTheme = function(props) {
    var children = props.children;
    var ref = (0,esm/* useWindowSize */.iP)(), windowWidth = ref.width;
    var isMobile = windowWidth <= 768;
    var isTablet = windowWidth <= 991;
    var _backgroundColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (roomstay_blog_product_theme_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(clipped_box/* default */.Z, {
                configs: [
                    {
                        rad: isMobile ? Math.tan(101 / 375) : Math.tan(511 / 1920),
                        position: clipped_box/* POSITION.BottomRight */.V.BottomRight
                    }, 
                ],
                className: classnames_default()((roomstay_blog_product_theme_module_default()).background, (roomstay_blog_product_theme_module_default()).backgroundClippedBottom),
                style: {
                    backgroundColor: "".concat((_backgroundColor = props.backgroundColor) !== null && _backgroundColor !== void 0 ? _backgroundColor : "#000"),
                    maxHeight: isMobile ? 101 : isTablet ? 300 : 500,
                    transform: "rotate(180deg)",
                    marginBottom: -1
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (roomstay_blog_product_theme_module_default()).children,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FadeUpOnVisible/* default */.Z, {
                    children: children
                })
            })
        ]
    });
};
/* harmony default export */ var roomstay_blog_product_theme = (RoomstayBlogProductTheme);

;// CONCATENATED MODULE: ./components/roomstay-blog-product-theme/roomstay-blog-product-theme.builder-component.ts


var RoomstayBlogProductThemeBuilderConfig = {
    name: "Product Theme",
    inputs: [
        {
            name: "autoPadding",
            type: "boolean",
            defaultValue: true
        },
        {
            name: "backgroundColor",
            type: "color"
        }, 
    ]
};
var roomstay_blog_product_theme_builder_component_builderConfig = {
    component: (0,builder_react_es5/* withChildren */.u7)(roomstay_blog_product_theme),
    config: RoomstayBlogProductThemeBuilderConfig
};
/* harmony default export */ var roomstay_blog_product_theme_builder_component = (roomstay_blog_product_theme_builder_component_builderConfig);

;// CONCATENATED MODULE: ./components/roomstay-blog-products-card/roomstay-blog-product-card.builder-component.ts

var RoomstayBlogProductCardBuilderConfig = {
    name: "Product Card",
    inputs: [
        {
            name: "graphic",
            type: "file"
        },
        {
            name: "title",
            type: "html"
        },
        {
            name: "description",
            type: "html"
        },
        {
            name: "inverted",
            type: "boolean"
        },
        {
            name: "ctaButton",
            type: "object",
            subFields: [
                {
                    name: "text",
                    type: "string"
                },
                {
                    name: "href",
                    type: "string"
                }, 
            ]
        }, 
    ]
};
var roomstay_blog_product_card_builder_component_builderConfig = {
    component: roomstay_blog_product_card,
    config: RoomstayBlogProductCardBuilderConfig
};
/* harmony default export */ var roomstay_blog_product_card_builder_component = (roomstay_blog_product_card_builder_component_builderConfig);

;// CONCATENATED MODULE: ./components/Icon/icons/QuotationMarks.tsx

var QuotationMarks = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "73",
        height: "67",
        viewBox: "0 0 73 67",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M64.7946 0L70.7364 6.16737C67.7183 11.4003 65.0775 16.5398 62.814 21.5858C60.5504 26.8187 59.3243 31.8647 59.1357 36.7239L73 39.8075V67H42.4419V47.3766C42.4419 35.9763 44.7997 26.6318 49.5155 19.3431C54.0426 12.0544 59.1357 5.60669 64.7946 0ZM22.3527 0L28.2946 6.16737C25.2765 11.4003 22.6357 16.5398 20.3721 21.5858C18.1085 26.8187 16.8824 31.8647 16.6938 36.7239L30.5581 39.8075V67H0V47.3766C0 35.9763 2.35788 26.6318 7.07363 19.3431C11.6008 12.0544 16.6938 5.60669 22.3527 0Z",
            fill: "#7C39FF"
        })
    });
};
/* harmony default export */ var icons_QuotationMarks = (QuotationMarks);

;// CONCATENATED MODULE: ./components/Icon/icons/Roomstay.tsx

var Roomstay = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "161",
        height: "33",
        viewBox: "0 0 161 33",
        fill: "#7C39FF",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M29.1546 22.0625H27.9192V11.1584H33.1407C34.2498 11.1584 35.1392 11.4659 35.8091 12.0808C36.4789 12.6847 36.8138 13.5138 36.8138 14.568C36.8138 15.9296 36.2483 16.8575 35.1173 17.3517C34.7988 17.4944 34.4858 17.5988 34.1784 17.6646L37.0444 22.0625H35.5785L32.943 17.8788H29.1546V22.0625ZM29.1546 16.7093H32.9265C34.0905 16.7093 34.8921 16.3469 35.3314 15.6222C35.4961 15.3476 35.5785 14.9963 35.5785 14.568C35.5785 13.8762 35.3424 13.3326 34.8702 12.9373C34.398 12.531 33.7721 12.3279 32.9924 12.3279H29.1546V16.7093Z",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M50.369 11.0266C51.9942 11.0266 53.3284 11.5702 54.3716 12.6573C55.3928 13.7115 55.9034 15.0292 55.9034 16.6105C55.9034 18.1917 55.3928 19.5095 54.3716 20.5636C53.3284 21.6508 51.9942 22.1943 50.369 22.1943C48.7438 22.1943 47.4096 21.6508 46.3664 20.5636C45.3452 19.5095 44.8346 18.1917 44.8346 16.6105C44.8346 15.0292 45.3452 13.7115 46.3664 12.6573C47.4096 11.5702 48.7438 11.0266 50.369 11.0266ZM50.369 20.9919C51.6648 20.9919 52.7134 20.5691 53.5151 19.7236C54.2837 18.911 54.6681 17.8733 54.6681 16.6105C54.6681 15.3476 54.2837 14.3099 53.5151 13.4973C52.7134 12.6518 51.6648 12.229 50.369 12.229C49.0732 12.229 48.0245 12.6518 47.2229 13.4973C46.4543 14.3099 46.0699 15.3476 46.0699 16.6105C46.0699 17.8733 46.4543 18.911 47.2229 19.7236C48.0245 20.5691 49.0732 20.9919 50.369 20.9919Z",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M69.3113 11.0266C70.9365 11.0266 72.2707 11.5702 73.3139 12.6573C74.3351 13.7115 74.8457 15.0292 74.8457 16.6105C74.8457 18.1917 74.3351 19.5095 73.3139 20.5636C72.2707 21.6508 70.9365 22.1943 69.3113 22.1943C67.6861 22.1943 66.3519 21.6508 65.3087 20.5636C64.2875 19.5095 63.7768 18.1917 63.7768 16.6105C63.7768 15.0292 64.2875 13.7115 65.3087 12.6573C66.3519 11.5702 67.6861 11.0266 69.3113 11.0266ZM69.3113 20.9919C70.607 20.9919 71.6557 20.5691 72.4573 19.7236C73.226 18.911 73.6103 17.8733 73.6103 16.6105C73.6103 15.3476 73.226 14.3099 72.4573 13.4973C71.6557 12.6518 70.607 12.229 69.3113 12.229C68.0155 12.229 66.9668 12.6518 66.1652 13.4973C65.3965 14.3099 65.0122 15.3476 65.0122 16.6105C65.0122 17.8733 65.3965 18.911 66.1652 19.7236C66.9668 20.5691 68.0155 20.9919 69.3113 20.9919Z",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M94.0186 11.1584V22.0625H92.7832V13.0361L88.7477 18.2247L84.6463 13.0361V22.0625H83.4109V11.1584H84.8439L88.7477 16.3304L92.5856 11.1584H94.0186Z",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M104.522 12.8385C104.313 13.0142 104.171 13.2118 104.094 13.4315C104.028 13.6511 103.995 13.8872 103.995 14.1397C103.995 14.3813 104.099 14.6064 104.308 14.8151C104.527 15.0237 104.813 15.1994 105.164 15.3422C105.516 15.4849 105.916 15.6112 106.367 15.721C106.817 15.8308 107.273 15.9461 107.734 16.0669C108.206 16.1767 108.667 16.3085 109.117 16.4622C109.568 16.605 109.968 16.7917 110.32 17.0223C111.1 17.5164 111.489 18.1917 111.489 19.0483C111.489 20.0695 111.105 20.8491 110.336 21.3872C109.579 21.9253 108.524 22.1943 107.174 22.1943C105.647 22.1943 104.483 21.8759 103.682 21.239C102.968 20.668 102.562 19.8554 102.463 18.8012H103.748C103.792 19.5479 104.154 20.1189 104.835 20.5142C105.428 20.8546 106.213 21.0248 107.19 21.0248C109.233 21.0248 110.254 20.3824 110.254 19.0977C110.254 18.6584 110.067 18.3125 109.694 18.06C109.332 17.8074 108.87 17.5988 108.31 17.434C107.761 17.2693 107.163 17.1156 106.515 16.9728C105.878 16.8301 105.28 16.6489 104.72 16.4293C104.17 16.1987 103.709 15.9022 103.336 15.5398C102.974 15.1665 102.792 14.6668 102.792 14.0409C102.792 13.1514 103.133 12.4267 103.814 11.8667C104.494 11.3066 105.521 11.0266 106.894 11.0266C108.277 11.0266 109.348 11.3451 110.106 11.982C110.798 12.542 111.165 13.2613 111.209 14.1397H109.941C109.831 13.2393 109.249 12.6408 108.195 12.3443C107.822 12.2345 107.355 12.1796 106.795 12.1796C106.246 12.1796 105.779 12.2455 105.395 12.3773C105.022 12.4981 104.731 12.6518 104.522 12.8385Z",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M127.638 12.3443H123.833V22.0625H122.597V12.3443H118.792V11.1584H127.638V12.3443Z",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M144.354 22.0625H142.986L141.652 18.9H136.25L134.915 22.0625H133.548L138.177 11.1584H139.725L144.354 22.0625ZM141.175 17.7635L138.951 12.4432L136.727 17.7635H141.175Z",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M155.633 22.0625H154.398V17.747L149.819 11.1584H151.318L155.007 16.4622L158.697 11.1584H160.196L155.633 17.747V22.0625Z",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.000976562 20.7454C1.48709 21.5309 3.18114 21.9757 4.97907 21.9757C10.8705 21.9757 15.6464 17.1998 15.6464 11.3084C15.6464 5.41698 10.8705 0.641052 4.97907 0.641052C3.18114 0.641052 1.48709 1.08585 0.000976562 1.87142V20.7454Z",
                fill: "#00D7E1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M0 20.7449C1.48612 21.5305 3.18018 21.9753 4.97812 21.9753C10.8695 21.9753 15.6455 17.1994 15.6455 11.308C15.6455 5.41655 10.8695 0.640625 4.97812 0.640625C3.18018 0.640625 1.48612 1.08543 0 1.87101V20.7449Z",
                fill: "#FF0068"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.7518 29.1002L0.000244141 1.87292V18.7751V32.0566C1.59736 32.4384 3.26424 32.6405 4.97834 32.6405C9.33014 32.6405 13.3776 31.3374 16.7518 29.1002Z",
                fill: "#00D7E1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#7C39FF",
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M0.000244141 20.7454V18.823V1.92084L11.1359 20.0203C9.39645 21.2519 7.27196 21.9758 4.97842 21.9758C3.18045 21.9758 1.48638 21.531 0.000244141 20.7454Z"
            })
        ]
    });
};
/* harmony default export */ var icons_Roomstay = (Roomstay);

;// CONCATENATED MODULE: ./components/Icon/index.tsx



var IconType;
(function(IconType) {
    IconType["Roomstay"] = "Roomstay";
    IconType["QuotationMarks"] = "QuotationMarks";
})(IconType || (IconType = {}));
var Icon = function(param) {
    var type = param.type;
    switch(type){
        case IconType.Roomstay:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Roomstay, {});
        case IconType.QuotationMarks:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_QuotationMarks, {});
        default:
            return null;
    }
};
/* harmony default export */ var components_Icon = (Icon);

// EXTERNAL MODULE: ./components/roomstay-blog-quote/roomstay-blog-quote.module.scss
var roomstay_blog_quote_module = __webpack_require__(4678);
var roomstay_blog_quote_module_default = /*#__PURE__*/__webpack_require__.n(roomstay_blog_quote_module);
;// CONCATENATED MODULE: ./components/roomstay-blog-quote/roomstay-blog-quote.tsx



var RoomstayBlogQuote = function(props) {
    var quote = props.quote, author = props.author, jobTitle = props.jobTitle;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (roomstay_blog_quote_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (roomstay_blog_quote_module_default()).quoteMark,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Icon, {
                    type: IconType.QuotationMarks
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (roomstay_blog_quote_module_default()).quoteContent,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (roomstay_blog_quote_module_default()).quote,
                        dangerouslySetInnerHTML: {
                            __html: quote
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (roomstay_blog_quote_module_default()).author,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (roomstay_blog_quote_module_default()).name,
                                children: author
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (roomstay_blog_quote_module_default()).jobTitle,
                                children: jobTitle
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var roomstay_blog_quote = (RoomstayBlogQuote);

;// CONCATENATED MODULE: ./components/roomstay-blog-quote/roomstay-blog-quote.builder-component.ts

var RoomstayBlogQuoteBuilderConfig = {
    name: "Quote",
    inputs: [
        {
            name: "quote",
            type: "richText",
            defaultValue: ""
        },
        {
            name: "author",
            type: "string",
            defaultValue: ""
        },
        {
            name: "jobTitle",
            type: "string",
            defaultValue: ""
        }, 
    ]
};
var roomstay_blog_quote_builder_component_builderConfig = {
    component: roomstay_blog_quote,
    config: RoomstayBlogQuoteBuilderConfig
};
/* harmony default export */ var roomstay_blog_quote_builder_component = (roomstay_blog_quote_builder_component_builderConfig);

;// CONCATENATED MODULE: ./utils/CalculateRevPar.ts
var calculateRevParAverageDaily = function(dailyRates, occupancyRates) {
    if (occupancyRates === 0) {
        return 0;
    }
    var occupancyPercentage = occupancyRates / 100; // convert occupancy rate to a decimal
    var revPAR = dailyRates * occupancyPercentage;
    return revPAR.toFixed(2); // calculate RevPAR
};
var calculateRevParTotalRoom = function(totalRoomRevenues, totalNumberOfRooms, periods) {
    if (totalNumberOfRooms === 0) {
        return 0;
    }
    var adr = totalRoomRevenues / totalNumberOfRooms;
    var revPar = periods * adr;
    return revPar.toFixed(2); // calculate RevPAR
};

// EXTERNAL MODULE: ./components/roomstay-blog-revpar/roomstay-blog-revpar.module.scss
var roomstay_blog_revpar_module = __webpack_require__(2804);
var roomstay_blog_revpar_module_default = /*#__PURE__*/__webpack_require__.n(roomstay_blog_revpar_module);
;// CONCATENATED MODULE: ./components/roomstay-blog-revpar/roomstay-blog-revpar.tsx






var RoomstayBlogRevPar = function(props) {
    var spaceDefault = props.spaceDefault;
    var ref = (0,react.useState)(0), dailyRate = ref[0], setDailyRate = ref[1];
    var ref1 = (0,react.useState)(0), occupancyRate = ref1[0], setOccupancy = ref1[1];
    var ref2 = (0,react.useState)(0), Period = ref2[0], setPeriod = ref2[1];
    var ref3 = (0,react.useState)(0), totalRoomRevenue = ref3[0], setTotalRoomRevenue = ref3[1];
    var ref4 = (0,react.useState)(0), totalNumberOfRooms = ref4[0], setTotalNumberOfRooms = ref4[1];
    var onChangeDailyRage = function(e) {
        setDailyRate(Number(e.target.value));
    };
    var onChangeOccupancyRate = function(e) {
        setOccupancy(Number(e.target.value));
    };
    var onChangePeriod = function(e) {
        setPeriod(Number(e.target.value));
    };
    var onChangeRoomRevenue = function(e) {
        setTotalRoomRevenue(Number(e.target.value));
    };
    var onChangeNumberOfRooms = function(e) {
        setTotalNumberOfRooms(Number(e.target.value));
    };
    var totalRevPar = calculateRevParAverageDaily(dailyRate, occupancyRate);
    var totalRevParTotalRoom = calculateRevParTotalRoom(totalRoomRevenue, totalNumberOfRooms, Period);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((roomstay_blog_revpar_module_default()).container, (0,_define_property/* default */.Z)({}, (roomstay_blog_revpar_module_default()).spaceDefault, spaceDefault)),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((roomstay_blog_revpar_module_default()).methodOne, (0,_define_property/* default */.Z)({}, (roomstay_blog_revpar_module_default()).spaceDefault, spaceDefault)),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (roomstay_blog_revpar_module_default()).title,
                        children: "Method #1"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (roomstay_blog_revpar_module_default()).subTitle,
                        children: "Calculate RevPAR using Average Daily Rate and Occupancy Rate."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (roomstay_blog_revpar_module_default()).groupRevPar,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (roomstay_blog_revpar_module_default()).wrapper,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (roomstay_blog_revpar_module_default()).text,
                                        children: "Average Daily Rate (ADR)"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (roomstay_blog_revpar_module_default()).wrapperInput,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (roomstay_blog_revpar_module_default()).prefix,
                                                children: "ADR"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                className: (roomstay_blog_revpar_module_default()).input,
                                                type: "number",
                                                onChange: onChangeDailyRage
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (roomstay_blog_revpar_module_default()).wrapper,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (roomstay_blog_revpar_module_default()).text,
                                        children: "Occupancy Rate (in percentage)"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (roomstay_blog_revpar_module_default()).wrapperInput,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (roomstay_blog_revpar_module_default()).prefix,
                                                children: "%"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                className: (roomstay_blog_revpar_module_default()).input,
                                                type: "number",
                                                onChange: onChangeOccupancyRate
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (roomstay_blog_revpar_module_default()).totalRevPar,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (roomstay_blog_revpar_module_default()).text,
                                children: "Your RevPAR is:"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (roomstay_blog_revpar_module_default()).number,
                                children: totalRevPar
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((roomstay_blog_revpar_module_default()).methodTow, (0,_define_property/* default */.Z)({}, (roomstay_blog_revpar_module_default()).spaceDefault, spaceDefault)),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (roomstay_blog_revpar_module_default()).title,
                        children: "Method #2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (roomstay_blog_revpar_module_default()).subTitle,
                        children: "Calculate RevPAR using the Total Room Revenue and Available Rooms."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (roomstay_blog_revpar_module_default()).groupRevPar,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (roomstay_blog_revpar_module_default()).wrapper,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (roomstay_blog_revpar_module_default()).text,
                                        children: "Period (in days)"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (roomstay_blog_revpar_module_default()).wrapperInput,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (roomstay_blog_revpar_module_default()).prefix,
                                                children: "days"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                className: (roomstay_blog_revpar_module_default()).input,
                                                type: "number",
                                                onChange: onChangePeriod
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (roomstay_blog_revpar_module_default()).wrapper,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (roomstay_blog_revpar_module_default()).text,
                                        children: "Total room revenue"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (roomstay_blog_revpar_module_default()).wrapperInput,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            className: (roomstay_blog_revpar_module_default()).input,
                                            type: "number",
                                            onChange: onChangeRoomRevenue
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (roomstay_blog_revpar_module_default()).wrapper,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (roomstay_blog_revpar_module_default()).text,
                                        children: "Total number of rooms"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (roomstay_blog_revpar_module_default()).wrapperInput,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (roomstay_blog_revpar_module_default()).prefix,
                                                children: "rooms"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                className: (roomstay_blog_revpar_module_default()).input,
                                                type: "number",
                                                onChange: onChangeNumberOfRooms
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (roomstay_blog_revpar_module_default()).totalRevPar,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (roomstay_blog_revpar_module_default()).text,
                                children: "Your RevPAR is:"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (roomstay_blog_revpar_module_default()).number,
                                children: totalRevParTotalRoom
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var roomstay_blog_revpar = (RoomstayBlogRevPar);

;// CONCATENATED MODULE: ./components/roomstay-blog-revpar/roomtay-blog-revpar.builder-component.ts

var roomtay_blog_revpar_builder_component_RoomstayBlogProductThemeBuilderConfig = {
    name: "RevPar",
    inputs: [
        {
            name: "spaceDefault",
            type: "boolean"
        }, 
    ]
};
var roomtay_blog_revpar_builder_component_builderConfig = {
    component: roomstay_blog_revpar,
    config: roomtay_blog_revpar_builder_component_RoomstayBlogProductThemeBuilderConfig
};
/* harmony default export */ var roomtay_blog_revpar_builder_component = (roomtay_blog_revpar_builder_component_builderConfig);

;// CONCATENATED MODULE: ./components/roomstay-blog-sem-helpdesk-form/roomstay-blog-sem-helpdesk-form.builder-component.ts

var roomstay_blog_sem_helpdesk_form_builder_component_config = {
    name: "Helpdesk Sem Form",
    inputs: [
        {
            name: "titleForm",
            type: "string"
        },
        {
            name: "fontSizeTitle",
            type: "text",
            enum: [
                "default",
                "small"
            ]
        },
        {
            name: "successMessage",
            type: "string"
        },
        {
            name: "buttonText",
            type: "string"
        }, 
    ]
};
var roomstay_blog_sem_helpdesk_form_builder_component_builderConfig = {
    component: roomstay_blog_sem_helpdesk_form,
    config: roomstay_blog_sem_helpdesk_form_builder_component_config
};
/* harmony default export */ var roomstay_blog_sem_helpdesk_form_builder_component = (roomstay_blog_sem_helpdesk_form_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/roomstay-blog-sem-hero/roomstay-blog-sem-hero.module.scss
var roomstay_blog_sem_hero_module = __webpack_require__(4909);
var roomstay_blog_sem_hero_module_default = /*#__PURE__*/__webpack_require__.n(roomstay_blog_sem_hero_module);
;// CONCATENATED MODULE: ./components/roomstay-blog-sem-hero/roomstay-blog-sem-hero.tsx







var RoomstayBlogSemHero = function(props) {
    var title = props.title, subTitle = props.subTitle, description = props.description, image = props.image, buttonText = props.buttonText, titleForm = props.titleForm, showImage = props.showImage, hideClipped = props.hideClipped;
    var ref = (0,esm/* useWindowSize */.iP)(), windowWidth = ref.width;
    var isMobile = windowWidth <= 768;
    var isTablet = windowWidth <= 1200;
    var isDesktop = windowWidth <= 1920;
    var _backgroundColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (roomstay_blog_sem_hero_module_default()).container,
        children: [
            !hideClipped && /*#__PURE__*/ (0,jsx_runtime.jsx)(clipped_box/* default */.Z, {
                configs: [
                    {
                        rad: isMobile ? Math.tan(101 / 375) : isTablet ? Math.tan(431 / 1920) : isDesktop ? Math.tan(320 / 1920) : Math.tan(190 / 1920),
                        position: clipped_box/* POSITION.BottomRight */.V.BottomRight
                    }, 
                ],
                className: classnames_default()((roomstay_blog_sem_hero_module_default()).background, (roomstay_blog_sem_hero_module_default()).backgroundClippedBottom),
                style: {
                    backgroundColor: "".concat((_backgroundColor = props.backgroundColor) !== null && _backgroundColor !== void 0 ? _backgroundColor : "#1C1624"),
                    maxHeight: isMobile ? 300 : isTablet ? 300 : 420,
                    transform: "rotate(180deg)",
                    marginTop: -1
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (roomstay_blog_sem_hero_module_default()).wrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (roomstay_blog_sem_hero_module_default()).content,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: (roomstay_blog_sem_hero_module_default()).title,
                                dangerouslySetInnerHTML: {
                                    __html: title || ""
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (roomstay_blog_sem_hero_module_default()).subTitle,
                                dangerouslySetInnerHTML: {
                                    __html: subTitle || ""
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (roomstay_blog_sem_hero_module_default()).description,
                                dangerouslySetInnerHTML: {
                                    __html: description || ""
                                }
                            })
                        ]
                    }),
                    showImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(lazy_load_image_lazy_load_image/* default */.Z, {
                        className: (roomstay_blog_sem_hero_module_default()).image,
                        imageUrl: image
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (roomstay_blog_sem_hero_module_default()).wrapperForm,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(roomstay_blog_sem_helpdesk_form, {
                            titleForm: titleForm,
                            fontSizeTitle: "default",
                            buttonText: buttonText
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var roomstay_blog_sem_hero = (RoomstayBlogSemHero);

;// CONCATENATED MODULE: ./components/roomstay-blog-sem-hero/roomstay-blog-sem-hero.builder-component.ts

var roomstay_blog_sem_hero_builder_component_RoomstayBlogQuoteBuilderConfig = {
    name: "Sem Hero",
    inputs: [
        {
            name: "title",
            type: "html",
            defaultValue: ""
        },
        {
            name: "subTitle",
            type: "html",
            defaultValue: ""
        },
        {
            name: "description",
            type: "html",
            defaultValue: ""
        },
        {
            name: "image",
            type: "file",
            defaultValue: ""
        },
        {
            name: "titleForm",
            type: "string"
        },
        {
            name: "showImage",
            type: "boolean"
        },
        {
            name: "buttonText",
            type: "string"
        },
        {
            name: "hideClipped",
            type: "boolean"
        }, 
    ]
};
var roomstay_blog_sem_hero_builder_component_builderConfig = {
    component: roomstay_blog_sem_hero,
    config: roomstay_blog_sem_hero_builder_component_RoomstayBlogQuoteBuilderConfig
};
/* harmony default export */ var roomstay_blog_sem_hero_builder_component = (roomstay_blog_sem_hero_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/roomstay-blog-sem-list-solutions/roomstay-blog-sem-list-solution.module.scss
var roomstay_blog_sem_list_solution_module = __webpack_require__(4724);
var roomstay_blog_sem_list_solution_module_default = /*#__PURE__*/__webpack_require__.n(roomstay_blog_sem_list_solution_module);
;// CONCATENATED MODULE: ./components/roomstay-blog-sem-list-solutions/roomstay-blog-sem-list-solution.tsx



var RoomstayBlogSemListSolution = function(props) {
    var _items = props.items, items = _items === void 0 ? [] : _items;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (roomstay_blog_sem_list_solution_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (roomstay_blog_sem_list_solution_module_default()).content,
                children: items.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (roomstay_blog_sem_list_solution_module_default()).item,
                        children: [
                            item.icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(lazy_load_image/* LazyLoadImage */.e6, {
                                imageUrl: item.icon,
                                className: (roomstay_blog_sem_list_solution_module_default()).icon,
                                alt: "avatar",
                                loadingPlaceholder: false
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (roomstay_blog_sem_list_solution_module_default()).title,
                                dangerouslySetInnerHTML: {
                                    __html: item.title
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (roomstay_blog_sem_list_solution_module_default()).description,
                                dangerouslySetInnerHTML: {
                                    __html: item.description
                                }
                            })
                        ]
                    }, new Date().getTime() + index);
                })
            })
        })
    });
};
/* harmony default export */ var roomstay_blog_sem_list_solution = (RoomstayBlogSemListSolution);

;// CONCATENATED MODULE: ./components/roomstay-blog-sem-list-solutions/roomstay-blog-sem-list-solution.builder-component.ts

var roomstay_blog_sem_list_solution_builder_component_RoomstayBlogOurPromiseBuilderConfig = {
    name: "List Sem Solution",
    inputs: [
        {
            name: "items",
            type: "list",
            subFields: [
                {
                    name: "icon",
                    type: "file"
                },
                {
                    name: "title",
                    type: "html"
                },
                {
                    name: "description",
                    type: "html"
                }, 
            ]
        }, 
    ]
};
var roomstay_blog_sem_list_solution_builder_component_builderConfig = {
    component: roomstay_blog_sem_list_solution,
    config: roomstay_blog_sem_list_solution_builder_component_RoomstayBlogOurPromiseBuilderConfig
};
/* harmony default export */ var roomstay_blog_sem_list_solution_builder_component = (roomstay_blog_sem_list_solution_builder_component_builderConfig);

// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 94 modules
var swiper_esm = __webpack_require__(4159);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(933);
// EXTERNAL MODULE: ./node_modules/swiper/modules/effect-fade/effect-fade.min.css
var effect_fade_min = __webpack_require__(9846);
// EXTERNAL MODULE: ./node_modules/swiper/modules/navigation/navigation.min.css
var navigation_min = __webpack_require__(92);
// EXTERNAL MODULE: ./node_modules/swiper/modules/pagination/pagination.min.css
var pagination_min = __webpack_require__(8770);
// EXTERNAL MODULE: ./components/roomstay-blog-sem-list/roomstay-blog-sem-list.module.scss
var roomstay_blog_sem_list_module = __webpack_require__(844);
var roomstay_blog_sem_list_module_default = /*#__PURE__*/__webpack_require__.n(roomstay_blog_sem_list_module);
// EXTERNAL MODULE: ./components/roomstay-blog-sem-list/sem-card/sem-card.module.scss
var sem_card_module = __webpack_require__(3893);
var sem_card_module_default = /*#__PURE__*/__webpack_require__.n(sem_card_module);
;// CONCATENATED MODULE: ./components/roomstay-blog-sem-list/sem-card/sem-card.tsx



var SemCard = function(props) {
    var image = props.image, title = props.title, description = props.description;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (sem_card_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (sem_card_module_default()).imageContainer,
                children: image && /*#__PURE__*/ (0,jsx_runtime.jsx)(lazy_load_image/* LazyLoadImage */.e6, {
                    className: (sem_card_module_default()).image,
                    imageUrl: image,
                    alt: ""
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (sem_card_module_default()).title,
                dangerouslySetInnerHTML: {
                    __html: title || ""
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (sem_card_module_default()).divider
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (sem_card_module_default()).description,
                dangerouslySetInnerHTML: {
                    __html: description || ""
                }
            })
        ]
    });
};
/* harmony default export */ var sem_card = (SemCard);

;// CONCATENATED MODULE: ./components/roomstay-blog-sem-list/roomstay-blog-sem-list.tsx












var roomstay_blog_sem_list_options = {
    slidesPerView: "auto",
    spaceBetween: 24,
    allowTouchMove: true,
    noSwiping: false,
    effect: "slide",
    cssMode: true,
    autoplay: {
        delay: 5000,
        disableOnInteraction: false
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
    },
    watchSlidesProgress: true,
    freeMode: true,
    pagination: {
        clickable: true
    },
    modules: [
        swiper_esm/* EffectFade */.xW,
        swiper_esm/* Navigation */.W_,
        swiper_esm/* Pagination */.tl,
        swiper_esm/* Autoplay */.pt
    ],
    breakpoints: {
        992: {
            watchOverflow: true
        },
        768: {
            spaceBetween: 20
        }
    }
};
var RoomstayBlogSemList = function(props) {
    var cards = props.cards;
    var ref = (0,react.useState)(false), showBgShadowRight = ref[0], setShowBgShadowRight = ref[1];
    var ref1 = (0,react.useState)(true), showBgShadowLeft = ref1[0], setShowBgShadowLeft = ref1[1];
    if (!(cards === null || cards === void 0 ? void 0 : cards.length)) return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: "123123"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (roomstay_blog_sem_list_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "swiper-button-next ",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "33",
                    height: "32",
                    viewBox: "0 0 33 32",
                    fill: "none",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M7.16675 16H25.8334",
                            stroke: "white",
                            strokeWidth: "2",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M16.5 6.66675L25.8333 16.0001L16.5 25.3334",
                            stroke: "white",
                            strokeWidth: "2",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "swiper-button-prev",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "33",
                    height: "32",
                    viewBox: "0 0 33 32",
                    fill: "none",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M7.16675 16H25.8334",
                            stroke: "white",
                            strokeWidth: "2",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M16.5 6.66675L25.8333 16.0001L16.5 25.3334",
                            stroke: "white",
                            strokeWidth: "2",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (roomstay_blog_sem_list_module_default()).box,
                children: [
                    !showBgShadowRight && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (roomstay_blog_sem_list_module_default()).bgShadowRight
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (roomstay_blog_sem_list_module_default()).bgShadowLeft
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, roomstay_blog_sem_list_options), {
                        onSlideChange: function(swiper) {
                            setShowBgShadowRight(swiper.isEnd);
                            setShowBgShadowLeft(swiper.isEnd);
                        },
                        children: cards.map(function(card) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (roomstay_blog_sem_list_module_default()).item,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sem_card, {
                                        image: card.image,
                                        title: card.title,
                                        description: card.description
                                    }, Math.random())
                                })
                            }, card.title);
                        })
                    }))
                ]
            })
        ]
    });
};
/* harmony default export */ var roomstay_blog_sem_list = (RoomstayBlogSemList);

;// CONCATENATED MODULE: ./components/roomstay-blog-sem-list/roomstay-blog-sem-list.builder-component.ts

var roomstay_blog_sem_list_builder_component_RoomstayBlogQuoteBuilderConfig = {
    name: "Sem List",
    inputs: [
        {
            name: "cards",
            type: "list",
            subFields: [
                {
                    name: "image",
                    type: "file"
                },
                {
                    name: "title",
                    type: "html"
                },
                {
                    name: "description",
                    type: "html"
                }, 
            ]
        }, 
    ]
};
var roomstay_blog_sem_list_builder_component_builderConfig = {
    component: roomstay_blog_sem_list,
    config: roomstay_blog_sem_list_builder_component_RoomstayBlogQuoteBuilderConfig
};
/* harmony default export */ var roomstay_blog_sem_list_builder_component = (roomstay_blog_sem_list_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/roomstay-blog-sem-theme/roomstay-blog-sem-theme.module.scss
var roomstay_blog_sem_theme_module = __webpack_require__(1725);
var roomstay_blog_sem_theme_module_default = /*#__PURE__*/__webpack_require__.n(roomstay_blog_sem_theme_module);
;// CONCATENATED MODULE: ./components/roomstay-blog-sem-theme/roomstay-blog-sem-theme.tsx







var RoomstayBlogSemTheme = function(props) {
    var backgroundColor = props.backgroundColor, children = props.children;
    var ref = (0,esm/* useWindowSize */.iP)(), windowWidth = ref.width;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,esm/* useElementSize */.h4)(), 2), introRef = ref1[0], ref2 = ref1[1], introHeight = ref2.height;
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,esm/* useElementSize */.h4)(), 2), containerRef = ref3[0], height = ref3[1].height;
    var isMobile = windowWidth <= 768;
    var isTablet = windowWidth <= 991;
    var _backgroundColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (roomstay_blog_sem_theme_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(clipped_box/* default */.Z, {
                configs: [
                    {
                        rad: isMobile ? Math.tan(101 / 375) : Math.tan(531 / 1920),
                        position: clipped_box/* POSITION.BottomRight */.V.BottomRight
                    }, 
                ],
                className: classnames_default()((roomstay_blog_sem_theme_module_default()).background, (roomstay_blog_sem_theme_module_default()).backgroundClippedBottom),
                style: {
                    backgroundColor: "".concat((_backgroundColor = props.backgroundColor) !== null && _backgroundColor !== void 0 ? _backgroundColor : "#1C1624"),
                    maxHeight: isMobile ? 300 : isTablet ? 400 : 600,
                    // transform: 'rotate(80deg)',
                    marginTop: -1
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (roomstay_blog_sem_theme_module_default()).children,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FadeUpOnVisible/* default */.Z, {
                    children: children
                })
            })
        ]
    });
};
/* harmony default export */ var roomstay_blog_sem_theme = (RoomstayBlogSemTheme);

;// CONCATENATED MODULE: ./components/roomstay-blog-sem-theme/roomstay-blog-sem-theme.builder-component.ts


var roomstay_blog_sem_theme_builder_component_RoomstayBlogProductThemeBuilderConfig = {
    name: "Sem Theme",
    inputs: [
        {
            name: "autoPadding",
            type: "boolean",
            defaultValue: true
        },
        {
            name: "backgroundColor",
            type: "color"
        }, 
    ]
};
var roomstay_blog_sem_theme_builder_component_builderConfig = {
    component: (0,builder_react_es5/* withChildren */.u7)(roomstay_blog_sem_theme),
    config: roomstay_blog_sem_theme_builder_component_RoomstayBlogProductThemeBuilderConfig
};
/* harmony default export */ var roomstay_blog_sem_theme_builder_component = (roomstay_blog_sem_theme_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/roomstay-blog-summing-up/roomstay-blog-summing-up.module.scss
var roomstay_blog_summing_up_module = __webpack_require__(6434);
var roomstay_blog_summing_up_module_default = /*#__PURE__*/__webpack_require__.n(roomstay_blog_summing_up_module);
;// CONCATENATED MODULE: ./components/roomstay-blog-summing-up/roomstay-blog-summing-up.tsx


var RoomstayBlogSummingUp = function(props) {
    var _items = props.items, items = _items === void 0 ? [] : _items;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (roomstay_blog_summing_up_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (roomstay_blog_summing_up_module_default()).summingUp,
                children: "Summing up..."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (roomstay_blog_summing_up_module_default()).items,
                children: items.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (roomstay_blog_summing_up_module_default()).item,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (roomstay_blog_summing_up_module_default()).number,
                                children: index + 1
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (roomstay_blog_summing_up_module_default()).content,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (roomstay_blog_summing_up_module_default()).title,
                                        children: item.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (roomstay_blog_summing_up_module_default()).description,
                                        children: item.description
                                    })
                                ]
                            })
                        ]
                    }, item.title);
                })
            })
        ]
    });
};
/* harmony default export */ var roomstay_blog_summing_up = (RoomstayBlogSummingUp);

;// CONCATENATED MODULE: ./components/roomstay-blog-summing-up/roomstay-blog-summing-up.builder-component.ts

var RoomstayBlogSummingUpBuilderConfig = {
    name: "Article Summing Up",
    inputs: [
        {
            name: "items",
            type: "list",
            defaultValue: "",
            subFields: [
                {
                    name: "title",
                    type: "string",
                    defaultValue: ""
                },
                {
                    name: "description",
                    type: "string",
                    defaultValue: ""
                }, 
            ]
        }, 
    ]
};
var roomstay_blog_summing_up_builder_component_builderConfig = {
    component: roomstay_blog_summing_up,
    config: RoomstayBlogSummingUpBuilderConfig
};
/* harmony default export */ var roomstay_blog_summing_up_builder_component = (roomstay_blog_summing_up_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/roomstay-blog-text-booking/roomstay-blog-text-booking.module.scss
var roomstay_blog_text_booking_module = __webpack_require__(5905);
var roomstay_blog_text_booking_module_default = /*#__PURE__*/__webpack_require__.n(roomstay_blog_text_booking_module);
;// CONCATENATED MODULE: ./components/roomstay-blog-text-booking/roomstay-blog-text-booking.tsx


var RoomStayBlogTextBooking = function(props) {
    var title = props.title, description = props.description;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (roomstay_blog_text_booking_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (roomstay_blog_text_booking_module_default()).titleContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (roomstay_blog_text_booking_module_default()).title,
                        dangerouslySetInnerHTML: {
                            __html: title
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (roomstay_blog_text_booking_module_default()).titleDivider
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (roomstay_blog_text_booking_module_default()).description,
                dangerouslySetInnerHTML: {
                    __html: description
                }
            })
        ]
    });
};
/* harmony default export */ var roomstay_blog_text_booking = (RoomStayBlogTextBooking);

;// CONCATENATED MODULE: ./components/roomstay-blog-text-booking/roomstay-blog-text-booking.builder-component.ts

var RoomStayBlogTextBookingBuilderConfig = {
    name: "Text Booking",
    inputs: [
        {
            name: "title",
            type: "html",
            defaultValue: ""
        },
        {
            name: "description",
            type: "richText",
            defaultValue: ""
        }, 
    ]
};
var roomstay_blog_text_booking_builder_component_builderConfig = {
    component: roomstay_blog_text_booking,
    config: RoomStayBlogTextBookingBuilderConfig
};
/* harmony default export */ var roomstay_blog_text_booking_builder_component = (roomstay_blog_text_booking_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/roomstay-blog-text-caption/roomstay-blog-text-caption.module.scss
var roomstay_blog_text_caption_module = __webpack_require__(2483);
var roomstay_blog_text_caption_module_default = /*#__PURE__*/__webpack_require__.n(roomstay_blog_text_caption_module);
;// CONCATENATED MODULE: ./components/roomstay-blog-text-caption/roomstay-blog-text-caption.tsx


var RoomstayBlogTextCaption = function(props) {
    var text = props.text;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (roomstay_blog_text_caption_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (roomstay_blog_text_caption_module_default()).textCaption,
            dangerouslySetInnerHTML: {
                __html: text
            }
        })
    });
};
/* harmony default export */ var roomstay_blog_text_caption = (RoomstayBlogTextCaption);

;// CONCATENATED MODULE: ./components/roomstay-blog-text-caption/roomstay-blog-text-caption.builder-component.ts

var RoomstayBlogTextCaptionBuilderConfig = {
    name: "Text Caption",
    inputs: [
        {
            name: "text",
            type: "richText",
            defaultValue: ""
        }, 
    ]
};
var roomstay_blog_text_caption_builder_component_builderConfig = {
    component: roomstay_blog_text_caption,
    config: RoomstayBlogTextCaptionBuilderConfig
};
/* harmony default export */ var roomstay_blog_text_caption_builder_component = (roomstay_blog_text_caption_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/roomstay-blog-text-footer/roomstay-blog-text-footer.module.scss
var roomstay_blog_text_footer_module = __webpack_require__(6806);
var roomstay_blog_text_footer_module_default = /*#__PURE__*/__webpack_require__.n(roomstay_blog_text_footer_module);
;// CONCATENATED MODULE: ./components/roomstay-blog-text-footer/roomstay-blog-text-footer.tsx




var RoomstayBlogTextFooter = function(props) {
    var ref = (0,esm/* useWindowSize */.iP)(), windowWidth = ref.width;
    var isTablet = windowWidth <= 1200;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (roomstay_blog_text_footer_module_default()).container,
        children: [
            isTablet ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (roomstay_blog_text_footer_module_default()).headText,
                children: [
                    "Ready to take your hote",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        style: {
                            background: "#6333c6"
                        },
                        children: "l's booking"
                    }),
                    " performance to the next level?"
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (roomstay_blog_text_footer_module_default()).headText,
                children: [
                    "Ready to take your hotel's booking ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        style: {
                            background: "#6333c6"
                        },
                        children: "performance to the next level?"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (roomstay_blog_text_footer_module_default()).subText,
                children: "Sign up for our free booking performance audit today and see how RoomStay can help you drive more bookings and increase revenue."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                type: "secondary",
                size: "large",
                link: "/book-demo",
                children: "Book a Demo"
            })
        ]
    });
};
/* harmony default export */ var roomstay_blog_text_footer = (RoomstayBlogTextFooter);

;// CONCATENATED MODULE: ./components/roomstay-blog-text-footer/roomstay-blog-text-footer.builder-component.ts

var RoomStayBlogTextFooterBuilderConfig = {
    name: "Text Footer",
    inputs: [
        {
            name: "headText",
            type: "html",
            defaultValue: ""
        },
        {
            name: "subText",
            type: "html",
            defaultValue: ""
        }, 
    ]
};
var roomstay_blog_text_footer_builder_component_builderConfig = {
    component: roomstay_blog_text_footer,
    config: RoomStayBlogTextFooterBuilderConfig
};
/* harmony default export */ var roomstay_blog_text_footer_builder_component = (roomstay_blog_text_footer_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/roomstay-blog-text-intro-user/roomstay-blog-text-intro-user.module.scss
var roomstay_blog_text_intro_user_module = __webpack_require__(5951);
var roomstay_blog_text_intro_user_module_default = /*#__PURE__*/__webpack_require__.n(roomstay_blog_text_intro_user_module);
;// CONCATENATED MODULE: ./components/roomstay-blog-text-intro-user/roomstay-blog-text-intro-user.tsx


var RoomStayBlogTexIntroUser = function(props) {
    var title = props.title, description = props.description, subTitle = props.subTitle;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (roomstay_blog_text_intro_user_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (roomstay_blog_text_intro_user_module_default()).containerWrapper,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (roomstay_blog_text_intro_user_module_default()).containerWrapperTitle,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (roomstay_blog_text_intro_user_module_default()).containerWrapperTitleText,
                        dangerouslySetInnerHTML: {
                            __html: title
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (roomstay_blog_text_intro_user_module_default()).containerWrapperTitleDivider
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (roomstay_blog_text_intro_user_module_default()).containerSubTitle,
                        dangerouslySetInnerHTML: {
                            __html: subTitle
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (roomstay_blog_text_intro_user_module_default()).containerDescription,
                        dangerouslySetInnerHTML: {
                            __html: description
                        }
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var roomstay_blog_text_intro_user = (RoomStayBlogTexIntroUser);

;// CONCATENATED MODULE: ./components/roomstay-blog-text-intro-user/roomstay-blog-text-intro-user.builder-component.ts

var RoomStayBlogTextIntroUserBuilderConfig = {
    name: "Text intro user",
    inputs: [
        {
            name: "title",
            type: "richText",
            defaultValue: ""
        },
        {
            name: "subTitle",
            type: "richText",
            defaultValue: ""
        },
        {
            name: "description",
            type: "richText",
            defaultValue: ""
        }, 
    ]
};
var roomstay_blog_text_intro_user_builder_component_builderConfig = {
    component: roomstay_blog_text_intro_user,
    config: RoomStayBlogTextIntroUserBuilderConfig
};
/* harmony default export */ var roomstay_blog_text_intro_user_builder_component = (roomstay_blog_text_intro_user_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/roomstay-blog-text-synxis-booking/roomstay-blog-text-synxis-booking.module.scss
var roomstay_blog_text_synxis_booking_module = __webpack_require__(1368);
var roomstay_blog_text_synxis_booking_module_default = /*#__PURE__*/__webpack_require__.n(roomstay_blog_text_synxis_booking_module);
;// CONCATENATED MODULE: ./components/roomstay-blog-text-synxis-booking/roomstay-blog-text-synxis-booking.tsx


var RoomStayBlogTextSynXisBooking = function(props) {
    var title = props.title, description = props.description;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (roomstay_blog_text_synxis_booking_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (roomstay_blog_text_synxis_booking_module_default()).titleContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (roomstay_blog_text_synxis_booking_module_default()).title,
                        dangerouslySetInnerHTML: {
                            __html: title
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (roomstay_blog_text_synxis_booking_module_default()).titleDivider
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (roomstay_blog_text_synxis_booking_module_default()).description,
                dangerouslySetInnerHTML: {
                    __html: description
                }
            })
        ]
    });
};
/* harmony default export */ var roomstay_blog_text_synxis_booking = (RoomStayBlogTextSynXisBooking);

;// CONCATENATED MODULE: ./components/roomstay-blog-text-synxis-booking/roomstay-blog-text-synxis-booking.builder-component.ts

var RoomStayBlogTextSynXisBookingBuilderConfig = {
    name: "Text SynXis Booking",
    inputs: [
        {
            name: "title",
            type: "html",
            defaultValue: ""
        },
        {
            name: "description",
            type: "richText",
            defaultValue: ""
        }, 
    ]
};
var roomstay_blog_text_synxis_booking_builder_component_builderConfig = {
    component: roomstay_blog_text_synxis_booking,
    config: RoomStayBlogTextSynXisBookingBuilderConfig
};
/* harmony default export */ var roomstay_blog_text_synxis_booking_builder_component = (roomstay_blog_text_synxis_booking_builder_component_builderConfig);

;// CONCATENATED MODULE: ./components/roomstay-blog-text-wrap/roomstay-blog-text-wrap.builder-component.ts

var roomstay_blog_text_wrap_builder_component_config = {
    name: "Text Wrap",
    inputs: [
        {
            name: "text",
            type: "richText"
        },
        {
            name: "dark",
            type: "boolean"
        },
        {
            name: "noPadding",
            type: "boolean"
        },
        {
            name: "positionText",
            type: "string",
            enum: [
                "left",
                "center",
                "right"
            ]
        }, 
    ]
};
var roomstay_blog_text_wrap_builder_component_builderConfig = {
    component: roomstay_blog_text_wrap,
    config: roomstay_blog_text_wrap_builder_component_config
};
/* harmony default export */ var roomstay_blog_text_wrap_builder_component = (roomstay_blog_text_wrap_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/roomstay-blog-use-case-hero/roomstay-blog-use-case-hero.module.scss
var roomstay_blog_use_case_hero_module = __webpack_require__(1572);
var roomstay_blog_use_case_hero_module_default = /*#__PURE__*/__webpack_require__.n(roomstay_blog_use_case_hero_module);
;// CONCATENATED MODULE: ./components/roomstay-blog-use-case-hero/roomstay-blog-use-case-hero.tsx







var RoomstayBlogHeroUseCases = function(props) {
    var heading = props.heading, title = props.title, description = props.description, image = props.image;
    var ref = (0,_sliced_to_array/* default */.Z)((0,esm/* useElementSize */.h4)(), 2), introRef = ref[0], ref1 = ref[1], introHeight = ref1.height;
    var ref2 = (0,esm/* useWindowSize */.iP)(), windowWidth = ref2.width;
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,esm/* useElementSize */.h4)(), 2), containerRef = ref3[0], height = ref3[1].height;
    var width = (0,esm/* useWindowSize */.iP)().width;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: containerRef,
        className: (roomstay_blog_use_case_hero_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (roomstay_blog_use_case_hero_module_default()).background,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(clipped_box/* default */.Z, {
                        configs: [],
                        className: (roomstay_blog_use_case_hero_module_default()).background,
                        style: {
                            backgroundColor: "#F9F9FA",
                            maxHeight: "".concat(height / 2, "px")
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(clipped_box/* default */.Z, {
                        configs: [
                            {
                                rad: Math.atan(190 / 1920),
                                position: clipped_box/* POSITION.BottomRight */.V.BottomRight
                            }, 
                        ],
                        className: classnames_default()((roomstay_blog_use_case_hero_module_default()).background, (roomstay_blog_use_case_hero_module_default()).backgroundClipped),
                        style: {
                            backgroundColor: "#F9F9FA",
                            maxHeight: "".concat(windowWidth > 768 ? introHeight + 380 + 156 : introHeight + 530 + 38, "px"),
                            marginTop: "-2px"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (roomstay_blog_use_case_hero_module_default()).wrapContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (roomstay_blog_use_case_hero_module_default()).wrapImg,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (roomstay_blog_use_case_hero_module_default()).img,
                            children: image && /*#__PURE__*/ (0,jsx_runtime.jsx)(lazy_load_image/* LazyLoadImage */.e6, {
                                imageUrl: image,
                                alt: "",
                                objectFit: "cover"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (roomstay_blog_use_case_hero_module_default()).gridContent,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (roomstay_blog_use_case_hero_module_default()).wrapContent,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (roomstay_blog_use_case_hero_module_default()).heading,
                                        children: heading
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        className: (roomstay_blog_use_case_hero_module_default()).title,
                                        dangerouslySetInnerHTML: {
                                            __html: title
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (roomstay_blog_use_case_hero_module_default()).description,
                                        dangerouslySetInnerHTML: {
                                            __html: description
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (roomstay_blog_use_case_hero_module_default()).box
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var roomstay_blog_use_case_hero = (RoomstayBlogHeroUseCases);

;// CONCATENATED MODULE: ./components/roomstay-blog-use-case-hero/roomstay-blog-use-case-hero.builder-component.ts

var RoomstayBlogHeroUseCasesBuilderConfig = {
    name: "Hero Use Cases",
    inputs: [
        {
            name: "heading",
            type: "string"
        },
        {
            name: "title",
            type: "html"
        },
        {
            name: "description",
            type: "html"
        },
        {
            name: "image",
            type: "file"
        }, 
    ]
};
var roomstay_blog_use_case_hero_builder_component_builderConfig = {
    component: roomstay_blog_use_case_hero,
    config: RoomstayBlogHeroUseCasesBuilderConfig
};
/* harmony default export */ var roomstay_blog_use_case_hero_builder_component = (roomstay_blog_use_case_hero_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/roomstay-integration-module/roomstay-integration-module.module.scss
var roomstay_integration_module_module = __webpack_require__(6321);
var roomstay_integration_module_module_default = /*#__PURE__*/__webpack_require__.n(roomstay_integration_module_module);
;// CONCATENATED MODULE: ./components/roomstay-integration-module/roomstay-integration-module.tsx









var RoomstayIntegrationModule = function(props) {
    var headline = props.headline, title = props.title, height = props.height, description = props.description, cta = props.cta, images = props.images;
    var width = (0,esm/* useWindowSize */.iP)().width;
    var image = (0,react.useMemo)(function() {
        if (!images) return null;
        if (!images.mobile) return images.desktop;
        if (width > 992) return images.desktop;
        return images.mobile;
    }, [
        width,
        images
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FadeUpOnVisible/* default */.Z, {
        delay: models_AnimationDelay.A200,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "container",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (roomstay_integration_module_module_default()).container,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (roomstay_integration_module_module_default()).left,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (roomstay_integration_module_module_default()).headline,
                                dangerouslySetInnerHTML: {
                                    __html: headline || ""
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (roomstay_integration_module_module_default()).title,
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (roomstay_integration_module_module_default()).line
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (roomstay_integration_module_module_default()).description,
                                dangerouslySetInnerHTML: {
                                    __html: description || ""
                                }
                            }),
                            (cta === null || cta === void 0 ? void 0 : cta.text) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                    link: cta === null || cta === void 0 ? void 0 : cta.url,
                                    type: "secondary",
                                    hideShadow: true,
                                    children: cta === null || cta === void 0 ? void 0 : cta.text
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()((roomstay_integration_module_module_default()).right, (roomstay_integration_module_module_default())["right-height-".concat(images === null || images === void 0 ? void 0 : images.height)]),
                        children: image ? /*#__PURE__*/ (0,jsx_runtime.jsx)(lazy_load_image/* LazyLoadImage */.e6, {
                            className: (roomstay_integration_module_module_default()).image,
                            imageUrl: image,
                            layout: "fill",
                            objectFit: "contain"
                        }) : null
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var roomstay_integration_module = (RoomstayIntegrationModule);

;// CONCATENATED MODULE: ./components/roomstay-integration-module/roomstay-integration-module.builder-component.ts

var roomstay_integration_module_builder_component_config = {
    name: "Integration module",
    inputs: [
        {
            name: "headline",
            type: "html"
        },
        {
            name: "title",
            type: "text"
        },
        {
            name: "description",
            type: "richText"
        },
        {
            name: "cta",
            type: "object",
            subFields: [
                {
                    name: "text",
                    type: "text"
                },
                {
                    name: "url",
                    type: "string"
                }, 
            ]
        },
        {
            name: "images",
            type: "object",
            subFields: [
                {
                    name: "height",
                    type: "string",
                    enum: [
                        "default",
                        "full"
                    ]
                },
                {
                    name: "desktop",
                    type: "file"
                },
                {
                    name: "mobile",
                    type: "file"
                }, 
            ]
        }, 
    ]
};
var roomstay_integration_module_builder_component_builderConfig = {
    component: roomstay_integration_module,
    config: roomstay_integration_module_builder_component_config
};
/* harmony default export */ var roomstay_integration_module_builder_component = (roomstay_integration_module_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/roomstay-members/roomstay-members.module.scss
var roomstay_members_module = __webpack_require__(242);
var roomstay_members_module_default = /*#__PURE__*/__webpack_require__.n(roomstay_members_module);
;// CONCATENATED MODULE: ./components/roomstay-members/roomstay-members.tsx







var RoomstayMembers = function(props) {
    var _members = props.members, members = _members === void 0 ? [] : _members, title = props.title, subTitle = props.subTitle, description = props.description;
    var ref = (0,_sliced_to_array/* default */.Z)((0,esm/* useElementSize */.h4)(), 2), containerRef = ref[0], height = ref[1].height;
    var ref1 = (0,esm/* useWindowSize */.iP)(), windowWidth = ref1.width;
    var clippedRadian = Math.atan(1438 / 1920);
    var clippedMaxHeight = "".concat(height * 0.38, "px");
    if (windowWidth < 1300) {
        clippedRadian = Math.atan(0.3);
        clippedMaxHeight = "".concat(height * 0.33, "px");
    }
    if (windowWidth < 998) {
        clippedMaxHeight = "".concat(height * 0.24, "px");
    }
    if (windowWidth < 768) {
        clippedRadian = Math.atan(0.3);
        clippedMaxHeight = "".concat(height * 0.175, "px");
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: containerRef,
        className: (roomstay_members_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (roomstay_members_module_default()).intro,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (roomstay_members_module_default()).heading,
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (roomstay_members_module_default()).divider
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (roomstay_members_module_default()).title,
                        children: subTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (roomstay_members_module_default()).description,
                        children: description
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (roomstay_members_module_default()).memberContainer,
                children: members.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (roomstay_members_module_default()).member,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (roomstay_members_module_default()).avatar,
                                children: item.avatar ? /*#__PURE__*/ (0,jsx_runtime.jsx)(lazy_load_image_lazy_load_image/* default */.Z, {
                                    imageUrl: item.avatar,
                                    objectFit: "cover"
                                }) : null
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (roomstay_members_module_default()).infoBlock,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (roomstay_members_module_default()).name,
                                        children: item.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (roomstay_members_module_default()).jobTitle,
                                        children: item.jobTitle
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (roomstay_members_module_default()).description,
                                        dangerouslySetInnerHTML: {
                                            __html: item.description
                                        }
                                    })
                                ]
                            })
                        ]
                    }, new Date().getTime() + index);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (roomstay_members_module_default()).background
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(clipped_box/* default */.Z, {
                configs: [
                    {
                        rad: clippedRadian,
                        position: clipped_box/* POSITION.BottomRight */.V.BottomRight
                    }, 
                ],
                className: classnames_default()((roomstay_members_module_default()).background, (roomstay_members_module_default()).backgroundClipped),
                style: {
                    maxHeight: clippedMaxHeight
                }
            })
        ]
    });
};
/* harmony default export */ var roomstay_members = (RoomstayMembers);

;// CONCATENATED MODULE: ./components/roomstay-members/roomstay-members.builder-component.ts

var RoomstayMemberBuilderConfig = {
    name: "Roomstay members",
    inputs: [
        {
            name: "title",
            type: "text"
        },
        {
            name: "subTitle",
            type: "text"
        },
        {
            name: "description",
            type: "text"
        },
        {
            name: "members",
            type: "list",
            subFields: [
                {
                    name: "avatar",
                    type: "file"
                },
                {
                    name: "name",
                    type: "text"
                },
                {
                    name: "jobTitle",
                    type: "text"
                },
                {
                    name: "description",
                    type: "richText",
                    defaultValue: ""
                }, 
            ]
        }, 
    ]
};
var roomstay_members_builder_component_builderConfig = {
    component: roomstay_members,
    config: RoomstayMemberBuilderConfig
};
/* harmony default export */ var roomstay_members_builder_component = (roomstay_members_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/roomstay-stats/roomstay-stats.module.scss
var roomstay_stats_module = __webpack_require__(8619);
var roomstay_stats_module_default = /*#__PURE__*/__webpack_require__.n(roomstay_stats_module);
;// CONCATENATED MODULE: ./components/roomstay-stats/roomstay-stats.tsx


var RoomstayStats = function(props) {
    var _items = props.items, items = _items === void 0 ? [] : _items;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (roomstay_stats_module_default()).container,
        children: items.map(function(item, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (roomstay_stats_module_default()).content,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (roomstay_stats_module_default()).title,
                        children: item.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (roomstay_stats_module_default()).description,
                        children: item.description
                    })
                ]
            }, new Date().getTime() + index);
        })
    });
};
/* harmony default export */ var roomstay_stats = (RoomstayStats);

;// CONCATENATED MODULE: ./components/roomstay-stats/roomstay-stats.builder-component.ts

var RoomstayStatsBuilderConfig = {
    name: "Roomstay stats",
    inputs: [
        {
            name: "items",
            type: "list",
            subFields: [
                {
                    name: "title",
                    type: "string"
                },
                {
                    name: "description",
                    type: "string"
                }, 
            ]
        }, 
    ]
};
var roomstay_stats_builder_component_builderConfig = {
    component: roomstay_stats,
    config: RoomstayStatsBuilderConfig
};
/* harmony default export */ var roomstay_stats_builder_component = (roomstay_stats_builder_component_builderConfig);

// EXTERNAL MODULE: ./node_modules/react-dropdown/dist/index.js
var dist = __webpack_require__(6451);
;// CONCATENATED MODULE: ./components/roonstay-blog-helpdesk-form/roomstay-blog-helpdesk-form.tsx










var RoomstayBlogHelpdeskForm = function(param) {
    var title = param.title, description = param.description, successMessage = param.successMessage, textColorInput = param.textColorInput;
    var formMethods = (0,dist_index_esm/* useForm */.cI)({
        mode: "onChange"
    });
    var ref = (0,react.useState)(""), type = ref[0], setType = ref[1];
    var ref1 = (0,react.useState)(false), sending = ref1[0], setSending = ref1[1];
    var ref2 = (0,react.useState)(false), success = ref2[0], setSuccess = ref2[1];
    var dropdownOptions = [
        "Talk to Sales",
        "Customer Support",
        "Media Enquiry"
    ].map(function(item) {
        return {
            label: item,
            value: item
        };
    });
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var values, response;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setSending(true);
                        values = formMethods.getValues();
                        _ctx.prev = 2;
                        _ctx.next = 5;
                        return fetch("/api/ticket/raise", {
                            method: "POST",
                            body: JSON.stringify({
                                type: type,
                                email: values.email,
                                message: values.message,
                                name: values.name,
                                mobile: values.mobile
                            })
                        });
                    case 5:
                        response = _ctx.sent;
                        setType("");
                        formMethods.reset();
                        setSuccess(response.ok);
                        setSending(false);
                        _ctx.next = 15;
                        break;
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](2);
                        setSending(false);
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    12
                ]
            ]);
        }));
        return function onSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "centered-body",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "container",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row justify-content-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-md-6 col-lg-5 col-xl-4",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                        onSubmit: formMethods.handleSubmit(onSubmit),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "u-marg-bottom",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: "headline u-text-center",
                                    children: title
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "u-marg-bottom--largest",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "body-text u-text-center",
                                    children: description
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "helpdesk-inputs",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputGroup, {
                                        dimensions: "2/2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "u-marg-bottom",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                                    type: "text",
                                                    required: true,
                                                    style: {
                                                        color: textColorInput
                                                    },
                                                    className: "text-input",
                                                    placeholder: "Your name",
                                                    tabIndex: 1
                                                }, formMethods.register("name")))
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "u-marg-bottom",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                                    type: "text",
                                                    style: {
                                                        color: textColorInput
                                                    },
                                                    required: true,
                                                    className: "text-input",
                                                    placeholder: "Your number",
                                                    tabIndex: 1
                                                }, formMethods.register("mobile")))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "u-marg-bottom",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                            style: {
                                                color: textColorInput
                                            },
                                            type: "email",
                                            required: true,
                                            className: "text-input",
                                            placeholder: "Your Email",
                                            tabIndex: 1
                                        }, formMethods.register("email")))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "u-marg-bottom",
                                        style: (0,_define_property/* default */.Z)({}, "--colorText", textColorInput),
                                        tabIndex: 2,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                            className: "color-text",
                                            options: dropdownOptions,
                                            placeholder: "Type of enquiry",
                                            arrowOpen: "\u2303",
                                            arrowClosed: "\u2304",
                                            value: type,
                                            onChange: function(value) {
                                                return setType(value.value);
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "u-marg-bottom",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", (0,_object_spread/* default */.Z)({
                                            style: {
                                                color: textColorInput
                                            },
                                            className: "text-input",
                                            placeholder: "Type your message, questions, details here...",
                                            tabIndex: 3
                                        }, formMethods.register("message")))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "d-flex justify-content-between align-items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "body-text --small --cyan u-pad-right",
                                        style: {
                                            opacity: success ? 1 : 0
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            children: successMessage || "Thanks! Message sent."
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                        type: "secondary",
                                        loading: sending,
                                        htmlType: "submit",
                                        theme: "primary",
                                        onSubmit: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                                            return runtime_default().wrap(function _callee$(_ctx) {
                                                while(1)switch(_ctx.prev = _ctx.next){
                                                    case 0:
                                                        _ctx.next = 2;
                                                        return formMethods.handleSubmit(onSubmit)();
                                                    case 2:
                                                    case "end":
                                                        return _ctx.stop();
                                                }
                                            }, _callee);
                                        })),
                                        style: {
                                            flexShrink: 1,
                                            display: "flex",
                                            whiteSpace: "nowrap"
                                        },
                                        children: "Send Message"
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ var roomstay_blog_helpdesk_form = (RoomstayBlogHelpdeskForm);

;// CONCATENATED MODULE: ./components/roonstay-blog-helpdesk-form/roomstay-blog-helpdesk-form.builder-component.ts

var roomstay_blog_helpdesk_form_builder_component_config = {
    name: "Helpdesk Form",
    inputs: [
        {
            name: "title",
            type: "string"
        },
        {
            name: "description",
            type: "string"
        },
        {
            name: "successMessage",
            type: "string"
        },
        {
            name: "textColorInput",
            type: "color"
        }, 
    ]
};
var roomstay_blog_helpdesk_form_builder_component_builderConfig = {
    component: roomstay_blog_helpdesk_form,
    config: roomstay_blog_helpdesk_form_builder_component_config
};
/* harmony default export */ var roomstay_blog_helpdesk_form_builder_component = (roomstay_blog_helpdesk_form_builder_component_builderConfig);

;// CONCATENATED MODULE: ./builder/index.ts

// @ts-ignore - Suppressing "unable to find module" error because webpack preloader will load all matching files
// eslint-disable-next-line import/no-unresolved































































var builderComponentConfigs = [
    roomstay_blog_book_a_demo_builder_component_namespaceObject,
    roomstay_blog_button_custom_builder_component_namespaceObject,
    roomstay_blog_about_hero_builder_component_namespaceObject,
    roomstay_blog_all_articles_builder_component,
    roomstay_blog_article_card_builder_component_namespaceObject,
    roomstay_blog_article_text_list_builder_component_namespaceObject,
    roomstay_blog_blog_hero_builder_component,
    roomstay_blog_book_demo_form_builder_component_namespaceObject,
    roomstay_blog_button_builder_component_namespaceObject,
    roomstay_blog_card_pricing_builder_component_namespaceObject,
    roomstay_blog_clipped_section_builder_component_namespaceObject,
    roomstay_blog_customer_case_accordion_2_builder_component_namespaceObject,
    roomstay_blog_customer_case_accordion_builder_component_namespaceObject,
    roomstay_blog_customer_case_block_builder_component_namespaceObject,
    roomstay_blog_customer_case_hero_builder_component_namespaceObject,
    roomstay_blog_customer_case_image_builder_component_namespaceObject,
    roomstay_blog_customer_case_list_card_2_builder_component_namespaceObject,
    roomstay_blog_customer_case_list_card_builder_component_namespaceObject,
    roomstay_blog_fade_up_builder_component_namespaceObject,
    roomstay_blog_featured_articles_builder_component,
    roomstay_blog_featured_card_builder_component_namespaceObject,
    roomstay_blog_footer_layout_2_builder_component_namespaceObject,
    roomstay_blog_footer_layout_form_builder_component_namespaceObject,
    roomstay_blog_hero_pricing_builder_component_namespaceObject,
    roomstay_blog_hero_product_builder_component_namespaceObject,
    roomstay_blog_highlight_article_builder_component,
    roomstay_blog_home_headline_builder_component_namespaceObject,
    roomstay_blog_home_hero_builder_component_namespaceObject,
    roomstay_blog_home_image_block_builder_component_namespaceObject,
    roomstay_blog_home_introduction_builder_component_namespaceObject,
    roomstay_blog_home_youtube_builder_component_namespaceObject,
    roomstay_blog_image_block_builder_component_namespaceObject,
    roomstay_blog_image_block_roomstay_blog_image_block_builder_component_namespaceObject,
    roomstay_blog_image_grid_builder_component_namespaceObject,
    roomstay_blog_use_case_img_clipped_builder_component_namespaceObject,
    roomstay_blog_increase_builder_component_namespaceObject,
    roomstay_blog_integrations_builder_component_namespaceObject,
    roomstay_blog_intro_revpar_builder_component_namespaceObject,
    roomstay_blog_list_card_builder_component_namespaceObject,
    roomstay_blog_our_promise_builder_component_namespaceObject,
    roomstay_blog_product_hero_builder_component_namespaceObject,
    roomstay_blog_product_theme_builder_component_namespaceObject,
    roomstay_blog_product_card_builder_component_namespaceObject,
    roomstay_blog_quote_builder_component_namespaceObject,
    roomtay_blog_revpar_builder_component_namespaceObject,
    roomstay_blog_sem_helpdesk_form_builder_component_namespaceObject,
    roomstay_blog_sem_hero_builder_component_namespaceObject,
    roomstay_blog_sem_list_solution_builder_component_namespaceObject,
    roomstay_blog_sem_list_builder_component_namespaceObject,
    roomstay_blog_sem_theme_builder_component_namespaceObject,
    roomstay_blog_summing_up_builder_component_namespaceObject,
    roomstay_blog_text_booking_builder_component_namespaceObject,
    roomstay_blog_text_caption_builder_component_namespaceObject,
    roomstay_blog_text_footer_builder_component_namespaceObject,
    roomstay_blog_text_intro_user_builder_component_namespaceObject,
    roomstay_blog_text_synxis_booking_builder_component_namespaceObject,
    roomstay_blog_text_wrap_builder_component_namespaceObject,
    roomstay_blog_use_case_hero_builder_component_namespaceObject,
    roomstay_integration_module_builder_component_namespaceObject,
    roomstay_members_builder_component_namespaceObject,
    roomstay_stats_builder_component_namespaceObject,
    roomstay_blog_helpdesk_form_builder_component_namespaceObject
];
index_esm/* builder.init */.fl.init(env/* BUILDER_API_KEY */.uT);
var registerComponents = function() {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = builderComponentConfigs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var exports = _step.value;
            if (Object.hasOwnProperty.call(exports, "default")) {
                var _default = exports.default, component = _default.component, config = _default.config;
                if (component && config) {
                    index_esm/* Builder.registerComponent */.Ib.registerComponent(component, config);
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
};


/***/ }),

/***/ 6892:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FadeUpOnVisible; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(315);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2991);
/* harmony import */ var react_intersection_observer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7650);





function FadeUpOnVisible(props) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), visible = ref[0], setVisible = ref[1];
    var ref1 = (0,react_intersection_observer__WEBPACK_IMPORTED_MODULE_3__/* .useInView */ .YD)({
        threshold: 0.1
    }), ref2 = ref1.ref, inView = ref1.inView;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (inView && !visible) {
            setVisible(true);
        }
    }, [
        inView
    ]);
    var classes = classnames__WEBPACK_IMPORTED_MODULE_1___default()("a-fade-in-up", (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        "--active": visible
    }, props.delay, !!props.delay));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        ref: ref2,
        className: classes,
        children: props.children
    });
};


/***/ }),

/***/ 4402:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ article_card; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(4924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(315);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(6779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(6899);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/lazy-load-image/lazy-load-image.tsx
var lazy_load_image = __webpack_require__(1087);
// EXTERNAL MODULE: ./components/roomstay-blog-article-author/roomstay-blog-article-author.module.scss
var roomstay_blog_article_author_module = __webpack_require__(6984);
var roomstay_blog_article_author_module_default = /*#__PURE__*/__webpack_require__.n(roomstay_blog_article_author_module);
;// CONCATENATED MODULE: ./components/roomstay-blog-article-author/roomstay-blog-article-author.tsx





var RoomstayBlogArticleAuthor = function(param) {
    var _dark = param.dark, dark = _dark === void 0 ? false : _dark, articleAuthor = param.articleAuthor, prefix = param.prefix;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((roomstay_blog_article_author_module_default()).root, (0,_define_property/* default */.Z)({}, (roomstay_blog_article_author_module_default()).dark, dark)),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (roomstay_blog_article_author_module_default()).avatar,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (roomstay_blog_article_author_module_default()).zoomedImageContainer,
                    children: articleAuthor.leadImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(lazy_load_image/* default */.Z, {
                        className: (roomstay_blog_article_author_module_default()).zoomedImage,
                        imageUrl: articleAuthor.leadImage,
                        objectFit: "cover",
                        relativeContainer: false
                    }) : null
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (roomstay_blog_article_author_module_default()).info,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (roomstay_blog_article_author_module_default()).name,
                        children: [
                            prefix,
                            articleAuthor.name
                        ].filter(Boolean).join(" ")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (roomstay_blog_article_author_module_default()).jobTitle,
                        children: articleAuthor.jobTitle
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var roomstay_blog_article_author = (RoomstayBlogArticleAuthor);

// EXTERNAL MODULE: ./helpers/DateHelper.ts
var DateHelper = __webpack_require__(6447);
// EXTERNAL MODULE: ./components/lazy-load-image/index.tsx + 2 modules
var components_lazy_load_image = __webpack_require__(1618);
// EXTERNAL MODULE: ./components/article-card/article-card.module.scss
var article_card_module = __webpack_require__(8178);
var article_card_module_default = /*#__PURE__*/__webpack_require__.n(article_card_module);
;// CONCATENATED MODULE: ./components/article-card/article-card.tsx








var ArticleCard = function(param) {
    var _dark = param.dark, dark = _dark === void 0 ? false : _dark, _large = param.large, large = _large === void 0 ? false : _large, _imageFullBleed = param.imageFullBleed, imageFullBleed = _imageFullBleed === void 0 ? false : _imageFullBleed, article = param.article;
    var ref, ref1;
    var image = article.leadImage || article.leadPortraitImage;
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: article.url || "",
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            className: classnames_default()((article_card_module_default()).root, (_obj = {}, (0,_define_property/* default */.Z)(_obj, (article_card_module_default()).dark, dark), (0,_define_property/* default */.Z)(_obj, (article_card_module_default()).large, large), (0,_define_property/* default */.Z)(_obj, (article_card_module_default()).imageFullBleed, imageFullBleed), _obj)),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (article_card_module_default()).zoomedImageContainer,
                    children: image ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_lazy_load_image/* LazyLoadImage */.e6, {
                        className: (article_card_module_default()).zoomedImage,
                        imageUrl: image,
                        objectFit: "cover",
                        relativeContainer: false
                    }) : null
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (article_card_module_default()).main,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (article_card_module_default()).content,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (article_card_module_default()).information,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (article_card_module_default()).category,
                                            children: (ref = article.categories) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.name
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (article_card_module_default()).dotDivider,
                                            children: "\u2022"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (article_card_module_default()).date,
                                            children: (0,DateHelper/* formatDate */.p)(article.builderModel.createdDate)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    title: article.title,
                                    className: (article_card_module_default()).title,
                                    children: article.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    title: article.description,
                                    className: (article_card_module_default()).description,
                                    children: article.description
                                })
                            ]
                        }),
                        article.author && /*#__PURE__*/ (0,jsx_runtime.jsx)(roomstay_blog_article_author, {
                            prefix: "By",
                            articleAuthor: article.author,
                            dark: dark
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var article_card = (ArticleCard);


/***/ }),

/***/ 1618:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "e6": function() { return /* reexport */ lazy_load_image/* default */.Z; },
  "Q$": function() { return /* reexport */ lazy_load_image_natural_size; },
  "Pq": function() { return /* reexport */ RawLazyLoadImage; }
});

// EXTERNAL MODULE: ./components/lazy-load-image/lazy-load-image.tsx
var lazy_load_image = __webpack_require__(1087);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(315);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(2991);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/react-intersection-observer.modern.mjs
var react_intersection_observer_modern = __webpack_require__(7650);
// EXTERNAL MODULE: ./helpers/BuilderImageHelper.ts
var BuilderImageHelper = __webpack_require__(1390);
;// CONCATENATED MODULE: ./components/lazy-load-image/raw-lazy-load-image.tsx







var RawLazyLoadImage = function(props) {
    var _className = props.className, className = _className === void 0 ? "" : _className, imageUrl = props.imageUrl, imageWidth = props.imageWidth, priority = props.priority, _threshold = props.threshold, threshold = _threshold === void 0 ? 0 : _threshold, onLoaded = props.onLoaded, rest = (0,_object_without_properties/* default */.Z)(props, [
        "className",
        "imageUrl",
        "imageWidth",
        "priority",
        "threshold",
        "onLoaded"
    ]);
    var ref = (0,react_intersection_observer_modern/* useInView */.YD)({
        threshold: threshold
    }), ref1 = ref.ref, inView = ref.inView;
    var ref2 = (0,react.useState)(false), wasSeen = ref2[0], setWasSeen = ref2[1];
    var ref3 = (0,react.useState)((0,BuilderImageHelper/* getPlaceholderBuilderImage */.W)(imageUrl)), currentImage = ref3[0], setCurrentImage = ref3[1];
    (0,react.useEffect)(function() {
        if ((priority || inView) && !wasSeen) {
            setWasSeen(true);
            onLoaded === null || onLoaded === void 0 ? void 0 : onLoaded();
        }
    }, [
        inView,
        priority
    ]);
    (0,react.useEffect)(function() {
        var cancelled = false;
        var resizeParams = {};
        if (imageWidth && imageWidth > 1) {
            resizeParams.width = imageWidth;
        }
        if (wasSeen) {
            var resizedImage = (0,BuilderImageHelper/* getResizedBuilderImage */.b)(imageUrl, resizeParams);
            var loadingImage = new Image();
            loadingImage.onload = function() {
                if (!cancelled) {
                    setCurrentImage(resizedImage);
                }
            };
            loadingImage.src = resizedImage !== null && resizedImage !== void 0 ? resizedImage : "";
        }
        return function() {
            cancelled = true;
        };
    }, [
        wasSeen,
        imageUrl,
        imageWidth
    ]);
    // eslint-disable-next-line @next/next/no-img-element
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        ref: ref1,
        alt: "",
        width: "100%",
        height: "auto",
        className: className
    }, rest), {
        src: currentImage
    }));
};


;// CONCATENATED MODULE: ./components/lazy-load-image/lazy-load-image-natural-size.tsx





var LazyLoadImageNaturalSize = function(props) {
    var ref = (0,react.useState)("1 / 1"), ratio = ref[0], setRatio = ref[1];
    var ref1 = (0,react.useState)("100%"), naturalWidth = ref1[0], setNaturalWidth = ref1[1];
    var ref2 = (0,react.useState)("100%"), naturalHeight = ref2[0], setNaturalHeight = ref2[1];
    var _onLoadingComplete = function(param) {
        var target = param.target;
        var naturalWidth = target.naturalWidth, naturalHeight = target.naturalHeight;
        setNaturalWidth(naturalWidth);
        setNaturalHeight(naturalHeight);
        setRatio("".concat(naturalWidth / naturalHeight));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(lazy_load_image/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        onLoad: _onLoadingComplete,
        width: naturalWidth,
        height: naturalHeight,
        layout: "intrinsic",
        objectFit: "cover"
    }));
};
/* harmony default export */ var lazy_load_image_natural_size = (LazyLoadImageNaturalSize);

;// CONCATENATED MODULE: ./components/lazy-load-image/index.tsx






/***/ }),

/***/ 1087:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(315);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8771);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2991);
/* harmony import */ var _helpers_BuilderImageHelper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1390);
/* harmony import */ var _lazy_load_image_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(532);
/* harmony import */ var _lazy_load_image_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_lazy_load_image_module_scss__WEBPACK_IMPORTED_MODULE_6__);










var LazyLoadImage = function(props) {
    var _className = props.className, className = _className === void 0 ? "" : _className, imageUrl = props.imageUrl, ratio = props.ratio, priority = props.priority, _loadingPlaceholder = props.loadingPlaceholder, loadingPlaceholder = _loadingPlaceholder === void 0 ? true : _loadingPlaceholder, _relativeContainer = props.relativeContainer, relativeContainer = _relativeContainer === void 0 ? true : _relativeContainer, blurDataColor = props.blurDataColor, style = props.style, containerStyle = props.containerStyle, onLoadingComplete = props.onLoadingComplete, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(props, [
        "className",
        "imageUrl",
        "ratio",
        "priority",
        "loadingPlaceholder",
        "relativeContainer",
        "blurDataColor",
        "style",
        "containerStyle",
        "onLoadingComplete"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(true), loading = ref[0], setLoading = ref[1];
    var loadingType = priority ? "eager" : "lazy";
    var blurDataURL = loadingPlaceholder ? (0,_helpers_BuilderImageHelper__WEBPACK_IMPORTED_MODULE_5__/* .getPlaceholderBuilderImage */ .W)(imageUrl) : undefined;
    if (blurDataColor && loadingPlaceholder) {
        switch(blurDataColor){
            case "White":
                // 1×1 white
                blurDataURL = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMCAO+ip1sAAAAASUVORK5CYII=";
                break;
            case "Black":
                // 1×1 black
                blurDataURL = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNk+A8AAQUBAScY42YAAAAASUVORK5CYII=";
                break;
            case "Cyan":
                // 1×1 cyan
                blurDataURL = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mM88/1nPQAIkAM92XC5AAAAAABJRU5ErkJggg==";
                break;
            default:
                // 1×1 transparent
                blurDataURL = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=";
                break;
        }
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_lazy_load_image_module_scss__WEBPACK_IMPORTED_MODULE_6___default().container), className, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, (_lazy_load_image_module_scss__WEBPACK_IMPORTED_MODULE_6___default().loading), loading), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, (_lazy_load_image_module_scss__WEBPACK_IMPORTED_MODULE_6___default().relative), relativeContainer)),
        style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
            aspectRatio: ratio
        }, containerStyle || {}),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
            objectFit: "contain",
            layout: "fill",
            quality: 80,
            alt: "",
            loading: loadingType,
            priority: priority,
            blurDataURL: blurDataURL,
            placeholder: loadingPlaceholder ? "blur" : "empty"
        }, rest), {
            loader: function(param) {
                var src = param.src, width = param.width, quality = param.quality;
                return (0,_helpers_BuilderImageHelper__WEBPACK_IMPORTED_MODULE_5__/* .getResizedBuilderImage */ .b)(src, {
                    width: width,
                    quality: quality
                }) || src;
            },
            src: imageUrl,
            style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                transition: "0.3s"
            }, style),
            onLoadingComplete: function(data) {
                setLoading(false);
                onLoadingComplete === null || onLoadingComplete === void 0 ? void 0 : onLoadingComplete(data);
            }
        }))
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_3__.memo)(LazyLoadImage));


/***/ }),

/***/ 8744:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(315);
/* harmony import */ var _loading_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7716);
/* harmony import */ var _loading_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_loading_module_scss__WEBPACK_IMPORTED_MODULE_1__);


var Loading = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_loading_module_scss__WEBPACK_IMPORTED_MODULE_1___default().container),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_loading_module_scss__WEBPACK_IMPORTED_MODULE_1___default().loaderText)
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Loading);


/***/ }),

/***/ 1176:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RoomstayBlogAllArticlesConfig": function() { return /* binding */ RoomstayBlogAllArticlesConfig; }
/* harmony export */ });
/* harmony import */ var _components_roomstay_blog_all_articles_roomstay_blog_all_articles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5848);

var RoomstayBlogAllArticlesConfig = {
    name: "All Articles",
    inputs: [
        {
            name: "title",
            type: "string"
        },
        {
            name: "offset",
            type: "number"
        }, 
    ]
};
var builderConfig = {
    component: _components_roomstay_blog_all_articles_roomstay_blog_all_articles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP,
    config: RoomstayBlogAllArticlesConfig
};
/* harmony default export */ __webpack_exports__["default"] = (builderConfig);


/***/ }),

/***/ 5848:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Yb": function() { return /* binding */ DEFAULT_OFFSET; },
  "ng": function() { return /* binding */ ROWS; },
  "hv": function() { return /* binding */ TEMPLATE; },
  "ZP": function() { return /* binding */ roomstay_blog_all_articles; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(9113);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(315);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(2991);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./components/article-card/article-card.tsx + 1 modules
var article_card = __webpack_require__(4402);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(6779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/skeleton/text-skeleton/text-skeleton.tsx
var text_skeleton = __webpack_require__(9438);
// EXTERNAL MODULE: ./components/skeleton/article-card-skeleton/article-card-skeleton.module.scss
var article_card_skeleton_module = __webpack_require__(3408);
var article_card_skeleton_module_default = /*#__PURE__*/__webpack_require__.n(article_card_skeleton_module);
// EXTERNAL MODULE: ./node_modules/usehooks-ts/dist/esm/index.js + 36 modules
var esm = __webpack_require__(4660);
;// CONCATENATED MODULE: ./components/skeleton/article-card-skeleton/article-card-skeleton.tsx





var ArticleCardSkeleton = function() {
    var width = (0,esm/* useWindowSize */.iP)().width;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(text_skeleton/* default */.Z, {
        className: (article_card_skeleton_module_default()).skeleton,
        size: [
            "100%",
            width < 768 ? 250 : 500
        ]
    }, Math.random());
};
/* harmony default export */ var article_card_skeleton = (ArticleCardSkeleton);

// EXTERNAL MODULE: ./hooks/useWindowSize.ts
var useWindowSize = __webpack_require__(5173);
// EXTERNAL MODULE: ./components/skeleton/article-grid-skeleton/article-grid-skeleton.module.scss
var article_grid_skeleton_module = __webpack_require__(4998);
var article_grid_skeleton_module_default = /*#__PURE__*/__webpack_require__.n(article_grid_skeleton_module);
;// CONCATENATED MODULE: ./components/skeleton/article-grid-skeleton/article-grid-skeleton.tsx








var ArticleGridSkeleton = function(param) {
    var templates = param.templates, length = param.length;
    var windowSize = (0,useWindowSize/* useWindowSize */.i)();
    var handleCards = function() {
        var maxTotalRows = length;
        var cards = [];
        var articleIndex = 0;
        var cardTemplate = (windowSize.width || 0) > 1200 ? templates ? templates : defaultTemplates : tabletTemplate;
        for(var rowNumber = 0; rowNumber < maxTotalRows; rowNumber += 1){
            var templateIndex = rowNumber % cardTemplate.length;
            var templateRow = cardTemplate[templateIndex];
            if (articleIndex >= maxTotalRows) {
                break;
            }
            for(var colNumber = 0; colNumber < templateRow.length; colNumber++){
                var cardType = templateRow[colNumber];
                if (articleIndex >= maxTotalRows) {
                    break;
                }
                // const article = filteredArticles[articleIndex];
                if (!cardType.large) {
                    cards.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(article_card_skeleton, {}, Math.random()));
                }
                if (cardType.large) {
                    cards.push(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (article_grid_skeleton_module_default()).articleLarge,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(article_card_skeleton, {})
                    }, Math.random()));
                }
                articleIndex += 1;
            }
        }
        return cards;
    };
    var renderArticleContent = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (article_grid_skeleton_module_default()).articlesContainer,
            children: handleCards().map(function(card) {
                return card;
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (article_grid_skeleton_module_default()).articleGrid,
        children: [
            renderArticleContent(),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (article_grid_skeleton_module_default()).loadMoreContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (article_grid_skeleton_module_default()).skeletonButtonContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(text_skeleton/* default */.Z, {
                        className: classnames_default()((article_grid_skeleton_module_default()).skeleton, (article_grid_skeleton_module_default()).skeletonButton),
                        size: [
                            166,
                            40
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var article_grid_skeleton = (ArticleGridSkeleton);

;// CONCATENATED MODULE: ./shared/sharedContext.tsx

var CategoryCtx = /*#__PURE__*/ (0,react.createContext)({});
var LocationCtx = /*#__PURE__*/ (0,react.createContext)({});

// EXTERNAL MODULE: ./components/article-grid/article-grid.module.scss
var article_grid_module = __webpack_require__(4908);
var article_grid_module_default = /*#__PURE__*/__webpack_require__.n(article_grid_module);
// EXTERNAL MODULE: ./components/button/index.tsx
var components_button = __webpack_require__(6811);
// EXTERNAL MODULE: ./components/spinner/spinner.tsx
var spinner = __webpack_require__(9295);
;// CONCATENATED MODULE: ./components/article-grid/article-grid.tsx











var defaultTemplates = [
    [
        {
            large: false
        },
        {
            large: true
        }
    ],
    [
        {
            large: false
        },
        {
            large: false
        },
        {
            large: false
        }
    ],
    [
        {
            large: true,
            dark: true,
            imageFullBleed: true
        },
        {
            large: false
        }
    ],
    [
        {
            large: false
        },
        {
            large: false
        },
        {
            large: false
        }
    ], 
];
var tabletTemplate = [
    [
        {
            large: false
        },
        {
            large: false
        }
    ], 
];
var ArticleGrid = function(props) {
    var articles = props.articles, setOffsetArticle = props.setOffsetArticle, offsetArticle = props.offsetArticle, isLoadingMoreArticles = props.isLoadingMoreArticles, templates = props.templates, _itemsPerPage = props.itemsPerPage, itemsPerPage = _itemsPerPage === void 0 ? 6 : _itemsPerPage, initialOffsetArticle = props.initialOffsetArticle, onLoadMoreClick = props.onLoadMoreClick;
    var windowSize = (0,useWindowSize/* useWindowSize */.i)();
    var categoryCtx = (0,react.useContext)(CategoryCtx);
    (0,react.useEffect)(function() {
        if (!categoryCtx) return;
        return function() {
            if (categoryCtx === null || categoryCtx === void 0 ? void 0 : categoryCtx.setCategoriesToFilter) {
                categoryCtx.setCategoriesToFilter([]);
            }
        };
    }, []);
    var cardTemplate = (windowSize.width || 0) > 1200 ? templates ? templates : defaultTemplates : tabletTemplate;
    var handleCards = function() {
        var maxTotalRows = articles.length;
        var cards = [];
        var articleIndex = 0;
        for(var rowNumber = 0; rowNumber < maxTotalRows; rowNumber += 1){
            var templateIndex = rowNumber % cardTemplate.length;
            var templateRow = cardTemplate[templateIndex];
            if (articleIndex >= maxTotalRows) {
                break;
            }
            for(var colNumber = 0; colNumber < templateRow.length; colNumber++){
                var cardType = templateRow[colNumber];
                if (articleIndex >= maxTotalRows) {
                    break;
                }
                var article = articles[articleIndex];
                if (!cardType.large) {
                    cards.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(article_card/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cardType), {
                        large: false,
                        article: article
                    }), Math.random()));
                }
                if (cardType.large) {
                    cards.push(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (article_grid_module_default()).articleLarge,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(article_card/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cardType), {
                            large: true,
                            article: article
                        }))
                    }, Math.random()));
                }
                articleIndex += 1;
            }
        }
        return cards;
    };
    var handleLoadMoreArticle = function() {
        var nextOffset = offsetArticle + itemsPerPage;
        setOffsetArticle(nextOffset);
        onLoadMoreClick === null || onLoadMoreClick === void 0 ? void 0 : onLoadMoreClick(offsetArticle, nextOffset);
    };
    var renderButtonLoadMore = function() {
        if (offsetArticle - initialOffsetArticle > articles.length) {
            return null;
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
            onClick: function() {
                return handleLoadMoreArticle();
            },
            loading: isLoadingMoreArticles,
            children: "MORE POSTS"
        });
    };
    var renderArticleContent = function() {
        if (articles.length === 0 && !isLoadingMoreArticles) {
            return null;
        }
        if (articles.length === 0) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(article_grid_skeleton, {
                length: 7,
                templates: cardTemplate
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (article_grid_module_default()).articlesContainer,
            children: handleCards().map(function(card) {
                return card;
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (article_grid_module_default()).articleGrid,
        children: [
            renderArticleContent(),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (article_grid_module_default()).loadMoreContainer,
                children: [
                    renderButtonLoadMore(),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (article_grid_module_default()).spinnerLoadMoreContainer,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(spinner/* default */.Z, {
                            size: 32,
                            strokeWidth: 3,
                            hide: !isLoadingMoreArticles
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var article_grid = (/*#__PURE__*/(0,react.memo)(ArticleGrid));

// EXTERNAL MODULE: ./components/roomstay-blog-all-articles/roomstay-blog-all-articles.builder-component.ts
var roomstay_blog_all_articles_builder_component = __webpack_require__(1176);
// EXTERNAL MODULE: ./utils/Article.ts
var Article = __webpack_require__(5359);
// EXTERNAL MODULE: ./components/roomstay-blog-all-articles/roomstay-blog-all-articles.module.scss
var roomstay_blog_all_articles_module = __webpack_require__(3715);
var roomstay_blog_all_articles_module_default = /*#__PURE__*/__webpack_require__.n(roomstay_blog_all_articles_module);
;// CONCATENATED MODULE: ./components/roomstay-blog-all-articles/roomstay-blog-all-articles.tsx








var ROWS = 3;
var DEFAULT_OFFSET = 7;
var TEMPLATE = defaultTemplates;
var getDefaultValue = function(defaultValue, value) {
    return value === undefined ? defaultValue : value;
};
var DijiBlogAllArticles = function(param) {
    var title = param.title, tmp = param.offset, offsetProp = tmp === void 0 ? DEFAULT_OFFSET : tmp, builderState = param.builderState;
    var state = builderState === null || builderState === void 0 ? void 0 : builderState.state[roomstay_blog_all_articles_builder_component.RoomstayBlogAllArticlesConfig.name];
    var ref = (0,react.useState)(getDefaultValue([], state === null || state === void 0 ? void 0 : state.fixedArticles)), articles = ref[0], setArticles = ref[1];
    var ref1 = (0,react.useState)(getDefaultValue(offsetProp, state === null || state === void 0 ? void 0 : state.defaultOffset)), offset = ref1[0], setOffsetArticle = ref1[1];
    var ref2 = (0,react.useState)(getDefaultValue(true, state === null || state === void 0 ? void 0 : state.isLoading)), isLoadingMoreArticles = ref2[0], setIsLoadingMoreArticles = ref2[1];
    var currentRow = (0,react.useRef)(getDefaultValue(0, state === null || state === void 0 ? void 0 : state.currentRow));
    var loadMoreArticles = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(currentOffset) {
            var newArticles;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return setIsLoadingMoreArticles(true);
                    case 2:
                        _ctx.next = 4;
                        return (0,Article/* getMoreArticles */._p)(currentOffset, (0,Article/* getItemsPerPage */.ZU)(ROWS, currentRow.current, TEMPLATE));
                    case 4:
                        newArticles = _ctx.sent;
                        setArticles((articles || []).concat(newArticles));
                        _ctx.next = 8;
                        return setIsLoadingMoreArticles(false);
                    case 8:
                        currentRow.current += ROWS;
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function loadMoreArticles(currentOffset) {
            return _ref.apply(this, arguments);
        };
    }();
    if (articles && articles.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (roomstay_blog_all_articles_module_default()).root,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (roomstay_blog_all_articles_module_default()).title,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(article_grid, {
                articles: articles || [],
                isLoadingMoreArticles: isLoadingMoreArticles,
                setOffsetArticle: setOffsetArticle,
                offsetArticle: offset,
                itemsPerPage: (0,Article/* getItemsPerPage */.ZU)(ROWS, currentRow.current, TEMPLATE),
                initialOffsetArticle: offsetProp,
                templates: TEMPLATE,
                onLoadMoreClick: loadMoreArticles
            })
        ]
    });
};
/* harmony default export */ var roomstay_blog_all_articles = (DijiBlogAllArticles);


/***/ }),

/***/ 7520:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "RoomstayBlogHomeHeroBuilderConfig": function() { return /* binding */ RoomstayBlogHomeHeroBuilderConfig; },
  "default": function() { return /* binding */ roomstay_blog_blog_hero_builder_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(315);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(6899);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/lazy-load-image/index.tsx + 2 modules
var lazy_load_image = __webpack_require__(1618);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(2991);
// EXTERNAL MODULE: ./hooks/useWindowSize.ts
var useWindowSize = __webpack_require__(5173);
// EXTERNAL MODULE: ./components/skeleton/text-skeleton/text-skeleton.tsx
var text_skeleton = __webpack_require__(9438);
// EXTERNAL MODULE: ./components/skeleton/home-hero-skeleton/home-hero-skeleton.module.scss
var home_hero_skeleton_module = __webpack_require__(935);
var home_hero_skeleton_module_default = /*#__PURE__*/__webpack_require__.n(home_hero_skeleton_module);
;// CONCATENATED MODULE: ./components/skeleton/home-hero-skeleton/home-hero-skeleton.tsx





var HomeHeroSkeleton = function() {
    var ref = (0,useWindowSize/* useWindowSize */.i)(), _width = ref.width, width = _width === void 0 ? 0 : _width;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (home_hero_skeleton_module_default()).heroContainer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (home_hero_skeleton_module_default()).pageContainer,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (home_hero_skeleton_module_default()).block,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(text_skeleton/* default */.Z, {
                            size: [
                                "80%",
                                width > 992 ? 120 : 64
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(text_skeleton/* default */.Z, {
                            size: [
                                "100%",
                                width > 992 ? 120 : 64
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (home_hero_skeleton_module_default()).arrow,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (home_hero_skeleton_module_default()).lineSkeleton
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (home_hero_skeleton_module_default()).divider,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (home_hero_skeleton_module_default()).lineSkeleton
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (home_hero_skeleton_module_default()).slider,
                    children: [
                        1,
                        2,
                        3
                    ].map(function(i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (home_hero_skeleton_module_default()).item,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (home_hero_skeleton_module_default()).info,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(text_skeleton/* default */.Z, {
                                            size: [
                                                79,
                                                16
                                            ]
                                        }),
                                        "\xa0\xa0\xa0",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (home_hero_skeleton_module_default()).dot,
                                            children: "\u2022"
                                        }),
                                        "\xa0\xa0\xa0",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(text_skeleton/* default */.Z, {
                                            size: [
                                                100,
                                                16
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(text_skeleton/* default */.Z, {
                                            size: [
                                                "100%",
                                                32
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(text_skeleton/* default */.Z, {
                                            size: [
                                                "75%",
                                                32
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, i);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var home_hero_skeleton = (HomeHeroSkeleton);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(2426);
// EXTERNAL MODULE: ./helpers/DateHelper.ts
var DateHelper = __webpack_require__(6447);
// EXTERNAL MODULE: ./components/roomstay-blog-blog-hero/blog-home-hero-article-carousel/article-carousel-item/article-carousel-item.module.scss
var article_carousel_item_module = __webpack_require__(5027);
var article_carousel_item_module_default = /*#__PURE__*/__webpack_require__.n(article_carousel_item_module);
;// CONCATENATED MODULE: ./components/roomstay-blog-blog-hero/blog-home-hero-article-carousel/article-carousel-item/article-carousel-item.tsx




var ArticleCarouselItem = function(props) {
    var ref;
    var article = props.article;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: article.url || "",
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            className: (article_carousel_item_module_default()).container,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (article_carousel_item_module_default()).info,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (article_carousel_item_module_default()).category,
                            children: (ref = article.categories[0]) === null || ref === void 0 ? void 0 : ref.name
                        }),
                        "\xa0\xa0\xa0",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (article_carousel_item_module_default()).dot,
                            children: "\u2022"
                        }),
                        "\xa0\xa0\xa0",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (article_carousel_item_module_default()).date,
                            children: article.lastUpdated ? (0,DateHelper/* formatDate */.p)(article.lastUpdated) : ""
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    title: article.title,
                    className: (article_carousel_item_module_default()).title,
                    children: article.title
                })
            ]
        })
    });
};
/* harmony default export */ var article_carousel_item = (ArticleCarouselItem);

// EXTERNAL MODULE: ./components/roomstay-blog-blog-hero/blog-home-hero-article-carousel/blog-home-hero-article-carousel.module.scss
var blog_home_hero_article_carousel_module = __webpack_require__(1841);
var blog_home_hero_article_carousel_module_default = /*#__PURE__*/__webpack_require__.n(blog_home_hero_article_carousel_module);
;// CONCATENATED MODULE: ./components/roomstay-blog-blog-hero/blog-home-hero-article-carousel/blog-home-hero-article-carousel.tsx






var options = {
    slidesPerView: "auto",
    spaceBetween: 24,
    allowTouchMove: true,
    noSwiping: false,
    freeMode: true,
    breakpoints: {
        992: {
            watchOverflow: true
        }
    }
};
var BlogHomeHeroArticleCarousel = function(props) {
    var articles = props.articles;
    if (!(articles === null || articles === void 0 ? void 0 : articles.length)) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (blog_home_hero_article_carousel_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (blog_home_hero_article_carousel_module_default()).box,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, options), {
                children: articles.map(function(article) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (blog_home_hero_article_carousel_module_default()).item,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(article_carousel_item, {
                                article: article
                            }, Math.random())
                        })
                    }, article.id);
                })
            }))
        })
    });
};
/* harmony default export */ var blog_home_hero_article_carousel = (BlogHomeHeroArticleCarousel);

// EXTERNAL MODULE: ./components/roomstay-blog-blog-hero/roomstay-blog-blog-hero.module.scss
var roomstay_blog_blog_hero_module = __webpack_require__(5619);
var roomstay_blog_blog_hero_module_default = /*#__PURE__*/__webpack_require__.n(roomstay_blog_blog_hero_module);
;// CONCATENATED MODULE: ./components/roomstay-blog-blog-hero/roomstay-blog-blog-hero.tsx







var BlogHomeHero = function(props) {
    var builderState = props.builderState;
    var config = builderState === null || builderState === void 0 ? void 0 : builderState.state[RoomstayBlogHomeHeroBuilderConfig.name];
    var leadArticle = config === null || config === void 0 ? void 0 : config.leadArticle;
    var articles = (config === null || config === void 0 ? void 0 : config.articles) || [];
    if (!leadArticle) return /*#__PURE__*/ (0,jsx_runtime.jsx)(home_hero_skeleton, {});
    var leadImage = (leadArticle === null || leadArticle === void 0 ? void 0 : leadArticle.leadPortraitImage) || (leadArticle === null || leadArticle === void 0 ? void 0 : leadArticle.leadImage);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (roomstay_blog_blog_hero_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (roomstay_blog_blog_hero_module_default()).background,
                children: leadImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(lazy_load_image/* LazyLoadImage */.e6, {
                    imageUrl: leadImage,
                    objectFit: "cover",
                    loadingPlaceholder: false
                }) : null
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (roomstay_blog_blog_hero_module_default()).content,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (roomstay_blog_blog_hero_module_default()).titleBox,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: leadArticle === null || leadArticle === void 0 ? void 0 : leadArticle.url,
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    title: leadArticle === null || leadArticle === void 0 ? void 0 : leadArticle.title,
                                    className: (roomstay_blog_blog_hero_module_default()).title,
                                    children: leadArticle === null || leadArticle === void 0 ? void 0 : leadArticle.title
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (roomstay_blog_blog_hero_module_default()).arrow
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (roomstay_blog_blog_hero_module_default()).divider
                            })
                        ]
                    }),
                    articles.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(blog_home_hero_article_carousel, {
                        articles: articles
                    }) : null
                ]
            })
        ]
    });
};
/* harmony default export */ var roomstay_blog_blog_hero = (BlogHomeHero);

;// CONCATENATED MODULE: ./components/roomstay-blog-blog-hero/roomstay-blog-blog-hero.builder-component.ts

var RoomstayBlogHomeHeroBuilderConfig = {
    name: "Blog Home Hero",
    inputs: []
};
var builderConfig = {
    component: roomstay_blog_blog_hero,
    config: RoomstayBlogHomeHeroBuilderConfig
};
/* harmony default export */ var roomstay_blog_blog_hero_builder_component = (builderConfig);


/***/ }),

/***/ 7998:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RoomstayBlogFeaturedArticlesConfig": function() { return /* binding */ RoomstayBlogFeaturedArticlesConfig; }
/* harmony export */ });
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4666);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_0__);
// import type { Component } from '@builder.io/sdk';

var RoomstayBlogFeaturedArticles = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
    return __webpack_require__.e(/* import() */ 640).then(__webpack_require__.bind(__webpack_require__, 8640));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(8640)
            ];
        }
    }
});
var RoomstayBlogFeaturedArticlesConfig = {
    name: "Featured Articles",
    inputs: [
        {
            name: "backgroundColor",
            type: "color"
        },
        {
            name: "articles",
            type: "list",
            copyOnAdd: false,
            subFields: [
                {
                    name: "article",
                    type: "reference",
                    model: "article"
                }, 
            ]
        },
        {
            hideFromUI: true,
            name: "fixedArticles",
            type: "list"
        }, 
    ]
};
var builderConfig = {
    component: RoomstayBlogFeaturedArticles,
    config: RoomstayBlogFeaturedArticlesConfig
};
/* harmony default export */ __webpack_exports__["default"] = (builderConfig);


/***/ }),

/***/ 4490:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RoomstayBlogHighlightArticleConfig": function() { return /* binding */ RoomstayBlogHighlightArticleConfig; }
/* harmony export */ });
/* harmony import */ var _types_builder_d__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9209);
/* harmony import */ var _roomstay_blog_highlight_article__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(270);


var RoomstayBlogHighlightArticleConfig = {
    name: "Highlight Article",
    inputs: [
        {
            name: "article",
            type: "reference",
            model: _types_builder_d__WEBPACK_IMPORTED_MODULE_0__/* .BUILDER_MODEL.ARTICLE */ .A.ARTICLE
        },
        {
            name: "topColor",
            type: "color"
        },
        {
            name: "bottomColor",
            type: "color"
        }, 
    ]
};
var builderConfig = {
    component: _roomstay_blog_highlight_article__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z,
    config: RoomstayBlogHighlightArticleConfig
};
/* harmony default export */ __webpack_exports__["default"] = (builderConfig);


/***/ }),

/***/ 270:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(7568);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9113);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(315);
/* harmony import */ var _builder_io_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5102);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6899);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2991);
/* harmony import */ var usehooks_ts__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4660);
/* harmony import */ var _components_roomstay_blog_image_block_clipped_box__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(974);
/* harmony import */ var _helpers_DateHelper__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6447);
/* harmony import */ var _utils_Article__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5359);
/* harmony import */ var _lazy_load_image__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(1618);
/* harmony import */ var _roomstay_blog_highlight_article_builder_component__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(4490);
/* harmony import */ var _roomstay_blog_highlight_article_module_scss__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(5539);
/* harmony import */ var _roomstay_blog_highlight_article_module_scss__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_roomstay_blog_highlight_article_module_scss__WEBPACK_IMPORTED_MODULE_13__);














var DESKTOP_ANGLE_TAN = 85 / 1920;
var MOBILE_ANGLE_TAN = 35 / 375;
var RoomstayBlogHighlightArticle = function(props) {
    var ref, ref1, ref2;
    var builderArticle = props.article, fixedArticle = props.fixedArticle, _arrowText = props.arrowText, arrowText = _arrowText === void 0 ? "Recommended" : _arrowText, builderState = props.builderState, topColor = props.topColor;
    var width = (0,usehooks_ts__WEBPACK_IMPORTED_MODULE_6__/* .useWindowSize */ .iP)().width;
    var isMobile = width < 992;
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(fixedArticle || (builderState === null || builderState === void 0 ? void 0 : (ref = builderState.state) === null || ref === void 0 ? void 0 : (ref1 = ref[_roomstay_blog_highlight_article_builder_component__WEBPACK_IMPORTED_MODULE_11__.RoomstayBlogHighlightArticleConfig.name]) === null || ref1 === void 0 ? void 0 : ref1.fixedArticle) || null), article = ref3[0], setArticle = ref3[1];
    var getDataClientSide = (0,react__WEBPACK_IMPORTED_MODULE_5__.useCallback)((0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var article;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!(builderArticle && _builder_io_react__WEBPACK_IMPORTED_MODULE_2__/* .Builder.isEditing */ .Ib.isEditing)) {
                        _ctx.next = 7;
                        break;
                    }
                    _ctx.next = 3;
                    return (0,_utils_Article__WEBPACK_IMPORTED_MODULE_9__/* .getHighlightArticle */ .np)(builderArticle);
                case 3:
                    article = _ctx.sent;
                    setArticle(article);
                    _ctx.next = 8;
                    break;
                case 7:
                    {
                        setArticle(fixedArticle);
                    }
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        builderArticle,
        fixedArticle
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(function() {
        getDataClientSide();
    }, [
        getDataClientSide
    ]);
    if (!article) return null;
    var leadImage = article.leadPortraitImage || article.leadImage;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        className: (_roomstay_blog_highlight_article_module_scss__WEBPACK_IMPORTED_MODULE_13___default().container),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_roomstay_blog_image_block_clipped_box__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                configs: [
                    {
                        rad: Math.atan(isMobile ? MOBILE_ANGLE_TAN : DESKTOP_ANGLE_TAN),
                        position: _components_roomstay_blog_image_block_clipped_box__WEBPACK_IMPORTED_MODULE_7__/* .POSITION.BottomRight */ .V.BottomRight
                    }, 
                ],
                className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_roomstay_blog_highlight_article_module_scss__WEBPACK_IMPORTED_MODULE_13___default().background), (_roomstay_blog_highlight_article_module_scss__WEBPACK_IMPORTED_MODULE_13___default().topBackground)),
                style: {
                    backgroundColor: topColor
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_roomstay_blog_image_block_clipped_box__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                configs: [
                    {
                        rad: Math.atan(isMobile ? MOBILE_ANGLE_TAN : DESKTOP_ANGLE_TAN),
                        position: _components_roomstay_blog_image_block_clipped_box__WEBPACK_IMPORTED_MODULE_7__/* .POSITION.TopLeft */ .V.TopLeft
                    },
                    {
                        rad: Math.atan(isMobile ? MOBILE_ANGLE_TAN : DESKTOP_ANGLE_TAN),
                        position: _components_roomstay_blog_image_block_clipped_box__WEBPACK_IMPORTED_MODULE_7__/* .POSITION.BottomRight */ .V.BottomRight
                    }, 
                ],
                className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_roomstay_blog_highlight_article_module_scss__WEBPACK_IMPORTED_MODULE_13___default().background), (_roomstay_blog_highlight_article_module_scss__WEBPACK_IMPORTED_MODULE_13___default().mainBackground))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                href: article.url || "/",
                passHref: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("a", {
                    className: (_roomstay_blog_highlight_article_module_scss__WEBPACK_IMPORTED_MODULE_13___default().box),
                    "aria-label": article.url,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: (_roomstay_blog_highlight_article_module_scss__WEBPACK_IMPORTED_MODULE_13___default().left),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: (_roomstay_blog_highlight_article_module_scss__WEBPACK_IMPORTED_MODULE_13___default().imageContainer),
                                children: leadImage ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_lazy_load_image__WEBPACK_IMPORTED_MODULE_10__/* .LazyLoadImage */ .e6, {
                                    className: (_roomstay_blog_highlight_article_module_scss__WEBPACK_IMPORTED_MODULE_13___default().image),
                                    imageUrl: leadImage,
                                    objectFit: "cover"
                                }) : null
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            className: (_roomstay_blog_highlight_article_module_scss__WEBPACK_IMPORTED_MODULE_13___default().right),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                    className: (_roomstay_blog_highlight_article_module_scss__WEBPACK_IMPORTED_MODULE_13___default().textCaption),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                            children: arrowText
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                            className: (_roomstay_blog_highlight_article_module_scss__WEBPACK_IMPORTED_MODULE_13___default().arrow)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                    className: (_roomstay_blog_highlight_article_module_scss__WEBPACK_IMPORTED_MODULE_13___default().info),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                            className: (_roomstay_blog_highlight_article_module_scss__WEBPACK_IMPORTED_MODULE_13___default().category),
                                            children: (ref2 = article.categories[0]) === null || ref2 === void 0 ? void 0 : ref2.name
                                        }),
                                        "\xa0\xa0\xa0",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                            className: (_roomstay_blog_highlight_article_module_scss__WEBPACK_IMPORTED_MODULE_13___default().dot),
                                            children: "\u2022"
                                        }),
                                        "\xa0\xa0\xa0",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                            className: (_roomstay_blog_highlight_article_module_scss__WEBPACK_IMPORTED_MODULE_13___default().date),
                                            children: article.lastUpdated ? (0,_helpers_DateHelper__WEBPACK_IMPORTED_MODULE_8__/* .formatDate */ .p)(article.lastUpdated) : ""
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    title: article.title,
                                    className: (_roomstay_blog_highlight_article_module_scss__WEBPACK_IMPORTED_MODULE_13___default().title),
                                    children: article.title
                                }),
                                article.author ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                    className: (_roomstay_blog_highlight_article_module_scss__WEBPACK_IMPORTED_MODULE_13___default().author),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: (_roomstay_blog_highlight_article_module_scss__WEBPACK_IMPORTED_MODULE_13___default().avatarContainer),
                                            children: article.author.leadImage ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_lazy_load_image__WEBPACK_IMPORTED_MODULE_10__/* .LazyLoadImage */ .e6, {
                                                className: (_roomstay_blog_highlight_article_module_scss__WEBPACK_IMPORTED_MODULE_13___default().avatar),
                                                imageUrl: article.author.leadImage
                                            }) : null
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                    className: (_roomstay_blog_highlight_article_module_scss__WEBPACK_IMPORTED_MODULE_13___default().name),
                                                    children: article.author.name
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                    className: (_roomstay_blog_highlight_article_module_scss__WEBPACK_IMPORTED_MODULE_13___default().jobTitle),
                                                    children: article.author.jobTitle
                                                })
                                            ]
                                        })
                                    ]
                                }) : null
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (RoomstayBlogHighlightArticle);


/***/ }),

/***/ 974:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ POSITION; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9534);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(253);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(315);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2991);
/* harmony import */ var usehooks_ts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4660);






var POSITION;
(function(POSITION) {
    POSITION[POSITION["TopLeft"] = 0] = "TopLeft";
    POSITION[POSITION["TopRight"] = 1] = "TopRight";
    POSITION[POSITION["BottomRight"] = 2] = "BottomRight";
    POSITION[POSITION["BottomLeft"] = 3] = "BottomLeft";
})(POSITION || (POSITION = {}));
var ClippedBox = function(_param) {
    var customStyle = _param.style, configs = _param.configs, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "style",
        "configs"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({}), style = ref[0], setStyle = ref[1];
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,usehooks_ts__WEBPACK_IMPORTED_MODULE_2__/* .useElementSize */ .h4)(), 2), ref2 = ref1[0], ref3 = ref1[1], width = ref3.width, height = ref3.height;
    var ref4 = (0,usehooks_ts__WEBPACK_IMPORTED_MODULE_2__/* .useWindowSize */ .iP)(), windowWidth = ref4.width;
    var createPolygon = function() {
        var edges = [
            [
                "0%",
                "0%"
            ],
            [
                "0%",
                "100%"
            ],
            [
                "100%",
                "100%"
            ],
            [
                "100%",
                "0%"
            ], 
        ];
        configs.forEach(function(param) {
            var rad = param.rad, position = param.position;
            var index = edges.findIndex(function(v, index) {
                return index === position;
            });
            var offset = Math.tan(rad) * width;
            switch(position){
                case POSITION.TopLeft:
                    edges.splice(index, 1, [
                        "0%",
                        "".concat(offset, "px")
                    ]);
                    break;
                case POSITION.TopRight:
                    edges.splice(index, 1, [
                        "100%",
                        "".concat(offset, "px")
                    ]);
                    break;
                case POSITION.BottomLeft:
                    edges.splice(index, 1, [
                        "0%",
                        "".concat(Math.max(height - offset, 0), "px")
                    ]);
                    break;
                case POSITION.BottomRight:
                    edges.splice(index, 1, [
                        "100%",
                        "".concat(Math.max(height - offset, 0), "px")
                    ]);
                    break;
            }
        });
        return edges.map(function(arr) {
            return arr.join(" ");
        }).join(",");
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var polygon = createPolygon();
        setStyle({
            clipPath: "polygon(".concat(polygon, ")")
        });
    }, [
        width,
        height,
        windowWidth,
        customStyle
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        ref: ref2,
        style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            marginTop: -1
        }, customStyle || {}, style)
    }, props));
};
/* harmony default export */ __webpack_exports__["Z"] = (ClippedBox);


/***/ }),

/***/ 7465:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ share_icons; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(4924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(315);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(6779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(2991);
// EXTERNAL MODULE: ./node_modules/react-copy-to-clipboard/lib/index.js
var lib = __webpack_require__(5630);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./components/share-icons/share-icons.module.scss
var share_icons_module = __webpack_require__(9436);
var share_icons_module_default = /*#__PURE__*/__webpack_require__.n(share_icons_module);
;// CONCATENATED MODULE: ./components/share-icons/share-icons.utils.ts
var getUrlShare = function(type, urlShare) {
    switch(type){
        case "facebook":
            return "https://www.facebook.com/sharer.php?u=".concat(urlShare);
        case "linkedIn":
            return "https://www.linkedin.com/sharing/share-offsite/?url=".concat(urlShare);
        case "twitter":
            return "https://twitter.com/intent/tweet?url=".concat(urlShare);
        default:
            return urlShare;
    }
};
var getTooltipMessage = function(type) {
    switch(type){
        case "facebook":
            return "Share on Facebook";
        case "linkedIn":
            return "Share on LinkedIn";
        case "twitter":
            return "Share on Twitter";
        case "copy":
            return "Click to copy";
        default:
            return "";
    }
};
var handlePopupCenter = function(param) {
    var url = param.url, title = param.title, popupWidth = param.popupWidth, popupHeight = param.popupHeight;
    var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
    var dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;
    var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;
    var systemZoom = width / window.screen.availWidth;
    var left = (width - popupWidth) / 2 / systemZoom + dualScreenLeft;
    var top = (height - popupHeight) / 2 / systemZoom + dualScreenTop;
    var newWindow = window.open(url, title, "\n    scrollbars=yes,\n    width=".concat(popupWidth / systemZoom, ", \n    height=").concat(popupHeight / systemZoom, ", \n    top=").concat(top, ", \n    left=").concat(left, "\n    "));
    if (window === null || window === void 0 ? void 0 : window.focus) newWindow === null || newWindow === void 0 ? void 0 : newWindow.focus();
};

;// CONCATENATED MODULE: ./components/share-icons/social-and-share-icon/facebook-social.tsx


var FacebookSocial = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M23.9987 2.6665H19.9987C18.2306 2.6665 16.5349 3.36888 15.2847 4.61913C14.0344 5.86937 13.332 7.56506 13.332 9.33317V13.3332H9.33203V18.6665H13.332V29.3332H18.6654V18.6665H22.6654L23.9987 13.3332H18.6654V9.33317C18.6654 8.97955 18.8058 8.64041 19.0559 8.39036C19.3059 8.14031 19.6451 7.99984 19.9987 7.99984H23.9987V2.6665Z",
            stroke: "#0F172A",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
/* harmony default export */ var facebook_social = (FacebookSocial);

;// CONCATENATED MODULE: ./components/share-icons/social-and-share-icon/linkedIn-social.tsx


var LinkedInSocial = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21.332 10.6665C23.4538 10.6665 25.4886 11.5094 26.9889 13.0096C28.4892 14.5099 29.332 16.5448 29.332 18.6665V27.9998H23.9987V18.6665C23.9987 17.9593 23.7177 17.281 23.2176 16.7809C22.7176 16.2808 22.0393 15.9998 21.332 15.9998C20.6248 15.9998 19.9465 16.2808 19.4464 16.7809C18.9463 17.281 18.6654 17.9593 18.6654 18.6665V27.9998H13.332V18.6665C13.332 16.5448 14.1749 14.5099 15.6752 13.0096C17.1755 11.5094 19.2103 10.6665 21.332 10.6665V10.6665Z",
                stroke: "#0F172A",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.0013 12H2.66797V28H8.0013V12Z",
                stroke: "#0F172A",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.33464 7.99984C6.80739 7.99984 8.0013 6.80593 8.0013 5.33317C8.0013 3.86041 6.80739 2.6665 5.33464 2.6665C3.86188 2.6665 2.66797 3.86041 2.66797 5.33317C2.66797 6.80593 3.86188 7.99984 5.33464 7.99984Z",
                stroke: "#0F172A",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ var linkedIn_social = (LinkedInSocial);

;// CONCATENATED MODULE: ./components/share-icons/social-and-share-icon/three-dot.tsx

var ThreeDot = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6 19C7.65685 19 9 17.6569 9 16C9 14.3431 7.65685 13 6 13C4.34315 13 3 14.3431 3 16C3 17.6569 4.34315 19 6 19Z",
                stroke: "#0F172A",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16 19C17.6569 19 19 17.6569 19 16C19 14.3431 17.6569 13 16 13C14.3431 13 13 14.3431 13 16C13 17.6569 14.3431 19 16 19Z",
                stroke: "#0F172A",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M26 19C27.6569 19 29 17.6569 29 16C29 14.3431 27.6569 13 26 13C24.3431 13 23 14.3431 23 16C23 17.6569 24.3431 19 26 19Z",
                stroke: "#0F172A",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ var three_dot = (ThreeDot);

;// CONCATENATED MODULE: ./components/share-icons/social-and-share-icon/twitter-social.tsx


var TwitterSocial = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M30.6654 4.00022C29.3885 4.90086 27.9748 5.5897 26.4787 6.04022C25.6757 5.11691 24.6085 4.46248 23.4214 4.16546C22.2343 3.86844 20.9847 3.94315 19.8415 4.3795C18.6983 4.81584 17.7166 5.59276 17.0293 6.60518C16.3421 7.6176 15.9823 8.81667 15.9987 10.0402V11.3736C13.6555 11.4343 11.3337 10.9146 9.24004 9.86082C7.14636 8.807 5.34579 7.25174 3.9987 5.33356C3.9987 5.33356 -1.33464 17.3336 10.6654 22.6669C7.9194 24.5308 4.64824 25.4655 1.33203 25.3336C13.332 32.0002 27.9987 25.3336 27.9987 10.0002C27.9975 9.62883 27.9618 9.25835 27.892 8.89356C29.2528 7.55155 30.2131 5.85717 30.6654 4.00022V4.00022Z",
            stroke: "#0F172A",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
/* harmony default export */ var twitter_social = (TwitterSocial);

;// CONCATENATED MODULE: ./components/share-icons/share-icons.tsx











var socialAndShares = [
    {
        type: "facebook",
        urlShare: "",
        compShare: /*#__PURE__*/ (0,jsx_runtime.jsx)(facebook_social, {})
    },
    {
        type: "twitter",
        urlShare: "",
        compShare: /*#__PURE__*/ (0,jsx_runtime.jsx)(twitter_social, {})
    },
    {
        type: "linkedIn",
        urlShare: "",
        compShare: /*#__PURE__*/ (0,jsx_runtime.jsx)(linkedIn_social, {})
    },
    {
        type: "copy",
        urlShare: "",
        compShare: /*#__PURE__*/ (0,jsx_runtime.jsx)(three_dot, {})
    }, 
];
var ShareIcons = function(props) {
    var shareUrl = props.shareUrl, vertical = props.vertical;
    var ref = (0,react.useState)(false), isCopied = ref[0], setIsCopied = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((share_icons_module_default()).container, (0,_define_property/* default */.Z)({}, (share_icons_module_default()).vertical, vertical)),
        children: (socialAndShares || []).map(function(item) {
            var linkShare = getUrlShare(item.type, item.urlShare || shareUrl);
            if (item.type === "copy") {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
                    text: linkShare,
                    onCopy: function() {
                        setIsCopied(true);
                        setTimeout(function() {
                            setIsCopied(false);
                        }, 3000);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (share_icons_module_default()).socialAndShareLink,
                        children: [
                            item.compShare,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (share_icons_module_default()).socialAndShareTooltip,
                                children: isCopied ? "Copied" : getTooltipMessage(item.type)
                            })
                        ]
                    }, item.type)
                }, item.type);
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (share_icons_module_default()).socialAndShareLink,
                onClick: function() {
                    handlePopupCenter({
                        url: linkShare,
                        title: getTooltipMessage(item.type),
                        popupWidth: 400,
                        popupHeight: 300
                    });
                },
                children: [
                    item.compShare,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (share_icons_module_default()).socialAndShareTooltip,
                        children: getTooltipMessage(item.type)
                    })
                ]
            }, item.type);
        })
    });
};
/* harmony default export */ var share_icons = (ShareIcons);


/***/ }),

/***/ 9438:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(253);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(315);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2991);
/* harmony import */ var _text_skeleton_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7838);
/* harmony import */ var _text_skeleton_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_text_skeleton_module_scss__WEBPACK_IMPORTED_MODULE_4__);





var TextSkeleton = function(props) {
    var _size = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props.size, 2), widthText = _size[0], heightText = _size[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_text_skeleton_module_scss__WEBPACK_IMPORTED_MODULE_4___default().textSkeleton), props.className),
        style: {
            height: heightText,
            width: widthText
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TextSkeleton);


/***/ }),

/***/ 1390:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ getPlaceholderBuilderImage; },
/* harmony export */   "b": function() { return /* binding */ getResizedBuilderImage; }
/* harmony export */ });
var getResizedBuilderImage = function(source, parameters) {
    if (source && source.startsWith("https://cdn.builder.io/api/v1/image/")) {
        var queryArray = [];
        if (parameters) {
            var _quality;
            parameters.quality = (_quality = parameters.quality) !== null && _quality !== void 0 ? _quality : 85;
            parameters.format = "webp";
            var parameterKeys = Object.keys(parameters);
            parameterKeys.forEach(function(paramKey) {
                var paramValue = parameters[paramKey];
                if (paramValue) {
                    queryArray.push("".concat(paramKey, "=").concat(paramValue));
                }
            });
        }
        return "".concat(source, "?").concat(queryArray.join("&"));
    }
    return source;
};
var getPlaceholderBuilderImage = function(source) {
    return getResizedBuilderImage(source, {
        width: 1,
        height: 1
    });
};


/***/ }),

/***/ 6447:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ formatDate; }
/* harmony export */ });
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6612);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_0__);

var formatDate = function(timeInMillisecond) {
    return timeInMillisecond ? dayjs__WEBPACK_IMPORTED_MODULE_0___default()(new Date(timeInMillisecond)).format("MMMM D, YYYY") : "";
};


/***/ }),

/***/ 5173:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ useWindowSize; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2991);

function useWindowSize() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        width: undefined,
        height: undefined
    }), windowSize = ref[0], setWindowSize = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var handleResize = function handleResize() {
            var ref, ref1, ref2, ref3;
            setWindowSize({
                width: (document === null || document === void 0 ? void 0 : (ref = document.documentElement) === null || ref === void 0 ? void 0 : ref.clientWidth) || (document === null || document === void 0 ? void 0 : (ref1 = document.body) === null || ref1 === void 0 ? void 0 : ref1.clientWidth) || (window === null || window === void 0 ? void 0 : window.innerWidth),
                height: (document === null || document === void 0 ? void 0 : (ref2 = document.documentElement) === null || ref2 === void 0 ? void 0 : ref2.clientHeight) || (document === null || document === void 0 ? void 0 : (ref3 = document.body) === null || ref3 === void 0 ? void 0 : ref3.clientHeight) || (window === null || window === void 0 ? void 0 : window.innerHeight)
            });
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return function() {
            return window.removeEventListener("resize", handleResize);
        };
    }, []);
    return windowSize;
}


/***/ }),

/***/ 6069:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ models_ArticleModel; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(1438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(8029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(460);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(9113);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./shared/constant.ts
var constant = __webpack_require__(2405);
// EXTERNAL MODULE: ./models/BaseModel.ts
var BaseModel = __webpack_require__(8345);
;// CONCATENATED MODULE: ./models/CategoryModel.ts




var CategoryModel = /*#__PURE__*/ function(BaseModel) {
    "use strict";
    (0,_inherits/* default */.Z)(CategoryModel, BaseModel);
    var _super = (0,_create_super/* default */.Z)(CategoryModel);
    function CategoryModel() {
        (0,_class_call_check/* default */.Z)(this, CategoryModel);
        var _this;
        _this = _super.call(this, {
            modelName: "category"
        });
        _this.fromBuilderContent = function(object) {
            if (!object) {
                return {
                    id: "",
                    name: "",
                    longName: null,
                    description: "",
                    image: "",
                    lastUpdated: ""
                };
            }
            var name;
            var category = object;
            if (object.data === undefined) {
                var _name;
                name = (_name = object.name) !== null && _name !== void 0 ? _name : "";
            } else {
                category = object.data;
                var _name1;
                name = (_name1 = object.name) !== null && _name1 !== void 0 ? _name1 : object.data.name;
            }
            var _longName;
            return {
                id: object.id,
                name: name,
                longName: (_longName = category.longName) !== null && _longName !== void 0 ? _longName : null,
                description: category.description || "",
                image: category.image || "",
                lastUpdated: object.lastUpdated || ""
            };
        };
        _this.fromListBuilderContent = function(objects) {
            return objects.map(_this.fromBuilderContent);
        };
        return _this;
    }
    return CategoryModel;
}(BaseModel/* default */.Z);
/* harmony default export */ var models_CategoryModel = (new CategoryModel());

;// CONCATENATED MODULE: ./models/ArticleModel.ts









var ArticleModel = /*#__PURE__*/ function(BaseModel) {
    "use strict";
    (0,_inherits/* default */.Z)(ArticleModel, BaseModel);
    var _super = (0,_create_super/* default */.Z)(ArticleModel);
    function ArticleModel() {
        (0,_class_call_check/* default */.Z)(this, ArticleModel);
        var _this;
        _this = _super.call(this, {
            modelName: "article"
        });
        _this.convertBuilderURL2Slug = function(url) {
            if (!url) return null;
            var ref;
            return "".concat(constant/* BLOG_HOME_PAGE */.a).concat((ref = url.replace(/^(\/article|\/builder-preview)/, "")) !== null && ref !== void 0 ? ref : "");
        };
        _this.convertSlug2BuilderURL = function(slug) {
            if (!slug) return null;
            return "/article".concat("/".concat(slug).replace(constant/* BLOG_HOME_PAGE */.a, ""));
        };
        _this.fromBuilderContent = function(object) {
            var ref, ref1, ref2;
            var oData = object === null || object === void 0 ? void 0 : object.data;
            var categories = (oData === null || oData === void 0 ? void 0 : (ref = oData.categories) === null || ref === void 0 ? void 0 : ref.map(function(cate) {
                return models_CategoryModel.fromBuilderContent(cate.category.value);
            })) || [];
            var author = oData === null || oData === void 0 ? void 0 : (ref1 = oData.author) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.value) === null || ref2 === void 0 ? void 0 : ref2.data;
            var articleSlug = _this.convertBuilderURL2Slug(oData === null || oData === void 0 ? void 0 : oData.url) || "";
            var ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21;
            return {
                id: (ref3 = object === null || object === void 0 ? void 0 : object.id) !== null && ref3 !== void 0 ? ref3 : null,
                title: (ref4 = oData === null || oData === void 0 ? void 0 : oData.title) !== null && ref4 !== void 0 ? ref4 : "",
                description: (ref5 = oData === null || oData === void 0 ? void 0 : oData.description) !== null && ref5 !== void 0 ? ref5 : "",
                summary: (ref6 = oData === null || oData === void 0 ? void 0 : oData.summary) !== null && ref6 !== void 0 ? ref6 : "",
                categories: categories,
                author: author !== null && author !== void 0 ? author : null,
                keywords: (ref7 = oData === null || oData === void 0 ? void 0 : oData.keywords) !== null && ref7 !== void 0 ? ref7 : "",
                backgroundColor: (ref8 = oData === null || oData === void 0 ? void 0 : oData.backgroundColor) !== null && ref8 !== void 0 ? ref8 : null,
                leadImage: (ref9 = oData === null || oData === void 0 ? void 0 : oData.leadImage) !== null && ref9 !== void 0 ? ref9 : null,
                leadPortraitImage: (ref10 = oData === null || oData === void 0 ? void 0 : oData.leadPortraitImage) !== null && ref10 !== void 0 ? ref10 : null,
                url: articleSlug !== null && articleSlug !== void 0 ? articleSlug : "",
                priority: (ref11 = oData === null || oData === void 0 ? void 0 : oData.priority) !== null && ref11 !== void 0 ? ref11 : 0,
                builderModel: object !== null && object !== void 0 ? object : null,
                seoTitle: (ref13 = (ref12 = oData === null || oData === void 0 ? void 0 : oData.seoTitle) !== null && ref12 !== void 0 ? ref12 : oData === null || oData === void 0 ? void 0 : oData.title) !== null && ref13 !== void 0 ? ref13 : "",
                seoDescription: (ref15 = (ref14 = oData === null || oData === void 0 ? void 0 : oData.seoDescription) !== null && ref14 !== void 0 ? ref14 : oData === null || oData === void 0 ? void 0 : oData.description) !== null && ref15 !== void 0 ? ref15 : "",
                lastUpdated: (ref16 = object === null || object === void 0 ? void 0 : object.lastUpdated) !== null && ref16 !== void 0 ? ref16 : null,
                createdDate: (ref17 = object === null || object === void 0 ? void 0 : object.createdDate) !== null && ref17 !== void 0 ? ref17 : null,
                firstPublished: (ref18 = object === null || object === void 0 ? void 0 : object.firstPublished) !== null && ref18 !== void 0 ? ref18 : null,
                readingTime: (ref19 = oData === null || oData === void 0 ? void 0 : oData.readingTime) !== null && ref19 !== void 0 ? ref19 : null,
                theme: (ref20 = oData === null || oData === void 0 ? void 0 : oData.theme) !== null && ref20 !== void 0 ? ref20 : null,
                schemas: (ref21 = oData === null || oData === void 0 ? void 0 : oData.schemas) !== null && ref21 !== void 0 ? ref21 : null
            };
        };
        var _this1 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.fromBuilderReference = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(articles) {
                var articleIds, updatedArticles;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (articles) {
                                _ctx.next = 2;
                                break;
                            }
                            return _ctx.abrupt("return", []);
                        case 2:
                            articleIds = articles.filter(function(a) {
                                var ref;
                                return (ref = a.article) === null || ref === void 0 ? void 0 : ref.id;
                            }).map(function(a) {
                                var ref;
                                return (ref = a.article) === null || ref === void 0 ? void 0 : ref.id;
                            });
                            _ctx.t0 = _this1;
                            _ctx.next = 6;
                            return _this1.findByIds(articleIds);
                        case 6:
                            _ctx.t1 = _ctx.sent;
                            updatedArticles = _ctx.t0.fromListBuilderContent.call(_ctx.t0, _ctx.t1);
                            return _ctx.abrupt("return", updatedArticles.sort(function(a, b) {
                                var findIndex = function(article) {
                                    return articleIds.findIndex(function(id) {
                                        return id === article.id;
                                    });
                                };
                                return findIndex(a) - findIndex(b);
                            }));
                        case 9:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(articles) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.fromListBuilderContent = function(objects) {
            return objects.map(_this.fromBuilderContent);
        };
        var _this2 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.getAllArticles = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var includeUnpublished, includeDraft, fields, draft, articles, _args = arguments;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        includeUnpublished = _args.length > 0 && _args[0] !== void 0 ? _args[0] : false, includeDraft = _args.length > 1 && _args[1] !== void 0 ? _args[1] : false, fields = _args.length > 2 ? _args[2] : void 0;
                        draft = includeDraft !== null && includeDraft !== void 0 ? includeDraft : "draft";
                        _ctx.next = 4;
                        return _this2.builder.getAll(_this2.modelName, {
                            options: {
                                noTargeting: true,
                                includeUnpublished: includeUnpublished,
                                enrich: true
                            },
                            query: {
                                published: {
                                    $ni: [
                                        "archived",
                                        draft
                                    ]
                                }
                            },
                            fields: fields
                        });
                    case 4:
                        articles = _ctx.sent;
                        return _ctx.abrupt("return", articles);
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        var _this3 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.findArticle = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(filter) {
                var ref;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ;
                            if ((ref = filter.params) === null || ref === void 0 ? void 0 : ref.url) {
                                filter.params.url = _this3.convertSlug2BuilderURL(filter.params.url) || undefined;
                            }
                            return _ctx.abrupt("return", _this3.find(filter));
                        case 3:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(filter) {
                return _ref.apply(this, arguments);
            };
        }();
        return _this;
    }
    return ArticleModel;
}(BaseModel/* default */.Z);
/* harmony default export */ var models_ArticleModel = (new ArticleModel());


/***/ }),

/***/ 2405:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ BLOG_HOME_PAGE; }
/* harmony export */ });
/* unused harmony export HOME_PAGE_NAME */
var BLOG_HOME_PAGE = "/blog";
var HOME_PAGE_NAME = "home";


/***/ }),

/***/ 9209:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ BUILDER_MODEL; }
/* harmony export */ });
var BUILDER_MODEL;
(function(BUILDER_MODEL) {
    BUILDER_MODEL["ARTICLE"] = "article";
    BUILDER_MODEL["ARTICLE_AUTHOR"] = "article-author";
    BUILDER_MODEL["PAGE"] = "page";
    BUILDER_MODEL["CATEGORY"] = "category";
})(BUILDER_MODEL || (BUILDER_MODEL = {}));


/***/ }),

/***/ 5359:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$$": function() { return /* binding */ getRelatedArticle; },
/* harmony export */   "L9": function() { return /* binding */ getFeaturedArticles; },
/* harmony export */   "XC": function() { return /* binding */ getNextArticle; },
/* harmony export */   "ZU": function() { return /* binding */ getItemsPerPage; },
/* harmony export */   "_p": function() { return /* binding */ getMoreArticles; },
/* harmony export */   "np": function() { return /* binding */ getHighlightArticle; },
/* harmony export */   "xM": function() { return /* binding */ getHeroArticles; }
/* harmony export */ });
/* unused harmony exports getLatestArticle, getArticle, getArticleById */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(253);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9113);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _models_ArticleModel__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6069);





var getHeroArticles = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var builderContent;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return _models_ArticleModel__WEBPACK_IMPORTED_MODULE_1__/* ["default"].findAll */ .Z.findAll({
                        filters: {
                            offset: 0,
                            limit: 4
                        },
                        includeUnpublished: false,
                        enrich: true
                    });
                case 2:
                    builderContent = _ctx.sent;
                    return _ctx.abrupt("return", _models_ArticleModel__WEBPACK_IMPORTED_MODULE_1__/* ["default"].fromListBuilderContent */ .Z.fromListBuilderContent(builderContent));
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getHeroArticles() {
        return _ref.apply(this, arguments);
    };
}();
var getLatestArticle = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var ref, article;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.t0 = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z;
                    _ctx.next = 3;
                    return _models_ArticleModel__WEBPACK_IMPORTED_MODULE_1__/* ["default"].findAll */ .Z.findAll({
                        filters: {
                            offset: 0,
                            limit: 1
                        }
                    });
                case 3:
                    _ctx.t1 = _ctx.sent;
                    ref = (0, _ctx.t0)(_ctx.t1, 1);
                    article = ref[0];
                    if (!article) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", _models_ArticleModel__WEBPACK_IMPORTED_MODULE_1__/* ["default"].fromBuilderContent */ .Z.fromBuilderContent(article));
                case 8:
                    return _ctx.abrupt("return", null);
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getLatestArticle() {
        return _ref.apply(this, arguments);
    };
}();
var getHighlightArticle = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(article) {
        var fixedArticle, ref;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    if (!(article === null || article === void 0 ? void 0 : article.id)) {
                        _ctx.next = 12;
                        break;
                    }
                    ;
                    _ctx.t0 = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z;
                    _ctx.next = 6;
                    return _models_ArticleModel__WEBPACK_IMPORTED_MODULE_1__/* ["default"].fromBuilderReference */ .Z.fromBuilderReference([
                        {
                            article: article
                        }
                    ]);
                case 6:
                    _ctx.t1 = _ctx.sent;
                    ref = (0, _ctx.t0)(_ctx.t1, 1);
                    fixedArticle = ref[0];
                    ref;
                    _ctx.next = 15;
                    break;
                case 12:
                    _ctx.next = 14;
                    return getLatestArticle();
                case 14:
                    fixedArticle = _ctx.sent;
                case 15:
                    return _ctx.abrupt("return", fixedArticle);
                case 16:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getHighlightArticle(article) {
        return _ref.apply(this, arguments);
    };
}();
var getNextArticle = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(article) {
        var nextArticle;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!article.id) {
                        _ctx.next = 6;
                        break;
                    }
                    _ctx.next = 3;
                    return _models_ArticleModel__WEBPACK_IMPORTED_MODULE_1__/* ["default"].findNextById */ .Z.findNextById(article.id, article === null || article === void 0 ? void 0 : article.createdDate);
                case 3:
                    nextArticle = _ctx.sent;
                    if (!nextArticle) {
                        _ctx.next = 6;
                        break;
                    }
                    return _ctx.abrupt("return", _models_ArticleModel__WEBPACK_IMPORTED_MODULE_1__/* ["default"].fromBuilderContent */ .Z.fromBuilderContent(nextArticle));
                case 6:
                    return _ctx.abrupt("return", null);
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getNextArticle(article) {
        return _ref.apply(this, arguments);
    };
}();
var getArticle = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(articleId) {
        var article;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return _models_ArticleModel__WEBPACK_IMPORTED_MODULE_1__/* ["default"].findArticle */ .Z.findArticle({
                        params: {
                            modelId: articleId
                        },
                        enrich: true
                    });
                case 2:
                    article = _ctx.sent;
                    if (!article) {
                        _ctx.next = 5;
                        break;
                    }
                    return _ctx.abrupt("return", _models_ArticleModel__WEBPACK_IMPORTED_MODULE_1__/* ["default"].fromBuilderContent */ .Z.fromBuilderContent(article));
                case 5:
                    return _ctx.abrupt("return", null);
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getArticle(articleId) {
        return _ref.apply(this, arguments);
    };
}();
var getRelatedArticle = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(article) {
        var ref, categoryFilter;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    categoryFilter = {};
                    if (((ref = article.categories) === null || ref === void 0 ? void 0 : ref.length) && article.categories.every(function(cate) {
                        return !!cate.id;
                    })) {
                        categoryFilter = {
                            "data.categories": {
                                $elemMatch: {
                                    "category.id": {
                                        $in: article.categories.map(function(param) {
                                            var id = param.id;
                                            return id;
                                        })
                                    }
                                }
                            }
                        };
                    }
                    _ctx.next = 5;
                    return _models_ArticleModel__WEBPACK_IMPORTED_MODULE_1__/* ["default"].findAll */ .Z.findAll({
                        sort: {
                            createdDate: -1
                        },
                        filters: {
                            limit: 3,
                            offset: 0,
                            extra: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                                id: {
                                    $ne: article.id
                                }
                            }, categoryFilter)
                        },
                        enrich: true
                    });
                case 5:
                    return _ctx.abrupt("return", _ctx.sent.map(_models_ArticleModel__WEBPACK_IMPORTED_MODULE_1__/* ["default"].fromBuilderContent */ .Z.fromBuilderContent));
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getRelatedArticle(article) {
        return _ref.apply(this, arguments);
    };
}();
var getFeaturedArticles = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(articles) {
        var fixedArticles;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    fixedArticles = [];
                    if (!((articles === null || articles === void 0 ? void 0 : articles.length) && (articles === null || articles === void 0 ? void 0 : articles.some(function(article) {
                        var ref;
                        return article === null || article === void 0 ? void 0 : (ref = article.article) === null || ref === void 0 ? void 0 : ref.id;
                    })))) {
                        _ctx.next = 7;
                        break;
                    }
                    _ctx.next = 4;
                    return _models_ArticleModel__WEBPACK_IMPORTED_MODULE_1__/* ["default"].fromBuilderReference */ .Z.fromBuilderReference(articles);
                case 4:
                    fixedArticles = _ctx.sent;
                    _ctx.next = 10;
                    break;
                case 7:
                    _ctx.next = 9;
                    return _models_ArticleModel__WEBPACK_IMPORTED_MODULE_1__/* ["default"].findAll */ .Z.findAll({
                        filters: {
                            offset: 4,
                            limit: 3
                        },
                        includeUnpublished: false,
                        enrich: true
                    });
                case 9:
                    fixedArticles = _ctx.sent.map(_models_ArticleModel__WEBPACK_IMPORTED_MODULE_1__/* ["default"].fromBuilderContent */ .Z.fromBuilderContent);
                case 10:
                    return _ctx.abrupt("return", fixedArticles);
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getFeaturedArticles(articles) {
        return _ref.apply(this, arguments);
    };
}();
var getMoreArticles = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(offset, itemsPerPage) {
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return _models_ArticleModel__WEBPACK_IMPORTED_MODULE_1__/* ["default"].findAll */ .Z.findAll({
                        filters: {
                            offset: offset,
                            limit: itemsPerPage
                        },
                        includeUnpublished: false,
                        sort: {
                            createdDate: -1
                        },
                        enrich: true
                    });
                case 2:
                    return _ctx.abrupt("return", _ctx.sent.map(_models_ArticleModel__WEBPACK_IMPORTED_MODULE_1__/* ["default"].fromBuilderContent */ .Z.fromBuilderContent));
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getMoreArticles(offset, itemsPerPage) {
        return _ref.apply(this, arguments);
    };
}();
var getItemsPerPage = function(rows, currentRow, template) {
    return Array(rows).fill(undefined).reduce(function(result, _, index) {
        var row = (index + currentRow) % template.length;
        return result += template[row].length;
    }, 0);
};
var getArticleById = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(articleId) {
        var article;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (articleId) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 2:
                    _ctx.next = 4;
                    return _models_ArticleModel__WEBPACK_IMPORTED_MODULE_1__/* ["default"].findArticle */ .Z.findArticle({
                        params: {
                            modelId: Array.isArray(articleId) ? articleId[0] : articleId
                        },
                        enrich: true
                    });
                case 4:
                    article = _ctx.sent;
                    return _ctx.abrupt("return", article);
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getArticleById(articleId) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 1756:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"btn":"button_btn__h5PrW","shadowNone":"button_shadowNone__JJfY_","btn-secondary":"button_btn-secondary__Bc58j","btn-highty":"button_btn-highty__1mTeH","btn-default":"button_btn-default__vNTaY","btn-small":"button_btn-small__5RuRL","btn-medium":"button_btn-medium__BivAG","btn-color-black":"button_btn-color-black__0471K","btn-color-white":"button_btn-color-white__1IMUH","btn-color-purple":"button_btn-color-purple__O4ZEs","btn-theme-black":"button_btn-theme-black__lbICV","btn-theme-transparent":"button_btn-theme-transparent__q3kHz","btn-theme-purple":"button_btn-theme-purple__XPfUM","btn-border-transparent":"button_btn-border-transparent__POEo1","btn-border-color":"button_btn-border-color__fxAdH"};

/***/ }),

/***/ 8178:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"article-card_root__Ob4kd","zoomedImageContainer":"article-card_zoomedImageContainer__us_5b","zoomedImage":"article-card_zoomedImage__WuaWq","link":"article-card_link__XjbYl","dark":"article-card_dark__PgtWK","category":"article-card_category__vVEIR","dotDivider":"article-card_dotDivider__7RAEo","date":"article-card_date__1HwWF","title":"article-card_title__3_Vcr","description":"article-card_description__9GS66","large":"article-card_large__tyR2F","main":"article-card_main__lA_ns","imageFullBleed":"article-card_imageFullBleed__ySQaU","content":"article-card_content__WaZsF","information":"article-card_information__p27E0"};

/***/ }),

/***/ 4908:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"articleGrid":"article-grid_articleGrid__h5gxn","articlesContainer":"article-grid_articlesContainer__0_Gqg","articleLarge":"article-grid_articleLarge__wKq6N","buttonLoadMore":"article-grid_buttonLoadMore__tOrmA","buttonLoadMoreContent":"article-grid_buttonLoadMoreContent__Clnq0","loading":"article-grid_loading__vRiUm","spinnerLoadMoreContainer":"article-grid_spinnerLoadMoreContainer__gnn_Q","spinnerLoadMore":"article-grid_spinnerLoadMore__tY_1b","loadMoreContainer":"article-grid_loadMoreContainer__V0lck"};

/***/ }),

/***/ 532:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"lazy-load-image_container__pu0oG","loading":"lazy-load-image_loading__OetB1","relative":"lazy-load-image_relative__Pt0V1"};

/***/ }),

/***/ 7716:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"loading_container__0H355","loaderText":"loading_loaderText__f0t5Y","loading-text":"loading_loading-text__nthjb"};

/***/ }),

/***/ 3773:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"gridGap":"image-grid_gridGap__P_Ege","squares":"image-grid_squares__xlcdr","row":"image-grid_row__vgIun","col":"image-grid_col__xRobQ","container":"image-grid_container__CC8a8","content":"image-grid_content__9L39u","wrapImg":"image-grid_wrapImg__O7N3b","row--1":"image-grid_row--1__Pn70d","row--2":"image-grid_row--2__V1p0e","row--3":"image-grid_row--3__pzq_T","row--3--1":"image-grid_row--3--1__vXGxW","maxHeight50":"image-grid_maxHeight50__kIgKW","squareContainer":"image-grid_squareContainer__Yxhr5","fillCyan":"image-grid_fillCyan__5KfhH","fillAztecPurple":"image-grid_fillAztecPurple__L3Xw5","fillWhite":"image-grid_fillWhite__dCpdh","mdHide":"image-grid_mdHide__Wuoke","mdShow":"image-grid_mdShow__CKHoC"};

/***/ }),

/***/ 5966:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"roomstay-blog-about-hero_container__0ymAy","background":"roomstay-blog-about-hero_background__Qk9p1","backgroundClipped":"roomstay-blog-about-hero_backgroundClipped__Fwv_C"};

/***/ }),

/***/ 3839:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"text-intro_container__wsyp7","title":"text-intro_title__UwZ2a","description":"text-intro_description__zpIKl"};

/***/ }),

/***/ 3715:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"roomstay-blog-all-articles_title__hC4aP","root":"roomstay-blog-all-articles_root__Nnql2"};

/***/ }),

/***/ 6984:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"zoomedImageContainer":"roomstay-blog-article-author_zoomedImageContainer__cXmk3","zoomedImage":"roomstay-blog-article-author_zoomedImage__7NTF8","avatar":"roomstay-blog-article-author_avatar__kPwyG","root":"roomstay-blog-article-author_root__bIv_V","dark":"roomstay-blog-article-author_dark__likOM","name":"roomstay-blog-article-author_name__ZT9Ek","jobTitle":"roomstay-blog-article-author_jobTitle___vUho","info":"roomstay-blog-article-author_info__Bd_mO"};

/***/ }),

/***/ 6033:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"article-card_root__JEShU","zoomedImageContainer":"article-card_zoomedImageContainer__nHMqf","zoomedImage":"article-card_zoomedImage__ZpbAH","link":"article-card_link__TRgzr","content":"article-card_content__EnZdD","title":"article-card_title__qnoUy","description":"article-card_description__AHRyt","btnLearnMore":"article-card_btnLearnMore__LMYK3","main":"article-card_main__tw0QA"};

/***/ }),

/***/ 5039:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"roomstay-blog-article-card_container__CoMT4","header":"roomstay-blog-article-card_header__c9mU8","wrapper":"roomstay-blog-article-card_wrapper__rQxYi"};

/***/ }),

/***/ 8086:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"roomstay-blog-article-text-list_container__Hryh4","shareIcons":"roomstay-blog-article-text-list_shareIcons__s5ZUS","content":"roomstay-blog-article-text-list_content__qmYNo","item":"roomstay-blog-article-text-list_item__7Zmdo","list":"roomstay-blog-article-text-list_list__wL0AI","arrow":"roomstay-blog-article-text-list_arrow__jwPDh"};

/***/ }),

/***/ 5027:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"article-carousel-item_container__TKQE2","info":"article-carousel-item_info__YOWXS","category":"article-carousel-item_category__tdWL7","title":"article-carousel-item_title__FyhxT","url":"article-carousel-item_url__8b1lR"};

/***/ }),

/***/ 1841:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"blog-home-hero-article-carousel_container__joya0","box":"blog-home-hero-article-carousel_box__6oVXz"};

/***/ }),

/***/ 5619:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"roomstay-blog-blog-hero_container__1INah","background":"roomstay-blog-blog-hero_background__Zmgq3","url":"roomstay-blog-blog-hero_url__tl_CD","content":"roomstay-blog-blog-hero_content__CICym","title":"roomstay-blog-blog-hero_title__BcN0h","arrow":"roomstay-blog-blog-hero_arrow____R_6","titleBox":"roomstay-blog-blog-hero_titleBox__MSmXZ","divider":"roomstay-blog-blog-hero_divider__suUfl"};

/***/ }),

/***/ 6710:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"roomstay-blog-card-pricing_container__Qk0jz","wrapperContent":"roomstay-blog-card-pricing_wrapperContent__qwNbH","gridContent":"roomstay-blog-card-pricing_gridContent__ugAL_","contentText":"roomstay-blog-card-pricing_contentText__cVvql","subTitle":"roomstay-blog-card-pricing_subTitle__tLoAz","title":"roomstay-blog-card-pricing_title__N2Phe","description":"roomstay-blog-card-pricing_description__t1oZU","contentForm":"roomstay-blog-card-pricing_contentForm__H4RG5","beFormGroup":"roomstay-blog-card-pricing_beFormGroup__qxJN2","helpdesk-form":"roomstay-blog-card-pricing_helpdesk-form___8zP7","margBottom":"roomstay-blog-card-pricing_margBottom__8ypLr","button":"roomstay-blog-card-pricing_button__RAvmx"};

/***/ }),

/***/ 5885:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"roomstay-blog-customer-case-accordion-2_container__TliDW","backgroundColor":"roomstay-blog-customer-case-accordion-2_backgroundColor__PhpI5","wrapperBox":"roomstay-blog-customer-case-accordion-2_wrapperBox__UkvEk","boxLeft":"roomstay-blog-customer-case-accordion-2_boxLeft__LLSpT","wrapperTag":"roomstay-blog-customer-case-accordion-2_wrapperTag__l7Qah","tag":"roomstay-blog-customer-case-accordion-2_tag__Teg5t","title":"roomstay-blog-customer-case-accordion-2_title__bLOv5","description":"roomstay-blog-customer-case-accordion-2_description__5qckP","button":"roomstay-blog-customer-case-accordion-2_button__N4__8","boxRight":"roomstay-blog-customer-case-accordion-2_boxRight__OGh93","boxCard":"roomstay-blog-customer-case-accordion-2_boxCard__O4uMH","wrapperCardContent":"roomstay-blog-customer-case-accordion-2_wrapperCardContent__dk_ez","cardNumber":"roomstay-blog-customer-case-accordion-2_cardNumber__e6zRx","cardText":"roomstay-blog-customer-case-accordion-2_cardText__Z4Db3","cardTitle":"roomstay-blog-customer-case-accordion-2_cardTitle__qoxsx","cardDescription":"roomstay-blog-customer-case-accordion-2_cardDescription__pdpKE","cardDivider":"roomstay-blog-customer-case-accordion-2_cardDivider__xrW3Y","wrapperItem":"roomstay-blog-customer-case-accordion-2_wrapperItem__czKZL","wrapperHeader":"roomstay-blog-customer-case-accordion-2_wrapperHeader__gQvSx","headerLeft":"roomstay-blog-customer-case-accordion-2_headerLeft__Zf_t8","icon":"roomstay-blog-customer-case-accordion-2_icon__9yE6O","image":"roomstay-blog-customer-case-accordion-2_image__vYjn_","text":"roomstay-blog-customer-case-accordion-2_text__fYh6V","wrapperDescription":"roomstay-blog-customer-case-accordion-2_wrapperDescription__nA69Q","expanded":"roomstay-blog-customer-case-accordion-2_expanded__nGu0U","arrow":"roomstay-blog-customer-case-accordion-2_arrow__kJbPc","dividerAccordion":"roomstay-blog-customer-case-accordion-2_dividerAccordion__olFV6","background":"roomstay-blog-customer-case-accordion-2_background__Z80y7","backgroundClipped":"roomstay-blog-customer-case-accordion-2_backgroundClipped__XMnHm","backgroundBottom":"roomstay-blog-customer-case-accordion-2_backgroundBottom__xbQHR","backgroundBottomClipped":"roomstay-blog-customer-case-accordion-2_backgroundBottomClipped__8lmx_"};

/***/ }),

/***/ 4279:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"roomstay-blog-customer-case-accordion_container__s_gZh","wrapperBox":"roomstay-blog-customer-case-accordion_wrapperBox__JwjWh","boxLeft":"roomstay-blog-customer-case-accordion_boxLeft__kUFH0","wrapperTag":"roomstay-blog-customer-case-accordion_wrapperTag__2mC7J","tag":"roomstay-blog-customer-case-accordion_tag__yBRgs","title":"roomstay-blog-customer-case-accordion_title__UKvbg","description":"roomstay-blog-customer-case-accordion_description__y0qjw","subDescription":"roomstay-blog-customer-case-accordion_subDescription__L4VKJ","boxRight":"roomstay-blog-customer-case-accordion_boxRight__tJYeQ","boxOne":"roomstay-blog-customer-case-accordion_boxOne__oUv_n","wrapperItem":"roomstay-blog-customer-case-accordion_wrapperItem__cne8P","wrapperHeader":"roomstay-blog-customer-case-accordion_wrapperHeader__2nvnb","headerLeft":"roomstay-blog-customer-case-accordion_headerLeft__D92gE","icon":"roomstay-blog-customer-case-accordion_icon__5KZn0","image":"roomstay-blog-customer-case-accordion_image__dIGNu","text":"roomstay-blog-customer-case-accordion_text__dM4BH","wrapperDescription":"roomstay-blog-customer-case-accordion_wrapperDescription__SkyAZ","expanded":"roomstay-blog-customer-case-accordion_expanded__gUUN_","arrow":"roomstay-blog-customer-case-accordion_arrow__S48Md","button":"roomstay-blog-customer-case-accordion_button__PmkFz"};

/***/ }),

/***/ 1433:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"roomstay-blog-customer-case-block_container__axbD3","backgroundColor":"roomstay-blog-customer-case-block_backgroundColor__xzmo9","wrapperContent":"roomstay-blog-customer-case-block_wrapperContent__U5Eb8","wrapperAvatar":"roomstay-blog-customer-case-block_wrapperAvatar__AJ0dV","textMain":"roomstay-blog-customer-case-block_textMain__7XmrY","title":"roomstay-blog-customer-case-block_title__emu73","description":"roomstay-blog-customer-case-block_description___NRIY","wrapperImage":"roomstay-blog-customer-case-block_wrapperImage__XZn0A","image":"roomstay-blog-customer-case-block_image__PI5Rv","background":"roomstay-blog-customer-case-block_background__FVcc9","backgroundBottom":"roomstay-blog-customer-case-block_backgroundBottom__c920S"};

/***/ }),

/***/ 4981:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"roomstay-blog-customer-case-hero_container__rMq70","wrapperContent":"roomstay-blog-customer-case-hero_wrapperContent__m32kk","contentBoxLeft":"roomstay-blog-customer-case-hero_contentBoxLeft__mnICR","wrapperText":"roomstay-blog-customer-case-hero_wrapperText__81XRt","subTitle":"roomstay-blog-customer-case-hero_subTitle__TRo9l","title":"roomstay-blog-customer-case-hero_title__wmT08","description":"roomstay-blog-customer-case-hero_description__KaYLv","button":"roomstay-blog-customer-case-hero_button__eyje5","contentBoxRight":"roomstay-blog-customer-case-hero_contentBoxRight__zxrJW","img":"roomstay-blog-customer-case-hero_img___Vdi5","imageMobile":"roomstay-blog-customer-case-hero_imageMobile__oqgnn","imgMobile":"roomstay-blog-customer-case-hero_imgMobile__1sYtS","background":"roomstay-blog-customer-case-hero_background__1tjGf","backgroundClippedBottom":"roomstay-blog-customer-case-hero_backgroundClippedBottom___0mKX"};

/***/ }),

/***/ 580:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"roomstay-blog-customer-case-image_container__Sj_0g","wrapperImg":"roomstay-blog-customer-case-image_wrapperImg__IoE3_","background":"roomstay-blog-customer-case-image_background__WyYw0","backgroundClipped":"roomstay-blog-customer-case-image_backgroundClipped__MxLVU","backgroundBottom":"roomstay-blog-customer-case-image_backgroundBottom__D9HRX","backgroundBottomClipped":"roomstay-blog-customer-case-image_backgroundBottomClipped__jPfc3"};

/***/ }),

/***/ 7944:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"roomstay-blog-customer-case-list-card-2_container__dO0Hg","backgroundColor":"roomstay-blog-customer-case-list-card-2_backgroundColor__Ph5WH","wrapperTag":"roomstay-blog-customer-case-list-card-2_wrapperTag__8E_Tu","tag":"roomstay-blog-customer-case-list-card-2_tag__3dfHV","title":"roomstay-blog-customer-case-list-card-2_title__9bVoI","description":"roomstay-blog-customer-case-list-card-2_description__7RVLI","wrapperCard":"roomstay-blog-customer-case-list-card-2_wrapperCard__ZgQlO","box":"roomstay-blog-customer-case-list-card-2_box__nNKnK","item":"roomstay-blog-customer-case-list-card-2_item__kxPIP","icon":"roomstay-blog-customer-case-list-card-2_icon__sDmeI","wrapperImg":"roomstay-blog-customer-case-list-card-2_wrapperImg__skk5s","titleCard":"roomstay-blog-customer-case-list-card-2_titleCard__XgOUl","descriptionCard":"roomstay-blog-customer-case-list-card-2_descriptionCard__6_og2","button":"roomstay-blog-customer-case-list-card-2_button__SJDTc","backgroundClipped":"roomstay-blog-customer-case-list-card-2_backgroundClipped__yCQ6i","backgroundClippedClipped":"roomstay-blog-customer-case-list-card-2_backgroundClippedClipped__396BO","backgroundBottom":"roomstay-blog-customer-case-list-card-2_backgroundBottom__wxjN5","backgroundBottomClipped":"roomstay-blog-customer-case-list-card-2_backgroundBottomClipped__5kuhS"};

/***/ }),

/***/ 7665:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"roomstay-blog-customer-case-list-card_container__XYa6q","wrapperTag":"roomstay-blog-customer-case-list-card_wrapperTag__uGoKZ","tag":"roomstay-blog-customer-case-list-card_tag__UWur0","title":"roomstay-blog-customer-case-list-card_title__iAU8O","wrapperCard":"roomstay-blog-customer-case-list-card_wrapperCard__1DNBl","box":"roomstay-blog-customer-case-list-card_box__Wf_gu","item":"roomstay-blog-customer-case-list-card_item__HEU7T","number":"roomstay-blog-customer-case-list-card_number__lM_yn","number2":"roomstay-blog-customer-case-list-card_number2__eU8lB","subTitle":"roomstay-blog-customer-case-list-card_subTitle__dI5Ao","description":"roomstay-blog-customer-case-list-card_description__LhFV0","button":"roomstay-blog-customer-case-list-card_button__3kZbq","backgroundClipped":"roomstay-blog-customer-case-list-card_backgroundClipped__OGoxl","backgroundClippedClipped":"roomstay-blog-customer-case-list-card_backgroundClippedClipped__PoS81","backgroundBottom":"roomstay-blog-customer-case-list-card_backgroundBottom__CpYiU","backgroundBottomClipped":"roomstay-blog-customer-case-list-card_backgroundBottomClipped__5PYXr"};

/***/ }),

/***/ 7166:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mw100":"roomstay-blog-featured-card_mw100__z1ItI"};

/***/ }),

/***/ 1375:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"body":"roomstay-blog-footer-layout-2_body__rQ5AT","wrapper":"roomstay-blog-footer-layout-2_wrapper__bWpBm","increase":"roomstay-blog-footer-layout-2_increase__mSLrP","title":"roomstay-blog-footer-layout-2_title__r84Mx","description":"roomstay-blog-footer-layout-2_description__Q_v7z","mail":"roomstay-blog-footer-layout-2_mail__j5oio","wrapperText":"roomstay-blog-footer-layout-2_wrapperText__K6eDX"};

/***/ }),

/***/ 9486:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"body":"roomstay-blog-footer-layout-form_body__BUjlr","wrapper":"roomstay-blog-footer-layout-form_wrapper__V0p_z","wrapperText":"roomstay-blog-footer-layout-form_wrapperText__zk37q","divider":"roomstay-blog-footer-layout-form_divider__s8l86"};

/***/ }),

/***/ 9079:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"roomstay-blog-hero-pricing_container__PpA0P","wrapperContent":"roomstay-blog-hero-pricing_wrapperContent__f4Fhf","content":"roomstay-blog-hero-pricing_content__mSqnO","contentIntro":"roomstay-blog-hero-pricing_contentIntro__GTUlB","subTitle":"roomstay-blog-hero-pricing_subTitle__O38AI","title":"roomstay-blog-hero-pricing_title__91pyw","subDescription":"roomstay-blog-hero-pricing_subDescription__DcYd7","description":"roomstay-blog-hero-pricing_description__AFr9Y","background":"roomstay-blog-hero-pricing_background__tskgq","backgroundClipped":"roomstay-blog-hero-pricing_backgroundClipped__Z_s8h"};

/***/ }),

/***/ 7085:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"roomstay-blog-hero-product_container__8ZuwK","wrapperContainer":"roomstay-blog-hero-product_wrapperContainer__TLjMr","wrapperContent":"roomstay-blog-hero-product_wrapperContent__G0Jrq","contentLeft":"roomstay-blog-hero-product_contentLeft__CtK0G","wrapperImage":"roomstay-blog-hero-product_wrapperImage__uNDYa","contentText":"roomstay-blog-hero-product_contentText__S53Uv","subTitle":"roomstay-blog-hero-product_subTitle__eu7aN","title":"roomstay-blog-hero-product_title__OOzNn","button":"roomstay-blog-hero-product_button__sRm7M","content":"roomstay-blog-hero-product_content__wfYxU","background":"roomstay-blog-hero-product_background__BTTmY","backgroundClipped":"roomstay-blog-hero-product_backgroundClipped__qdU7x"};

/***/ }),

/***/ 5539:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"roomstay-blog-highlight-article_container__iVs5E","background":"roomstay-blog-highlight-article_background__l9Dze","mainBackground":"roomstay-blog-highlight-article_mainBackground__HHiIm","topBackground":"roomstay-blog-highlight-article_topBackground__jRyui","bottomBackground":"roomstay-blog-highlight-article_bottomBackground__iogC9","box":"roomstay-blog-highlight-article_box__tYj5D","left":"roomstay-blog-highlight-article_left__m32T0","image":"roomstay-blog-highlight-article_image__sb_Zi","right":"roomstay-blog-highlight-article_right__qHign","textCaption":"roomstay-blog-highlight-article_textCaption__mXuJf","arrow":"roomstay-blog-highlight-article_arrow__4ol_c","imageContainer":"roomstay-blog-highlight-article_imageContainer__AUp61","info":"roomstay-blog-highlight-article_info__8V_au","category":"roomstay-blog-highlight-article_category__Dpt8I","title":"roomstay-blog-highlight-article_title__s9k_z","author":"roomstay-blog-highlight-article_author__MtHDZ","avatarContainer":"roomstay-blog-highlight-article_avatarContainer__XvRZr","avatar":"roomstay-blog-highlight-article_avatar__nIX9y","name":"roomstay-blog-highlight-article_name__gHJpx","jobTitle":"roomstay-blog-highlight-article_jobTitle__bgcNz"};

/***/ }),

/***/ 1850:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"hotel-brand-item_container__SdpHP","logo":"hotel-brand-item_logo__o_VxZ","info":"hotel-brand-item_info__x_5XC","name":"hotel-brand-item_name__gdsfS","website":"hotel-brand-item_website__EHvTN"};

/***/ }),

/***/ 6871:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"roomstay-blog-hotel-brand-carousel_container__fLCjm","box":"roomstay-blog-hotel-brand-carousel_box__DnH1S"};

/***/ }),

/***/ 1237:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"roomstay-blog-image-block_root__VV5vc","noOverflow":"roomstay-blog-image-block_noOverflow__XNlid","container":"roomstay-blog-image-block_container__SgGtT","image":"roomstay-blog-image-block_image__0Xnp6","textItem":"roomstay-blog-image-block_textItem__DIyOh","imageItem":"roomstay-blog-image-block_imageItem__BUsOa","textBlock":"roomstay-blog-image-block_textBlock__mbWez","left":"roomstay-blog-image-block_left__lfIx0","fluid":"roomstay-blog-image-block_fluid__x_JEs","contentContainer":"roomstay-blog-image-block_contentContainer__rwL09","fullWidth":"roomstay-blog-image-block_fullWidth__mmXtq","background":"roomstay-blog-image-block_background__6nE3_"};

/***/ }),

/***/ 4174:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"roomstay-blog-image-grid_container__KlmTa","row":"roomstay-blog-image-grid_row___5XDL","wrap":"roomstay-blog-image-grid_wrap__OG7fZ","item":"roomstay-blog-image-grid_item__Aj3OC","image":"roomstay-blog-image-grid_image__fQPdh","hide":"roomstay-blog-image-grid_hide__AAXx2"};

/***/ }),

/***/ 343:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"roomstay-blog-use-case-img-clipped_container__o4LX5","wrapperImg":"roomstay-blog-use-case-img-clipped_wrapperImg__6kuWn","background":"roomstay-blog-use-case-img-clipped_background__nIV4l","backgroundClipped":"roomstay-blog-use-case-img-clipped_backgroundClipped__VaqHX","backgroundBottom":"roomstay-blog-use-case-img-clipped_backgroundBottom__97lTS","backgroundBottomClipped":"roomstay-blog-use-case-img-clipped_backgroundBottomClipped__ZgVMI"};

/***/ }),

/***/ 5721:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"roomstay-blog-increase_container__MN3Wq","title":"roomstay-blog-increase_title__R9yNR","booking":"roomstay-blog-increase_booking__w0h90","icon":"roomstay-blog-increase_icon__rIQM_","wrapper":"roomstay-blog-increase_wrapper__LcoE_","text":"roomstay-blog-increase_text__qryhq","inputText":"roomstay-blog-increase_inputText__hotTe","extra":"roomstay-blog-increase_extra__D22Ux","description":"roomstay-blog-increase_description__Bgwpv"};

/***/ }),

/***/ 6170:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"card_container__REOqr","card":"card_card__OJVMt","wrapLogo":"card_wrapLogo__eAq_r","box":"card_box__VYePU","title":"card_title__cNlj3","description":"card_description__1oCfk"};

/***/ }),

/***/ 3902:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"roomstay-blog-integrations_container__lzNYi","textContent":"roomstay-blog-integrations_textContent__7Bxvn","title":"roomstay-blog-integrations_title__6BJ_o","description":"roomstay-blog-integrations_description__5XIGR","cardContent":"roomstay-blog-integrations_cardContent__beP79","cards":"roomstay-blog-integrations_cards__JiN3B","background":"roomstay-blog-integrations_background__Bz9IF","backgroundClipped":"roomstay-blog-integrations_backgroundClipped__P86iZ"};

/***/ }),

/***/ 205:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"roomstay-blog-intro-revpar_container__bMTJ0","wrapper":"roomstay-blog-intro-revpar_wrapper__m5_fx","left":"roomstay-blog-intro-revpar_left__kJrdg","wrapperImg":"roomstay-blog-intro-revpar_wrapperImg__Ew2Rd","hideImage":"roomstay-blog-intro-revpar_hideImage__c9QKx","positionImg":"roomstay-blog-intro-revpar_positionImg__TG_3s","img":"roomstay-blog-intro-revpar_img__VJhP_","imageMobile":"roomstay-blog-intro-revpar_imageMobile__BSLYp","wrapperText":"roomstay-blog-intro-revpar_wrapperText__1pUiC","wrapperBox":"roomstay-blog-intro-revpar_wrapperBox__dIvjz","title":"roomstay-blog-intro-revpar_title__C_ru3","titleCenter":"roomstay-blog-intro-revpar_titleCenter__U10dt","titleMedium":"roomstay-blog-intro-revpar_titleMedium___4LBw","titleLarge":"roomstay-blog-intro-revpar_titleLarge__so_OZ","description":"roomstay-blog-intro-revpar_description__lMeeR"};

/***/ }),

/***/ 7302:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"roomstay-blog-list-card_container__8pdYk","card":"roomstay-blog-list-card_card__IecEc","title":"roomstay-blog-list-card_title__elckc","divider":"roomstay-blog-list-card_divider__hsSqr","description":"roomstay-blog-list-card_description__3I9Qv"};

/***/ }),

/***/ 8013:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"roomstay-blog-our-promise_container__uCA8J","title":"roomstay-blog-our-promise_title__6_Gzn","content":"roomstay-blog-our-promise_content__EGnq3","item":"roomstay-blog-our-promise_item__GN5di","icon":"roomstay-blog-our-promise_icon__i_uP0","text":"roomstay-blog-our-promise_text__msTXn"};

/***/ }),

/***/ 7706:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"unactive":"list-button_unactive__Dj7hO"};

/***/ }),

/***/ 6627:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"roomstay-blog-products-hero_container__c6AHF","listButton":"roomstay-blog-products-hero_listButton__2gmiy","background":"roomstay-blog-products-hero_background__aQiLr","backgroundClippedBottom":"roomstay-blog-products-hero_backgroundClippedBottom__wPkDs"};

/***/ }),

/***/ 6640:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"text-intro_container__B7yxL","title":"text-intro_title__Zrh4n","description":"text-intro_description__48E8V"};

/***/ }),

/***/ 5740:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"roomstay-blog-product-theme_container__yQ1PI","children":"roomstay-blog-product-theme_children__PB3cz","background":"roomstay-blog-product-theme_background__E7eBa","backgroundClippedBottom":"roomstay-blog-product-theme_backgroundClippedBottom__Jc2W_"};

/***/ }),

/***/ 4678:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"roomstay-blog-quote_container___s3nX","background":"roomstay-blog-quote_background__DQcbL","quoteMark":"roomstay-blog-quote_quoteMark__fOyEC","quoteContent":"roomstay-blog-quote_quoteContent___X_MJ","quote":"roomstay-blog-quote_quote__5DAWX","author":"roomstay-blog-quote_author__z8qv3","name":"roomstay-blog-quote_name__SyGpg","jobTitle":"roomstay-blog-quote_jobTitle__ARa5H"};

/***/ }),

/***/ 2804:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"roomstay-blog-revpar_container__90q1F","spaceDefault":"roomstay-blog-revpar_spaceDefault__LnlWW","methodOne":"roomstay-blog-revpar_methodOne__QclX_","title":"roomstay-blog-revpar_title__7bPu6","subTitle":"roomstay-blog-revpar_subTitle__80XVE","groupRevPar":"roomstay-blog-revpar_groupRevPar__ZONdI","wrapper":"roomstay-blog-revpar_wrapper__BhRjr","text":"roomstay-blog-revpar_text__2urTN","wrapperInput":"roomstay-blog-revpar_wrapperInput__s80Br","prefix":"roomstay-blog-revpar_prefix__yO8MP","input":"roomstay-blog-revpar_input__jXQ1E","totalRevPar":"roomstay-blog-revpar_totalRevPar___8AX3","number":"roomstay-blog-revpar_number__C53Jz","methodTow":"roomstay-blog-revpar_methodTow__RzXov"};

/***/ }),

/***/ 5421:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"centeredBody":"roomstay-blog-sem-helpdesk-form_centeredBody__FS_fT","centeredBody-padding-none":"roomstay-blog-sem-helpdesk-form_centeredBody-padding-none__ydKwE","container":"roomstay-blog-sem-helpdesk-form_container__pDzur","title-font-default":"roomstay-blog-sem-helpdesk-form_title-font-default__gQuJN","title-font-small":"roomstay-blog-sem-helpdesk-form_title-font-small__H_HM9","title":"roomstay-blog-sem-helpdesk-form_title__TLPEK","helpdeskInputs":"roomstay-blog-sem-helpdesk-form_helpdeskInputs__KpGBx","be-form-group":"roomstay-blog-sem-helpdesk-form_be-form-group__4Hi1e","margBottom":"roomstay-blog-sem-helpdesk-form_margBottom__0VYnM","button":"roomstay-blog-sem-helpdesk-form_button__XHkWN"};

/***/ }),

/***/ 4909:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"roomstay-blog-sem-hero_container__txCbI","wrapper":"roomstay-blog-sem-hero_wrapper__vLahp","image":"roomstay-blog-sem-hero_image__0z62d","content":"roomstay-blog-sem-hero_content__FGoyB","title":"roomstay-blog-sem-hero_title__bPio5","subTitle":"roomstay-blog-sem-hero_subTitle__MP68_","description":"roomstay-blog-sem-hero_description__1jetw","btn":"roomstay-blog-sem-hero_btn__I2zE6","wrapperForm":"roomstay-blog-sem-hero_wrapperForm__xH23W","background":"roomstay-blog-sem-hero_background__P0y1z","backgroundClippedBottom":"roomstay-blog-sem-hero_backgroundClippedBottom__0Zxj3"};

/***/ }),

/***/ 4724:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"roomstay-blog-sem-list-solution_container__umnjs","button":"roomstay-blog-sem-list-solution_button__3QT21","content":"roomstay-blog-sem-list-solution_content__Gb3wP","item":"roomstay-blog-sem-list-solution_item__POBhn","icon":"roomstay-blog-sem-list-solution_icon__TosO5","title":"roomstay-blog-sem-list-solution_title__MvsXQ","description":"roomstay-blog-sem-list-solution_description__m4etj"};

/***/ }),

/***/ 844:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"roomstay-blog-sem-list_container__9qslR","box":"roomstay-blog-sem-list_box__VDig2","bgShadowRight":"roomstay-blog-sem-list_bgShadowRight__hyfdG","bgShadowLeft":"roomstay-blog-sem-list_bgShadowLeft__TBZG8"};

/***/ }),

/***/ 3893:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"sem-card_container__xC05T","title":"sem-card_title__f1xgA","divider":"sem-card_divider__vSdoo","description":"sem-card_description__C1y5p","imageContainer":"sem-card_imageContainer__b_8wT"};

/***/ }),

/***/ 1725:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"roomstay-blog-sem-theme_container__ZBwUh","children":"roomstay-blog-sem-theme_children__Kb__a","background":"roomstay-blog-sem-theme_background__caluS","backgroundClippedBottom":"roomstay-blog-sem-theme_backgroundClippedBottom__Jk7Ja"};

/***/ }),

/***/ 6434:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"roomstay-blog-summing-up_container__EbZzh","summingUp":"roomstay-blog-summing-up_summingUp__xW6wG","items":"roomstay-blog-summing-up_items__BXlhg","item":"roomstay-blog-summing-up_item__K3BO8","number":"roomstay-blog-summing-up_number____kMc","content":"roomstay-blog-summing-up_content__Gd710","title":"roomstay-blog-summing-up_title__y04Cp","description":"roomstay-blog-summing-up_description__eXJh8"};

/***/ }),

/***/ 5905:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"roomstay-blog-text-booking_container__lWt4f","titleContainer":"roomstay-blog-text-booking_titleContainer__doDoP","title":"roomstay-blog-text-booking_title__6tK_p","titleDivider":"roomstay-blog-text-booking_titleDivider__eMAUh","description":"roomstay-blog-text-booking_description__s2cS9"};

/***/ }),

/***/ 2483:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"roomstay-blog-text-caption_container__d1vnC","textCaption":"roomstay-blog-text-caption_textCaption__z74fM"};

/***/ }),

/***/ 6806:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"roomstay-blog-text-footer_container__FzfwS","headText":"roomstay-blog-text-footer_headText__KWQmQ","subText":"roomstay-blog-text-footer_subText__d50ed"};

/***/ }),

/***/ 5951:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"roomstay-blog-text-intro-user_container__1t_tm","containerWrapper":"roomstay-blog-text-intro-user_containerWrapper__jyvts","containerWrapperTitle":"roomstay-blog-text-intro-user_containerWrapperTitle__ZBM1y","containerWrapperTitleText":"roomstay-blog-text-intro-user_containerWrapperTitleText__CLuOu","containerWrapperTitleDivider":"roomstay-blog-text-intro-user_containerWrapperTitleDivider__vljp_","containerSubTitle":"roomstay-blog-text-intro-user_containerSubTitle__S0L8R","containerDescription":"roomstay-blog-text-intro-user_containerDescription__dChS3"};

/***/ }),

/***/ 1368:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"roomstay-blog-text-synxis-booking_container__fH_vZ","titleContainer":"roomstay-blog-text-synxis-booking_titleContainer__sd_YD","title":"roomstay-blog-text-synxis-booking_title__9j2mC","titleDivider":"roomstay-blog-text-synxis-booking_titleDivider__DzF9D","description":"roomstay-blog-text-synxis-booking_description__etwoR"};

/***/ }),

/***/ 6383:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"roomstay-blog-text-wrap_root__u0zKv","background":"roomstay-blog-text-wrap_background__sm28F","noPadding":"roomstay-blog-text-wrap_noPadding__IqLMH","dark":"roomstay-blog-text-wrap_dark__X_sOO"};

/***/ }),

/***/ 1572:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"roomstay-blog-use-case-hero_container__4gBP3","wrapContainer":"roomstay-blog-use-case-hero_wrapContainer__AzQvC","wrapImg":"roomstay-blog-use-case-hero_wrapImg__JqPr1","img":"roomstay-blog-use-case-hero_img__0G2Vo","gridContent":"roomstay-blog-use-case-hero_gridContent__8Aflh","wrapContent":"roomstay-blog-use-case-hero_wrapContent__SETm3","heading":"roomstay-blog-use-case-hero_heading__GIV6O","title":"roomstay-blog-use-case-hero_title__9rWNw","description":"roomstay-blog-use-case-hero_description__g6Rjq","box":"roomstay-blog-use-case-hero_box___K4Zw","background":"roomstay-blog-use-case-hero_background__inSh1","backgroundClipped":"roomstay-blog-use-case-hero_backgroundClipped__EpHcQ"};

/***/ }),

/***/ 6321:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"roomstay-integration-module_container__8__7Q","left":"roomstay-integration-module_left__UnceG","headline":"roomstay-integration-module_headline__TeZgZ","title":"roomstay-integration-module_title__XyFsP","line":"roomstay-integration-module_line__F0SEB","description":"roomstay-integration-module_description__inedO","right":"roomstay-integration-module_right___f5xu","right-height-full":"roomstay-integration-module_right-height-full__gEnwV","image":"roomstay-integration-module_image__d6512"};

/***/ }),

/***/ 242:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"roomstay-members_container__jNb26","background":"roomstay-members_background__15Oec","backgroundClipped":"roomstay-members_backgroundClipped__iF_9p","intro":"roomstay-members_intro__tGN7y","heading":"roomstay-members_heading__2bKyL","divider":"roomstay-members_divider__XVq2M","title":"roomstay-members_title__jNN5o","description":"roomstay-members_description__U3P_S","memberContainer":"roomstay-members_memberContainer__jCf3q","member":"roomstay-members_member__WQ4gi","avatar":"roomstay-members_avatar__XRoNl","infoBlock":"roomstay-members_infoBlock__WIAZZ","name":"roomstay-members_name__3ng60","jobTitle":"roomstay-members_jobTitle__fwLbT"};

/***/ }),

/***/ 8619:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"roomstay-stats_container__g7I7m","content":"roomstay-stats_content__ycSoS","title":"roomstay-stats_title__yo4zJ","description":"roomstay-stats_description__e8mbP"};

/***/ }),

/***/ 9436:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"share-icons_container__nS631","socialAndShareLink":"share-icons_socialAndShareLink__LJy8q","socialAndShareTooltip":"share-icons_socialAndShareTooltip__9L0T5","vertical":"share-icons_vertical__RrDUu"};

/***/ }),

/***/ 3408:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"article-card-skeleton_skeleton__4MqeN"};

/***/ }),

/***/ 4998:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"articleGrid":"article-grid-skeleton_articleGrid__JSFII","articlesContainer":"article-grid-skeleton_articlesContainer__WC9HQ","articleLarge":"article-grid-skeleton_articleLarge__sf_tF","buttonLoadMore":"article-grid-skeleton_buttonLoadMore__Vdp2p","buttonLoadMoreContent":"article-grid-skeleton_buttonLoadMoreContent__kkogH","loading":"article-grid-skeleton_loading___iOS5","loaded":"article-grid-skeleton_loaded__pbWoo","spinnerLoadMore":"article-grid-skeleton_spinnerLoadMore__PJg7s","video-spin":"article-grid-skeleton_video-spin__i6Fgk","loadMoreContainer":"article-grid-skeleton_loadMoreContainer__jmI5R","skeleton":"article-grid-skeleton_skeleton__MQOU0","skeletonButtonContainer":"article-grid-skeleton_skeletonButtonContainer__gwT9t","skeletonButton":"article-grid-skeleton_skeletonButton__20Dvm"};

/***/ }),

/***/ 935:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"heroContainer":"home-hero-skeleton_heroContainer__A_okI","pageContainer":"home-hero-skeleton_pageContainer__cykmn","arrow":"home-hero-skeleton_arrow__3Uc_x","divider":"home-hero-skeleton_divider__jzosv","lineSkeleton":"home-hero-skeleton_lineSkeleton__PvviK","shimmer":"home-hero-skeleton_shimmer__AR_bC","slider":"home-hero-skeleton_slider__2IHBk","item":"home-hero-skeleton_item__XXc_w","dot":"home-hero-skeleton_dot__WVpMv","info":"home-hero-skeleton_info__qOKbU"};

/***/ }),

/***/ 7838:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"textSkeleton":"text-skeleton_textSkeleton__y1TwC","shimmer":"text-skeleton_shimmer__wO8sQ"};

/***/ })

}]);